(function () {
  function initProfilePage(root) {
    var sid = root.getAttribute('data-pp-sid');

  var LOCALE       = (root.dataset.locale || 'en').toLowerCase();
  var IS_TH        = LOCALE === 'th';
  var LOGIN_URL    = root.dataset.loginUrl;
  var PROFILE_URL  = root.dataset.profileUrl;
  var LOGOUT_URL   = root.dataset.logoutUrl || 'https://api.vitals.co.th/shopify/logout';
  var DELETE_URL   = root.dataset.deleteUrl || 'https://api.vitals.co.th/shopify/customer/delete';
  var METAFIELDS_URL = root.dataset.metafieldsUrl || 'https://api.vitals.co.th/shopify/customer/metafields';
  var SUPPORT_EMAIL = root.dataset.supportEmail || 'info@vitals.co.th';
  var WELLNESS_TEST_URL = root.dataset.wellnessTestUrl || '';
  var STORE_TOKEN    = '_vitals_at_v5';
  var STORE_CUSTOMER = '_vitals_customer_v5';
  var STORE_EXPERT   = '_vitals_expert_v5';

  // Storefront API (for wellness product recommendations)
  var storefrontToken = root.dataset.token;
  var apiVersion = root.dataset.version || '2024-01';
  var apiUrl = 'https://' + root.dataset.domain + '/api/' + apiVersion + '/graphql.json';
  // Namespace of the bundle metafields (quantity_per_pack, quantity_unit,
  // estimated_monthly_quantity, calculation_enabled). Admin-created definitions
  // land in `custom` by default; the section setting overrides it.
  var bundleMfNamespace = root.dataset.mfNs || 'custom';
  // Bundles at or above this total also offer "Pay in installments" (Omise, picked at checkout).
  var installmentMin = parseFloat(root.dataset.installmentMin) || 2000;

  // ── JWT / session helpers ───────────────────────────────
  function decodeJwtPayload(token) {
    if (!token) return null;
    var jwt = token.indexOf('shcat_') === 0 ? token.substring(6) : token;
    var parts = jwt.split('.');
    if (parts.length !== 3) return null;
    var b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) b64 += '=';
    try { return JSON.parse(atob(b64)); } catch (e) { return null; }
  }
  function getStoredToken() {
    try {
      var token = sessionStorage.getItem(STORE_TOKEN);
      if (!token) return null;
      var payload = decodeJwtPayload(token);
      if (!payload || !payload.exp || !payload.shopId) return null;
      var now = Math.floor(Date.now() / 1000);
      if (payload.exp - now < 30) { sessionStorage.removeItem(STORE_TOKEN); return null; }
      return { token: token, shopId: payload.shopId, exp: payload.exp };
    } catch (e) { return null; }
  }
  function setStoredAuth(token, customer, expertData) {
    try {
      sessionStorage.setItem(STORE_TOKEN, token);
      sessionStorage.setItem(STORE_CUSTOMER, JSON.stringify(customer));
      if (expertData) {
        sessionStorage.setItem(STORE_EXPERT, JSON.stringify(expertData));
      } else {
        sessionStorage.removeItem(STORE_EXPERT);
      }
    } catch (e) {}
  }
  function getStoredCustomer() {
    try { var raw = sessionStorage.getItem(STORE_CUSTOMER); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  }
  function getStoredExpert() {
    try { var raw = sessionStorage.getItem(STORE_EXPERT); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  }
  // Set by sign-out, cleared only by a fresh login hand-off. While it is set,
  // boot() goes straight to the sign-in view without asking the backend, so a
  // session the backend has not finished retiring cannot sign the user back in.
  var SIGNED_OUT_KEY = 'vitals_signed_out';
  function markSignedOut() {
    try { localStorage.setItem(SIGNED_OUT_KEY, '1'); } catch (_) {}
  }
  function isMarkedSignedOut() {
    try { return localStorage.getItem(SIGNED_OUT_KEY) === '1'; } catch (_) { return false; }
  }
  function clearSignedOutMark() {
    try { localStorage.removeItem(SIGNED_OUT_KEY); } catch (_) {}
  }

  function clearStoredAuth() {
    try {
      sessionStorage.removeItem(STORE_TOKEN);
      sessionStorage.removeItem(STORE_CUSTOMER);
      sessionStorage.removeItem(STORE_EXPERT);
    } catch (e) {}
  }

  // Expire a client-readable cookie across the paths/domains it may have been
  // set on. httpOnly cookies can't be touched here — those are the backend's job.
  function clearCookie(name) {
    try {
      var host = window.location.hostname;
      var domains = ['', host, '.' + host];
      // Also cover the registrable parent domain (e.g. .vitals.co.th) in case
      // the cookie was scoped there rather than to the exact host.
      var parts = host.split('.');
      if (parts.length > 2) domains.push('.' + parts.slice(-2).join('.'));
      var expired = '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      domains.forEach(function (d) {
        document.cookie = name + expired + (d ? '; domain=' + d : '');
      });
    } catch (_) {}
  }

  // ── normalize: flatten Customer Account API customer ────
  function normalizeCustomer(raw) {
    if (!raw) return null;
    var emailObj = raw.emailAddress || {};
    var phoneObj = raw.phoneNumber  || {};
    return {
      id:           raw.id || '',
      firstName:    raw.firstName || '',
      lastName:     raw.lastName  || '',
      first_name:   raw.firstName || '',
      last_name:    raw.lastName  || '',
      displayName:  raw.displayName || ((raw.firstName || '') + ' ' + (raw.lastName || '')).trim(),
      email:        emailObj.emailAddress || '',
      phone:        phoneObj.phoneNumber  || '',
      emailMarketingState: (emailObj.marketingState || '').toUpperCase() || null,
      imageUrl:     raw.imageUrl || '',
      // Accept multiple field-name shapes since the Vitals backend and the Customer Account API
      // use different keys for the same account-creation timestamp.
      creationDate: raw.creationDate || raw.createdAt || raw.created_at || raw.registeredAt || '',
      // Vitals-side profile fields. Not surfaced by Customer Account API —
      // we round-trip them via our own webhook payloads, so they only have
      // values once the user has saved them in this session.
      dateOfBirth:  raw.dateOfBirth || raw.birth_date || raw.birthDate || '',
      gender:       (raw.gender || '').toUpperCase(),
      defaultAddress: raw.defaultAddress || null,
      addresses:    (raw.addresses && raw.addresses.edges) ? raw.addresses.edges.map(function (e) { return e.node; }) : []
    };
  }

  // ── Backend bootstrap (returns customer + token) ────────
  function fetchProfileFromBackend() {
    console.log('[ProfilePage] GET', PROFILE_URL);
    // A sign-out that lands while this request is in flight bumps sessionEpoch.
    // Storing the response anyway re-cached the account the user just left, and
    // the next visit to the profile painted it straight from that cache.
    var epoch = sessionEpoch;
    return fetch(PROFILE_URL, {
      method: 'GET', credentials: 'include',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      console.log('[ProfilePage] /shopify/profile status:', r.status);
      if (r.status === 401 || r.status === 403) {
        var err = new Error('Not authenticated'); err.status = r.status; throw err;
      }
      if (!r.ok) throw new Error('Profile fetch HTTP ' + r.status);
      return r.json();
    }).then(function (json) {
      console.log('[ProfilePage] /shopify/profile response:', json);
      if (!json || !json.success || !json.data) throw new Error('Invalid /shopify/profile response shape');
      var data = json.data;
      if (!data.accessToken || !data.customer) throw new Error('/shopify/profile missing accessToken or customer');
      var normalized = normalizeCustomer(data.customer);
      // Accept both response shapes: flat (data.role / data.expert_id) and
      // nested (data.expert.role / data.expert.expert_id).
      var nestedExpert = data.expert || {};
      var role = data.role || nestedExpert.role || null;
      var expertId = data.expert_id || data.expertId || nestedExpert.expert_id || nestedExpert.expertId || '';
      var expertData = role ? { role: role, expert_id: expertId } : null;
      console.log('[ProfilePage] resolved expert:', expertData);
      if (epoch !== sessionEpoch) {
        var signedOut = new Error('Signed out while the profile was loading'); signedOut.status = 401; throw signedOut;
      }
      setStoredAuth(data.accessToken, normalized, expertData);
      return { token: data.accessToken, customer: normalized, expert: expertData };
    });
  }

  // ── Customer Account API client (per-shop endpoint via JWT shopId) ──
  function caApi(query, variables) {
    var stored = getStoredToken();
    if (!stored) return Promise.reject({ status: 401, message: 'No valid token' });
    var url = 'https://shopify.com/' + stored.shopId + '/account/customer/api/2024-10/graphql';
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', 'Accept': 'application/json',
        'Authorization': stored.token
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) {
      if (r.status === 401 || r.status === 403) {
        // Only tear down the session once we know the cache is current. Before
        // that, a 401/403 more likely means this request was scoped to the
        // previous account, and clearing here would take the real session with it.
        if (sessionVerified) clearStoredAuth();
        var err = new Error('Customer Account API unauthorized'); err.status = r.status; throw err;
      }
      if (!r.ok) throw new Error('Customer Account API HTTP ' + r.status);
      return r.json();
    }).then(function (json) {
      if (json && json.errors && json.errors.length) {
        console.error('[Customer API] GraphQL errors:', json.errors);
        throw new Error(json.errors.map(function (e) { return e.message; }).join('; '));
      }
      return json;
    });
  }

  // ── UI helpers ──────────────────────────────────────────
  function showView(name) {
    root.querySelectorAll('.pp-view').forEach(function (v) { v.style.display = 'none'; });
    var el = document.getElementById('pp-view-' + name + '-' + sid);
    if (el) el.style.display = name === 'signin' ? 'block' : 'block';
    // The expert dashboard runs full-bleed with its own gutters — drop the profile's centred
    // container for it, and restore it for every other view. See `.pp-expert-mode` in the section.
    root.classList.toggle('pp-expert-mode', name === 'expert');
  }
  // Swap the boot loading caption. Keeps the 2-10s profile fetch from reading as
  // a blank page, and signals the app hand-off when a deeplink is on its way.
  function setLoadingMsg(text) {
    var el = root.querySelector('[data-pp-loading-msg]');
    if (el && text) el.textContent = text;
  }
  function showTab(name) {
    root.querySelectorAll('.pp-sidebar__btn').forEach(function (t) { t.classList.toggle('is-active', t.dataset.ppTab === name); });
    root.querySelectorAll('.pp-tab-panel').forEach(function (p) { p.classList.toggle('is-active', p.id === 'pp-tab-' + name + '-' + sid); });
    if (name === 'orders')   renderOrders();
    if (name === 'wellness') renderWellness();
    if (name === 'bloodtest') renderBloodTests();
    if (name === 'appointments') renderAppointments();
    paintBundleTimers();
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (_) { window.scrollTo(0, 0); }
  }

  // Which tab to open on boot. The order confirmation email links to
  // /pages/profile?tab=orders so the buyer lands on the order they just placed instead of the
  // profile tab. Validated against the sidebar buttons that actually rendered — `bloodtest` is a
  // section setting and may be absent — so a stale or hand-typed tab falls back to profile.
  function tabFromUrl() {
    var name = '';
    try { name = new URLSearchParams(window.location.search).get('tab') || ''; } catch (_) { return 'profile'; }
    if (!/^[a-z]+$/.test(name)) return 'profile';
    return root.querySelector('.pp-sidebar__btn[data-pp-tab="' + name + '"]') ? name : 'profile';
  }

  var toastTimer = null;
  function toast(msg, type) {
    var el = document.getElementById('pp-toast-' + sid);
    if (!el) return;
    el.textContent = msg;
    el.className = 'pp-toast pp-toast--' + (type || 'success') + ' pp-show';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.className = 'pp-toast'; }, 3200);
  }
  function showErr(id, msg) {
    var el = document.getElementById(id + '-' + sid);
    if (!el) return; el.textContent = msg; el.classList.add('pp-show');
  }
  function clearErr(id) {
    var el = document.getElementById(id + '-' + sid);
    if (!el) return; el.textContent = ''; el.classList.remove('pp-show');
  }
  function busy(id, on) {
    var btn = document.getElementById(id + '-' + sid);
    if (!btn) return;
    btn.disabled = on;
    if (on) { btn.dataset.orig = btn.textContent; btn.textContent = '…'; }
    else    { btn.textContent = btn.dataset.orig || btn.textContent; }
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return c === '&' ? '&amp;' : c === '<' ? '&lt;' : c === '>' ? '&gt;' : c === '"' ? '&quot;' : '&#39;';
    });
  }

  // ── Customer state (used by wellness code) ──────────────
  var customer = null;
  var expert = null;
  // Bumped by resetSessionState() whenever the signed-in account changes. Async
  // work started under an older epoch must not write back into the new session.
  var sessionEpoch = 0;
  // False until revalidateSession() (or a fresh backend fetch) has confirmed who
  // the current session belongs to. While it is false the page may be painted
  // from an unchecked cache, so a 401/403 is not proof the session is dead — see
  // the note in caApi()/expertApi().
  var sessionVerified = false;
  var ordersCache = null;
  var ordersLoaded = false;
  var wellnessTestsCache = null;

  // ── Expert / telehealth state ───────────────────────────
  var TELEHEALTH_API = 'https://api.vitals.co.th';
  // Public NLM RxTerms drug lookup (no auth) — powers the medicine-name autocomplete.
  var RXTERMS_URL = 'https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search';
  var appointmentsCache = null;
  var patientsCache = null;
  var expertPanelsLoaded = { appointments: false, patients: false, schedule: false, profile: false };
  var currentExpertTab = 'dashboard';
  var openApptId = null;
  var openPatientId = null;
  var apptFilterStatus  = 'all'; // all | confirmed | rescheduled | completed | cancelled
  var apptSearchQuery   = '';

  function expertApi(path, opts) {
    opts = opts || {};
    var stored = getStoredToken();
    if (!stored) return Promise.reject({ status: 401, message: 'No valid token' });
    var url = TELEHEALTH_API + path;
    var init = {
      method: opts.method || 'GET',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + stored.token
      }
    };
    if (opts.body != null) {
      init.headers['Content-Type'] = 'application/json';
      init.body = typeof opts.body === 'string' ? opts.body : JSON.stringify(opts.body);
    }
    return fetch(url, init).then(function (r) {
      return r.text().then(function (txt) {
        var json = null;
        try { json = txt ? JSON.parse(txt) : null; } catch (_) {}
        if (!r.ok) {
          // See caApi(): an unverified session may legitimately 403 because the
          // cached role/expert_id belongs to the previous account.
          if (sessionVerified && (r.status === 401 || r.status === 403)) clearStoredAuth();
          var msg = (json && (json.message || json.error)) || ('HTTP ' + r.status);
          var err = new Error(msg); err.status = r.status; err.body = json;
          throw err;
        }
        return json;
      });
    });
  }

  // Deterministic avatar color from an identifier.
  function ddpAvatarClass(seed) {
    var colors = ['ddp-av-blue', 'ddp-av-green', 'ddp-av-amber', 'ddp-av-violet'];
    var s = String(seed || '');
    var h = 0;
    for (var i = 0; i < s.length; i++) { h = ((h << 5) - h + s.charCodeAt(i)) | 0; }
    return colors[Math.abs(h) % colors.length];
  }

  function ddpInitialsFromName(first, last) {
    var a = (first || '').trim().charAt(0);
    var b = (last  || '').trim().charAt(0);
    var out = (a + b).toUpperCase();
    return out || '—';
  }

  function ddpStatusTagClass(status) {
    var s = normalizeApptStatus(status);
    if (s === 'rescheduled') return 'ddp-tag--rescheduled';
    if (s === 'confirmed') return 'ddp-tag--confirmed';
    if (s === 'completed') return 'ddp-tag--completed';
    if (s === 'cancelled') return 'ddp-tag--cancelled';
    if (s === 'requested_cancellation') return 'ddp-tag--requested';
    return 'ddp-tag--default';
  }

  function ddpStatusLabel(status) {
    var s = normalizeApptStatus(status);
    if (s === 'requested_cancellation') return 'Cancellation requested';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function ddpEl(id) {
    return document.getElementById(id + '-' + sid);
  }

  function ddpParseDate(str) {
    if (!str) return null;
    var d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
  }

  function ddpIsToday(str) {
    var d = ddpParseDate(str);
    if (!d) return false;
    var now = new Date();
    return d.getFullYear() === now.getFullYear()
      && d.getMonth() === now.getMonth()
      && d.getDate() === now.getDate();
  }

  function ddpEscape(s) { return escapeHtml(s); }

  function initialFromName(name) {
    if (!name) return '—';
    var t = String(name).trim();
    return t ? t.charAt(0).toUpperCase() : '—';
  }

  function renderHeroBasics() {
    if (!customer) return;
    // Pick the most personal label we have: first name → full name → last name → email local part.
    var fullName = ((customer.firstName || '') + ' ' + (customer.lastName || '')).trim();
    var emailLocal = (customer.email || '').split('@')[0];
    var fname =
      customer.firstName ||
      customer.displayName ||
      fullName ||
      customer.lastName ||
      emailLocal ||
      (IS_TH ? 'สมาชิก' : 'member');
    document.getElementById('pp-welcome-' + sid).textContent =
      (IS_TH ? 'ยินดีต้อนรับกลับ, ' : 'Welcome back, ') + fname + '.';
    var avatar = document.getElementById('pp-avatar-' + sid);
    if (avatar) {
      if (customer.imageUrl) {
        avatar.textContent = '';
        avatar.style.backgroundImage = 'url("' + customer.imageUrl + '")';
      } else {
        avatar.style.backgroundImage = '';
        avatar.textContent = initialFromName(fname);
      }
    }
    var pill = document.getElementById('pp-member-pill-' + sid);
    if (pill) {
      var pillName = customer.displayName || fullName || customer.firstName || customer.lastName || emailLocal || '';
      pill.textContent = pillName || (IS_TH ? 'สมาชิก' : 'Member');
    }
  }

  function formatDOB(iso) {
    if (!iso) return '';
    // Accept either YYYY-MM-DD or full ISO; render in user's locale.
    var d = new Date(iso.length === 10 ? iso + 'T00:00:00' : iso);
    if (isNaN(d.getTime())) return iso;
    var locale = IS_TH ? 'th-TH' : 'en-GB';
    try { return d.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' }); }
    catch (_) { return iso; }
  }
  // Build <option> strings for a day / month / year birthdate picker.
  // Year labels show the Buddhist Era (B.E. = C.E. + 543) when the locale is
  // Thai, while the option VALUE stays Gregorian so stored dates are unchanged.
  function buildDobOptions() {
    var t = getWT();
    var currentYear = new Date().getFullYear();
    var monthOpts = '<option value="">' + t.month + '</option>' +
      ['01','02','03','04','05','06','07','08','09','10','11','12'].map(function (m, i) {
        return '<option value="' + m + '">' + t.months[i] + '</option>';
      }).join('');
    var dayOpts = '<option value="">' + t.day + '</option>' +
      Array.from({ length: 31 }, function (_, i) {
        var d = String(i + 1).padStart(2, '0');
        return '<option value="' + d + '">' + (i + 1) + '</option>';
      }).join('');
    var yearOpts = '<option value="">' + t.year + '</option>' +
      Array.from({ length: 101 }, function (_, i) {
        var y = String(currentYear - i);
        var label = IS_TH ? String(Number(y) + 543) : y;
        return '<option value="' + y + '">' + label + '</option>';
      }).join('');
    return { monthOpts: monthOpts, dayOpts: dayOpts, yearOpts: yearOpts };
  }
  function labelForGender(g) {
    var v = String(g || '').toUpperCase();
    if (v === 'MALE')    return IS_TH ? 'ชาย'   : 'Male';
    if (v === 'FEMALE')  return IS_TH ? 'หญิง'  : 'Female';
    if (v === 'OTHERS' || v === 'OTHER') return IS_TH ? 'อื่นๆ' : 'Others';
    return '';
  }

  function renderAccountView() {
    if (!customer) return;
    var name = ((customer.firstName || '') + ' ' + (customer.lastName || '')).trim() || customer.displayName || '—';
    document.getElementById('pp-acct-name-' + sid).textContent   = name;
    document.getElementById('pp-acct-email-' + sid).textContent  = customer.email || '—';
    document.getElementById('pp-acct-phone-' + sid).textContent  = customer.phone || '—';
    document.getElementById('pp-acct-dob-' + sid).textContent    = formatDOB(customer.dateOfBirth) || '—';
    document.getElementById('pp-acct-gender-' + sid).textContent = labelForGender(customer.gender) || '—';
  }
  function openAccountEdit() {
    document.getElementById('pp-acct-view-' + sid).style.display = 'none';
    document.getElementById('pp-acct-form-' + sid).style.display = 'block';
    document.getElementById('pp-prf-fname-' + sid).value  = customer.firstName || '';
    document.getElementById('pp-prf-lname-' + sid).value  = customer.lastName  || '';
    document.getElementById('pp-prf-phone-' + sid).value  = customer.phone || '';
    // Birthdate: day / month / year selects (Thai locale shows Buddhist Era
    // years). Value stored/read is always Gregorian YYYY-MM-DD.
    var dob  = (customer.dateOfBirth || '').slice(0, 10);
    var opts = buildDobOptions();
    var mSel = document.getElementById('pp-prf-dob-month-' + sid);
    var dSel = document.getElementById('pp-prf-dob-day-'   + sid);
    var ySel = document.getElementById('pp-prf-dob-year-'  + sid);
    if (mSel) mSel.innerHTML = opts.monthOpts;
    if (dSel) dSel.innerHTML = opts.dayOpts;
    if (ySel) ySel.innerHTML = opts.yearOpts;
    if (dob.length === 10) {
      var parts = dob.split('-');
      if (ySel) ySel.value = parts[0];
      if (mSel) mSel.value = parts[1];
      if (dSel) dSel.value = parts[2];
    }
    document.getElementById('pp-prf-gender-' + sid).value = (customer.gender || '').toUpperCase();
    clearErr('pp-profile-err');
  }
  function closeAccountEdit() {
    document.getElementById('pp-acct-view-' + sid).style.display = 'block';
    document.getElementById('pp-acct-form-' + sid).style.display = 'none';
  }

  function renderStatTiles() {
    var ordersCount = ordersCache ? ordersCache.length : null;
    document.getElementById('pp-tile-orders-' + sid).textContent = ordersCount == null ? '—' : ordersCount;
    document.getElementById('pp-tile-orders-sub-' + sid).textContent = '';
    var tests = wellnessTestsCache || [];
    var t = document.getElementById('pp-tile-wellness-' + sid);
    var ts = document.getElementById('pp-tile-wellness-sub-' + sid);
    if (tests.length) {
			if ((tests.filter(t => !!t.test_url)).length) {
				t.textContent = IS_TH ? 'พร้อมแล้ว' : 'Results ready';
				ts.textContent = (IS_TH ? 'อัปเดตล่าสุด ' : 'Updated ') + (tests[0].createdAt ? new Date(tests[0].createdAt).toLocaleDateString(IS_TH ? 'th-TH' : 'en-GB', { day: 'numeric', month: 'short' }) : '');
			} else {
				t.textContent = IS_TH ? 'ตรวจแล้ว' : 'Test taken';
				ts.textContent = '';
			}
    } else if (wellnessTestsCache !== null) {
      t.textContent = IS_TH ? 'ยังไม่ได้ตรวจ' : 'Not taken yet';
      ts.textContent = '';
    }
  }

  function renderHeroStatus() { /* hero status card removed — left as no-op so callers don't break */ }

  // Kit tier → display name + biomarker count. The list endpoint has spelled the
  // tier field several ways (`tier`, `test_type`, `testTypeName`, product title),
  // so read all of them. An unrecognised tier claims no biomarker count rather
  // than guessing — an Ultra kit was being labelled "Core Test · 100+ biomarkers".
  var WB_TIERS = [
    { match: 'ultra',   name: 'Ultra Test',    markers: '700+' },
    { match: 'advance', name: 'Advanced Test', markers: '400+' },
    { match: 'core',    name: 'Core Test',     markers: '100+' }
  ];
  function wellnessTier(test) {
    if (!test) return null;
    var raw = String(
      test.tier || test.test_type || test.testType || test.testTypeName ||
      test.test_type_name || test.productTitle || test.product_title ||
      test.packageName || test.package_name || test.name || ''
    ).toLowerCase();
    if (!raw) return null;
    for (var i = 0; i < WB_TIERS.length; i++) {
      if (raw.indexOf(WB_TIERS[i].match) !== -1) return WB_TIERS[i];
    }
    return null;
  }
  // Status shown when no report link exists yet — "Results ready" must not be
  // claimed before the PDF is actually there.
  function wellnessStatusLabel(test) {
    var st = String((test && test.status) || '').toLowerCase();
    if (st === 'cancelled' || st === 'canceled') return IS_TH ? 'ยกเลิกแล้ว' : 'Cancelled';
    if (st === 'processing' || st === 'completed') return IS_TH ? 'กำลังตรวจวิเคราะห์' : 'In the lab';
    return IS_TH ? 'ลงทะเบียนแล้ว' : 'Kit registered';
  }

  function renderWellnessBanner() {
    var cap   = document.getElementById('pp-wb-cap-' + sid);
    var title = document.getElementById('pp-wb-title-' + sid);
    var sub   = document.getElementById('pp-wb-sub-' + sid);
    var cta   = document.getElementById('pp-wb-cta-' + sid);
    var tests = wellnessTestsCache;
    if (!title || tests === null) return;
    // Hide Test history for non-test users; show it once any test exists.
    var hist = document.getElementById('pp-wellness-history-section-' + sid);
    if (hist) hist.style.display = tests.length ? '' : 'none';

    if (tests.length) {
      var latest = tests[0];
      var tier   = wellnessTier(latest);
      var ready  = !!(latest && latest.test_url);
      var tierName = tier ? tier.name : (IS_TH ? 'ชุดตรวจสุขภาพ' : 'Wellness Test');
      cap.textContent = tierName + ' · ' + (ready ? (IS_TH ? 'ผลพร้อมแล้ว' : 'Results ready') : wellnessStatusLabel(latest));
      title.textContent = ready
        ? (IS_TH ? 'สุขภาพของคุณ ถอดรหัสแล้ว' : 'Your Health, Decoded.')
        : (IS_TH ? 'ผลตรวจของคุณกำลังมา' : 'Your results are on the way.');
      var when = latest && latest.createdAt ? new Date(latest.createdAt).toLocaleDateString(IS_TH ? 'th-TH' : 'en-GB', { month: 'long', year: 'numeric' }) : '';
      var markers = tier
        ? (IS_TH ? tier.markers + ' ตัวชี้วัด' : tier.markers + ' biomarkers' + (ready ? ' analysed' : ''))
        : '';
      var whenTxt = when
        ? (ready ? (IS_TH ? 'อัปเดต ' : 'updated ') : (IS_TH ? 'ลงทะเบียนเมื่อ ' : 'registered ')) + when
        : '';
      sub.textContent = markers && whenTxt ? markers + ' · ' + whenTxt : (markers || whenTxt);
      if (ready) {
        cta.href = latest.test_url;
        cta.textContent = IS_TH ? 'เปิดรายงาน' : 'Open Full Report';
        cta.style.display = '';
      } else { cta.style.display = 'none'; }
    } else {
      cap.textContent = IS_TH ? 'เริ่มต้นวันนี้' : 'Start today';
      title.textContent = IS_TH ? 'ทำการตรวจสุขภาพครั้งแรก' : 'Take your first Wellness Test';
      sub.textContent = IS_TH ? 'รับข้อมูลเชิงลึกที่ใช้ออกแบบโปรแกรมเฉพาะคุณ' : 'Get the insights we use to design your personalised protocol.';
      if (WELLNESS_TEST_URL) {
        cta.href = WELLNESS_TEST_URL;
        cta.target = '_self';
        cta.textContent = IS_TH ? 'สั่งซื้อชุดตรวจ' : 'Order Test Kit';
        cta.style.display = '';
      } else { cta.style.display = 'none'; }
    }
  }

  // ── Marketing prefs toggle ──────────────────────────────
  // Customer Account API exposes subscribe/unsubscribe as two separate mutations (not a single consent-update),
  // unlike the Admin API. Both require the customer_write_customers scope, granted by a logged-in customer JWT.
  var Q_MARKETING_SUBSCRIBE =
    'mutation MktSubscribe {' +
      'customerEmailMarketingSubscribe {' +
        'emailAddress { emailAddress marketingState }' +
        'userErrors { field message code }' +
      '}' +
    '}';
  var Q_MARKETING_UNSUBSCRIBE =
    'mutation MktUnsubscribe {' +
      'customerEmailMarketingUnsubscribe {' +
        'emailAddress { emailAddress marketingState }' +
        'userErrors { field message code }' +
      '}' +
    '}';

  function renderMarketingToggle() {
    var btn = document.getElementById('pp-mkt-toggle-' + sid);
    if (!btn || !customer) return;
    var on = customer.emailMarketingState === 'SUBSCRIBED';
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.disabled = false;
  }
  function handleMarketingToggle() {
    var btn = document.getElementById('pp-mkt-toggle-' + sid);
    if (!btn || !customer) return;
    var wasOn = customer.emailMarketingState === 'SUBSCRIBED';
    var mutation = wasOn ? Q_MARKETING_UNSUBSCRIBE : Q_MARKETING_SUBSCRIBE;
    var responseKey = wasOn ? 'customerEmailMarketingUnsubscribe' : 'customerEmailMarketingSubscribe';
    btn.disabled = true;
    btn.classList.toggle('is-on', !wasOn);
    customer.emailMarketingState = wasOn ? 'NOT_SUBSCRIBED' : 'SUBSCRIBED';
    caApi(mutation, {})
      .then(function (resp) {
        var r = (resp.data && resp.data[responseKey]) || {};
        if (r.userErrors && r.userErrors.length) throw new Error(r.userErrors[0].message);
        var newState = r.emailAddress && r.emailAddress.marketingState;
        if (newState) {
          customer.emailMarketingState = String(newState).toUpperCase();
          renderMarketingToggle();
        }
        try { sessionStorage.setItem(STORE_CUSTOMER, JSON.stringify(customer)); } catch (_) {}
        toast(IS_TH ? 'บันทึกความต้องการแล้ว' : 'Preference saved', 'success');
      })
      .catch(function (err) {
        customer.emailMarketingState = wasOn ? 'SUBSCRIBED' : 'NOT_SUBSCRIBED';
        renderMarketingToggle();
        console.error('[marketing] update failed:', err);
        toast(IS_TH ? 'ไม่สามารถบันทึกได้' : 'Could not save preference', 'error');
      })
      .finally(function () { btn.disabled = false; });
  }

  // ── Addresses ───────────────────────────────────────────
  var Q_ADDRESS_CREATE =
    'mutation AddressCreate($a: CustomerAddressInput!, $d: Boolean!) {' +
      'customerAddressCreate(address: $a, defaultAddress: $d) {' +
        'customerAddress { id firstName lastName address1 address2 city province country zip phone: phoneNumber }' +
        'userErrors { field message }' +
      '}' +
    '}';
  var Q_ADDRESS_UPDATE =
    'mutation AddressUpdate($id: ID!, $a: CustomerAddressInput!, $d: Boolean!) {' +
      'customerAddressUpdate(addressId: $id, address: $a, defaultAddress: $d) {' +
        'customerAddress { id firstName lastName address1 address2 city province country zip phone: phoneNumber }' +
        'userErrors { field message }' +
      '}' +
    '}';
  var Q_ADDRESS_DELETE =
    'mutation AddressDelete($id: ID!) {' +
      'customerAddressDelete(addressId: $id) {' +
        'deletedAddressId' +
        'userErrors { field message }' +
      '}' +
    '}';

  // Map a free-text country to a Customer Account API CountryCode (territoryCode).
  // This is a Thailand-first store, so unknown/blank values fall back to "TH".
  var TERRITORY_CODES = {
    'thailand': 'TH', 'ไทย': 'TH', 'ประเทศไทย': 'TH', 'th': 'TH',
    'singapore': 'SG', 'malaysia': 'MY', 'united states': 'US', 'usa': 'US',
    'united kingdom': 'GB', 'uk': 'GB', 'australia': 'AU', 'japan': 'JP'
  };
  function toTerritoryCode(country) {
    var c = String(country || '').trim();
    if (!c) return 'TH';
    var mapped = TERRITORY_CODES[c.toLowerCase()];
    if (mapped) return mapped;
    if (/^[A-Za-z]{2}$/.test(c)) return c.toUpperCase();
    return 'TH';
  }

  // Convert the flat form/address shape (country/province/phone) into a valid
  // CustomerAddressInput (territoryCode/zoneCode/phoneNumber). Optional fields
  // are omitted when blank so we don't trip PHONE_NUMBER_NOT_VALID / ZONE_CODE.
  function toAddressInput(raw) {
    raw = raw || {};
    var out = {
      firstName: raw.firstName || '',
      lastName:  raw.lastName  || '',
      address1:  raw.address1   || '',
      address2:  raw.address2   || '',
      city:      raw.city       || '',
      zip:       raw.zip        || '',
      territoryCode: toTerritoryCode(raw.country)
    };
    var phone = String(raw.phone || '').trim();
    if (phone) out.phoneNumber = phone;
    // zoneCode expects a region CODE ("TH-20"), not a name like "Chon Buri" — and Thailand is a
    // country Shopify zones, so an address without one is rejected with "Zone code must exist".
    // Free text goes through the shared province table (vitals-thai-provinces.js), which also
    // absorbs the spellings buyers actually type ("Chonburi", "ชลบุรี", "Krung Thep").
    var zone = String(raw.province || '').trim();
    if (out.territoryCode === 'TH') {
      var thZone = window.VitalsThaiProvinces ? window.VitalsThaiProvinces.zoneCode(zone) : '';
      if (thZone) out.zoneCode = thZone;
    } else if (zone && /^[A-Za-z]{2,3}$/.test(zone)) {
      out.zoneCode = zone.toUpperCase();
    }
    return out;
  }

  function addressIsDefault(a) {
    if (!customer || !customer.defaultAddress || !a) return false;
    return a.id === customer.defaultAddress.id;
  }
  function addressLines(a) {
    var lines = [];
    if (a.address1) lines.push(a.address1);
    if (a.address2) lines.push(a.address2);
    var cityRow = [a.city, a.province, a.zip].filter(Boolean).join(' ');
    if (cityRow) lines.push(cityRow);
    if (a.country) lines.push(a.country);
    return lines.join(', ');
  }
  function renderAddresses() {
    var list = document.getElementById('pp-addr-list-' + sid);
    if (!list || !customer) return;
    var arr = customer.addresses || [];
    if (!arr.length) {
      list.innerHTML = '<p class="pp-empty">' + (IS_TH ? 'ยังไม่มีที่อยู่ที่บันทึกไว้' : 'No addresses saved yet.') + '</p>';
      return;
    }
    var sorted = arr.slice().sort(function (a, b) {
      var ad = addressIsDefault(a) ? 0 : 1;
      var bd = addressIsDefault(b) ? 0 : 1;
      return ad - bd;
    });
    list.innerHTML = sorted.map(function (a) {
      var name = ((a.firstName || '') + ' ' + (a.lastName || '')).trim();
      var isDef = addressIsDefault(a);
      return '<div class="pp-addr-row">' +
        '<div class="pp-addr-row__icon">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>' +
        '</div>' +
        '<div class="pp-addr-row__body">' +
          '<div class="pp-addr-row__head">' +
            (name ? '<span class="pp-addr-row__name">' + escapeHtml(name) + '</span>' : '') +
            (isDef ? '<span class="pp-addr-row__pill">' + (IS_TH ? 'หลัก' : 'Default') + '</span>' : '') +
          '</div>' +
          '<span class="pp-addr-row__addr">' + escapeHtml(addressLines(a)) + (a.phone ? ' · ' + escapeHtml(a.phone) : '') + '</span>' +
          '<div class="pp-addr-row__actions">' +
            '<button class="pp-btn--plain" data-pp-addr-edit="' + escapeHtml(a.id) + '">' + (IS_TH ? 'แก้ไข' : 'Edit') + '</button>' +
            (isDef ? '' : '<button class="pp-btn--text" data-pp-addr-default="' + escapeHtml(a.id) + '">' + (IS_TH ? 'ตั้งเป็นหลัก' : 'Set as default') + '</button>') +
            '<button class="pp-btn--danger-text" data-pp-addr-del="' + escapeHtml(a.id) + '">' + (IS_TH ? 'ลบ' : 'Delete') + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  // Suggest the exact province names Shopify matches on, so the typed value resolves to a zoneCode.
  function fillProvinceOptions() {
    var list = document.getElementById('pp-af-prov-list-' + sid);
    if (!list || list.childElementCount || !window.VitalsThaiProvinces) return;
    list.innerHTML = window.VitalsThaiProvinces.names().map(function (name) {
      return '<option value="' + escapeHtml(name) + '"></option>';
    }).join('');
  }

  function openAddressForm(addr) {
    var form = document.getElementById('pp-addr-form-' + sid);
    var listDom = document.getElementById('pp-addr-list-' + sid);
    if (!form) return;
    clearErr('pp-addr-err');
    form.style.display = 'block';
    listDom.style.display = 'none';
    document.getElementById('pp-addr-add-' + sid).style.display = 'none';
    document.getElementById('pp-addr-id-' + sid).value     = addr ? (addr.id || '') : '';
    document.getElementById('pp-af-fname-' + sid).value    = addr ? (addr.firstName || customer.firstName || '') : (customer.firstName || '');
    document.getElementById('pp-af-lname-' + sid).value    = addr ? (addr.lastName  || customer.lastName  || '') : (customer.lastName  || '');
    document.getElementById('pp-af-a1-' + sid).value       = addr ? (addr.address1 || '') : '';
    document.getElementById('pp-af-a2-' + sid).value       = addr ? (addr.address2 || '') : '';
    document.getElementById('pp-af-city-' + sid).value     = addr ? (addr.city || '') : '';
    fillProvinceOptions();
    document.getElementById('pp-af-prov-' + sid).value     = addr ? (addr.province || '') : '';
    document.getElementById('pp-af-country-' + sid).value  = addr ? (addr.country || 'Thailand') : 'Thailand';
    document.getElementById('pp-af-zip-' + sid).value      = addr ? (addr.zip || '') : '';
    document.getElementById('pp-af-phone-' + sid).value    = addr ? (addr.phone || customer.phone || '') : (customer.phone || '');
    document.getElementById('pp-af-default-' + sid).checked = addr ? addressIsDefault(addr) : !(customer.addresses && customer.addresses.length);
  }
  function closeAddressForm() {
    document.getElementById('pp-addr-form-' + sid).style.display = 'none';
    document.getElementById('pp-addr-list-' + sid).style.display = '';
    document.getElementById('pp-addr-add-' + sid).style.display = '';
  }

  function readAddressFormInput() {
    return {
      firstName: document.getElementById('pp-af-fname-' + sid).value.trim(),
      lastName:  document.getElementById('pp-af-lname-' + sid).value.trim(),
      address1:  document.getElementById('pp-af-a1-' + sid).value.trim(),
      address2:  document.getElementById('pp-af-a2-' + sid).value.trim(),
      city:      document.getElementById('pp-af-city-' + sid).value.trim(),
      province:  document.getElementById('pp-af-prov-' + sid).value.trim(),
      country:   document.getElementById('pp-af-country-' + sid).value.trim(),
      zip:       document.getElementById('pp-af-zip-' + sid).value.trim(),
      phone:     document.getElementById('pp-af-phone-' + sid).value.trim()
    };
  }

  function handleAddressSubmit(e) {
    e.preventDefault();
    clearErr('pp-addr-err');
    var id   = document.getElementById('pp-addr-id-' + sid).value;
    var def  = document.getElementById('pp-af-default-' + sid).checked;
    var input = readAddressFormInput();
    if (!input.address1 || !input.city) {
      showErr('pp-addr-err', IS_TH ? 'กรุณากรอกที่อยู่และเมือง' : 'Address and city are required.');
      return;
    }
    var addrInput = toAddressInput(input);
    // Say which field is wrong here rather than letting Shopify answer "Zone code must exist",
    // which names nothing the buyer can see on the form.
    if (addrInput.territoryCode === 'TH' && !addrInput.zoneCode) {
      showErr('pp-addr-err', IS_TH
        ? 'กรุณาเลือกจังหวัดจากรายการ (เช่น ชลบุรี)'
        : 'Pick a province from the list (e.g. Chon Buri).');
      return;
    }
    busy('pp-addr-save', true);
    var p = id
      ? caApi(Q_ADDRESS_UPDATE, { id: id, a: addrInput, d: def })
      : caApi(Q_ADDRESS_CREATE, { a: addrInput, d: def });
    p.then(function (resp) {
      var key = id ? 'customerAddressUpdate' : 'customerAddressCreate';
      var r = (resp.data && resp.data[key]) || {};
      if (r.userErrors && r.userErrors.length) throw new Error(r.userErrors[0].message);
      // Update local model
      var saved = r.customerAddress;
      if (id) {
        customer.addresses = (customer.addresses || []).map(function (a) { return a.id === id ? saved : a; });
      } else {
        customer.addresses = (customer.addresses || []).concat([saved]);
      }
      // The payload no longer returns defaultAddress; we passed $d, so reflect it locally.
      if (def && saved) customer.defaultAddress = { id: saved.id };
      try { sessionStorage.setItem(STORE_CUSTOMER, JSON.stringify(customer)); } catch (_) {}
      closeAddressForm();
      renderAddresses();
      toast(IS_TH ? 'บันทึกที่อยู่แล้ว' : 'Address saved.', 'success');
    })
    .catch(function (err) {
      if (err && err.status === 401) { window.location.href = LOGIN_URL; return; }
      console.error('[address] save failed:', err);
      showErr('pp-addr-err', (err && err.message) || (IS_TH ? 'ไม่สามารถบันทึกได้' : 'Could not save address.'));
    })
    .finally(function () { busy('pp-addr-save', false); });
  }

  function handleAddressDelete(id) {
    if (!id) return;
    if (!confirm(IS_TH ? 'ลบที่อยู่นี้หรือไม่?' : 'Delete this address?')) return;
    caApi(Q_ADDRESS_DELETE, { id: id })
      .then(function (resp) {
        var r = (resp.data && resp.data.customerAddressDelete) || {};
        if (r.userErrors && r.userErrors.length) throw new Error(r.userErrors[0].message);
        customer.addresses = (customer.addresses || []).filter(function (a) { return a.id !== id; });
        if (customer.defaultAddress && customer.defaultAddress.id === id) customer.defaultAddress = null;
        try { sessionStorage.setItem(STORE_CUSTOMER, JSON.stringify(customer)); } catch (_) {}
        renderAddresses();
        toast(IS_TH ? 'ลบที่อยู่แล้ว' : 'Address deleted.', 'success');
      })
      .catch(function (err) {
        if (err && err.status === 401) { window.location.href = LOGIN_URL; return; }
        console.error('[address] delete failed:', err);
        toast(IS_TH ? 'ไม่สามารถลบได้' : 'Could not delete address.', 'error');
      });
  }

  function handleAddressSetDefault(id) {
    if (!id) return;
    var existing = (customer.addresses || []).filter(function (a) { return a.id === id; })[0];
    if (!existing) return;
    caApi(Q_ADDRESS_UPDATE, { id: id, a: toAddressInput(existing), d: true })
      .then(function (resp) {
        var r = (resp.data && resp.data.customerAddressUpdate) || {};
        if (r.userErrors && r.userErrors.length) throw new Error(r.userErrors[0].message);
        customer.defaultAddress = { id: id };
        try { sessionStorage.setItem(STORE_CUSTOMER, JSON.stringify(customer)); } catch (_) {}
        renderAddresses();
        toast(IS_TH ? 'ตั้งเป็นที่อยู่หลักแล้ว' : 'Default address updated.', 'success');
      })
      .catch(function (err) {
        if (err && err.status === 401) { window.location.href = LOGIN_URL; return; }
        console.error('[address] default failed:', err);
        toast(IS_TH ? 'ไม่สามารถตั้งค่าได้' : 'Could not set default.', 'error');
      });
  }

  // ── Top-up missing fields from Customer Account API ─────
  var Q_CUSTOMER_FULL =
    'query CustomerFull {' +
      'customer {' +
        'id firstName lastName displayName creationDate imageUrl' +
        ' emailAddress { emailAddress marketingState }' +
        ' phoneNumber  { phoneNumber }' +
        ' defaultAddress { id firstName lastName address1 address2 city province country zip phone: phoneNumber }' +
        ' addresses(first: 20) { edges { node { id firstName lastName address1 address2 city province country zip phone: phoneNumber } } }' +
        ' mfBirthdate: metafield(namespace: "custom", key: "birthdate") { value }' +
        ' mfGender: metafield(namespace: "custom", key: "gender") { value }' +
        ' mfPhone: metafield(namespace: "custom", key: "phone") { value }' +
      '}' +
    '}';

  function topUpCustomer() {
    // A request fired for the previous account can land after an account switch
    // has already rebuilt the page. Merging it would splice the old customer's
    // fields onto the new one, so drop anything that outlived its session.
    var epoch = sessionEpoch;
    return caApi(Q_CUSTOMER_FULL, {}).then(function (resp) {
      if (epoch !== sessionEpoch || !customer) return;
      var raw = (resp.data && resp.data.customer) || {};
      if (!raw || !raw.id) return;
      var fresh = normalizeCustomer(raw);
      // Merge: preserve any non-empty existing field, fill in fresh values where missing
      Object.keys(fresh).forEach(function (k) {
        var v = fresh[k];
        if (v === '' || v === null || v === undefined) return;
        if (Array.isArray(v) && !v.length) return;
        customer[k] = v;
      });
      // Always refresh emailMarketingState (it's the source of truth)
      customer.emailMarketingState = fresh.emailMarketingState;
      customer.creationDate = fresh.creationDate || customer.creationDate;
      customer.defaultAddress = fresh.defaultAddress || customer.defaultAddress;
      customer.addresses = fresh.addresses;
      // DOB + gender live in customer metafields (the source of truth now that
      // we write them there). Only override when the metafield has a value, so
      // an unset metafield doesn't wipe a value the backend just supplied.
      if (raw.mfBirthdate && raw.mfBirthdate.value) customer.dateOfBirth = raw.mfBirthdate.value;
      if (raw.mfGender && raw.mfGender.value)       customer.gender      = (raw.mfGender.value || '').toUpperCase();
      // Phone is saved to custom.phone (the Customer Account API can't write the native
      // phoneNumber), so the metafield wins over the native value on reload.
      if (raw.mfPhone && raw.mfPhone.value)       customer.phone       = raw.mfPhone.value;
      try { sessionStorage.setItem(STORE_CUSTOMER, JSON.stringify(customer)); } catch (_) {}
    }).catch(function (err) {
      // A 401 from a superseded session is expected — revalidateSession() has
      // already dealt with it, so don't bounce the user out of the new one.
      if (epoch !== sessionEpoch) return;
      if (err && err.status === 401) { window.location.href = LOGIN_URL; return; }
      console.warn('[topUpCustomer] failed:', err);
    });
  }

  // ── customerUpdate (name only) ──────────────────────────
  var Q_CUSTOMER_UPDATE =
    'mutation CustomerUpdate($input: CustomerUpdateInput!) {' +
      'customerUpdate(input: $input) {' +
        'customer { firstName lastName }' +
        'userErrors { field message }' +
      '}' +
    '}';

  // Posts a Shopify-style customers/update webhook payload to the Vitals
  // backend so it can persist DOB / gender / phone (fields the Customer
  // Account API doesn't expose for mutation). Mirrors the customer-created
  // webhook payload shape and adds the extra profile fields.
  function postCustomerUpdatedWebhook(extras) {
    var payload = buildShopifyCustomerWebhookPayload();
    if (!payload) return Promise.resolve(false);
    if (extras && typeof extras === 'object') {
      if (extras.phone !== undefined)        payload.phone        = extras.phone || null;
      if (extras.dateOfBirth !== undefined)  payload.date_of_birth = extras.dateOfBirth || null;
      if (extras.gender !== undefined)       payload.gender       = extras.gender || null;
    }
    return fetch(WELLNESS_API + '/auth/api/v1/webhook/shopify/customer-updated', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return !!r.ok; })
      .catch(function (err) {
        console.error('[profile] customer-updated webhook failed:', err);
        return false;
      });
  }

  // ── DOB + gender + phone → customer metafields (backend endpoint) ──
  // firstName/lastName go through customerUpdate; DOB, gender and phone aren't
  // mutable Customer fields, so we persist them via the backend, which writes
  // the customer metafields custom.birthdate (date), custom.gender
  // (single_line_text_field) and custom.phone (single_line_text_field).
  // Session-cookie auth — no Customer Account API metafield write scope
  // required. Backend expects gender uppercase (MALE | FEMALE | OTHERS),
  // matching the Shopify-facing values our form already uses.

  // Sends only the fields that have a value. Rejects with the backend's
  // validation message so handleProfileUpdate can surface it inline.
  function saveCustomerMetafields(dob, gender, phone) {
    var body = {};
    if (gender) body.gender      = gender.toUpperCase();
    if (dob)    body.dateOfBirth = dob;
    if (phone)  body.phone       = phone;
    if (!body.gender && !body.dateOfBirth && !body.phone) return Promise.resolve(true);
    return fetch(METAFIELDS_URL, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.text().then(function (txt) {
        var json = null;
        try { json = txt ? JSON.parse(txt) : null; } catch (_) {}
        if (r.status === 401 || r.status === 403) {
          var authErr = new Error('Not authenticated'); authErr.status = r.status; throw authErr;
        }
        if (!r.ok || !json || json.success === false) {
          var msg = (json && json.error && json.error.message) ||
                    (json && json.message) || ('Metafields save HTTP ' + r.status);
          throw new Error(msg);
        }
        return true;
      });
    });
  }

  // Reject a birthdate that isn't a real calendar day (31 Feb), lies in the
  // future, or is implausibly old. The backend stores whatever it's sent, so
  // this is the only gate. Returns '' when the value is empty or valid.
  function dobError(dob) {
    if (!dob) return '';
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dob);
    var d = m && new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    var real = d && d.getFullYear() === Number(m[1]) && d.getMonth() === Number(m[2]) - 1 && d.getDate() === Number(m[3]);
    if (!real) return IS_TH ? 'วันเกิดไม่ถูกต้อง' : 'Please enter a valid birthdate.';
    if (d > new Date()) return IS_TH ? 'วันเกิดต้องไม่เป็นวันในอนาคต' : 'Birthdate can’t be in the future.';
    if (Number(m[1]) < new Date().getFullYear() - 120) return IS_TH ? 'วันเกิดไม่ถูกต้อง' : 'Please enter a valid birthdate.';
    return '';
  }

  function handleProfileUpdate(e) {
    e.preventDefault();
    clearErr('pp-profile-err');
    if (!customer) return;
    var firstName = document.getElementById('pp-prf-fname-' + sid).value.trim();
    var lastName  = document.getElementById('pp-prf-lname-' + sid).value.trim();
    var phone     = document.getElementById('pp-prf-phone-'  + sid).value.trim();
    var dobY      = (document.getElementById('pp-prf-dob-year-'  + sid) || {}).value || '';
    var dobM      = (document.getElementById('pp-prf-dob-month-' + sid) || {}).value || '';
    var dobD      = (document.getElementById('pp-prf-dob-day-'   + sid) || {}).value || '';
    var dob       = (dobY && dobM && dobD) ? dobY + '-' + dobM + '-' + dobD : '';
    var gender    = document.getElementById('pp-prf-gender-' + sid).value.trim().toUpperCase();
    // A half-picked date used to be dropped silently; make the user finish or clear it.
    var dobPartial = (dobY || dobM || dobD) && !dob;
    var dobMsg    = dobPartial ? (IS_TH ? 'กรุณาเลือกวัน เดือน และปีเกิดให้ครบ' : 'Please pick a day, month and year.') : dobError(dob);
    if (dobMsg) { showErr('pp-profile-err', dobMsg); return; }
    busy('pp-profile-btn', true);
    caApi(Q_CUSTOMER_UPDATE, { input: { firstName: firstName, lastName: lastName } })
      .then(function (resp) {
        var r = (resp.data && resp.data.customerUpdate) || {};
        if (r.userErrors && r.userErrors.length) {
          showErr('pp-profile-err', r.userErrors[0].message);
          return null;
        }
        customer.firstName  = r.customer.firstName || '';
        customer.lastName   = r.customer.lastName  || '';
        customer.first_name = customer.firstName;
        customer.last_name  = customer.lastName;
        customer.displayName = (customer.firstName + ' ' + customer.lastName).trim() || customer.email;
        customer.phone       = phone;
        customer.dateOfBirth = dob;
        customer.gender      = gender;
        try { sessionStorage.setItem(STORE_CUSTOMER, JSON.stringify(customer)); } catch (_) {}
        // Persist DOB + gender + phone to the customer metafields via the backend.
        return saveCustomerMetafields(dob, gender, phone)
          // Then mirror phone / DOB / gender to the Vitals backend (phone
          // lives only there). Fire-and-forget; UI already reflects them.
          .then(function () { return postCustomerUpdatedWebhook({ phone: phone, dateOfBirth: dob, gender: gender }); });
      })
      .then(function (ok) {
        if (ok === null) return; // userErrors above
        renderHeroBasics();
        renderAccountView();
        closeAccountEdit();
        toast(IS_TH ? 'บันทึกข้อมูลแล้ว' : 'Profile updated.', 'success');
      })
      .catch(function (err) {
        if (err && err.status === 401) { window.location.href = LOGIN_URL; return; }
        showErr('pp-profile-err', (err && err.message) || 'Something went wrong. Please try again.');
      })
      .finally(function () { busy('pp-profile-btn', false); });
  }

  // ── Orders ──────────────────────────────────────────────
  // `variantId` is needed so we can re-order a past purchase: the line item's
  // Storefront variant GID is bulk-POSTed to /cart/add.js (exactly what the PDP
  // does). We keep `sku` only for display / debugging.
  var Q_ORDERS =
    'query CustomerOrders {' +
      'customer {' +
        'orders(first: 20, sortKey: PROCESSED_AT, reverse: true) {' +
          'edges { node {' +
            'id name confirmationNumber processedAt financialStatus fulfillmentStatus statusPageUrl' +
            ' totalPrice { amount currencyCode }' +
            ' totalRefunded { amount currencyCode }' +
            ' lineItems(first: 10) { edges { node {' +
              ' title quantity variantTitle sku variantId productId' +
              ' price { amount currencyCode }' +
              ' image { url altText }' +
            '} } }' +
          '} }' +
        '}' +
      '}' +
    '}';

  var ordersFilter = 'all';

  // ── Blood-test orders ───────────────────────────────────
  // Blood tests are paid for first and scheduled afterwards, so their order's action is booking the
  // home collection, not tracking a parcel.
  //
  // Matched by product id, like every other blood-test check across the storefront and the mobile
  // app: the Shopify products carry no distinguishing tag or product type. Keep this list in sync
  // with LONGEVITY_PRODUCT_IDS / LONGEVITY_EXPRESS_PRODUCT_IDS in
  // vitals-mobile-react/src/modules/Longevity/dtos/longevityTest.dto.ts.
  var BLOOD_TEST_PRODUCT_IDS = [
    '10364717760808', // Essential Wellness
    '10364717859112', // Advanced Vitality
    '10364717957416', // Executive Longevity
    '10392597594408', // Essential Wellness (express)
    '10392597659944', // Advanced Vitality (express)
    '10392597791016'  // Executive Longevity (express)
  ];

  /** Numeric id out of a Customer Account API GID ("gid://shopify/Product/123?key=…"). */
  function numericId(gid) {
    var raw = String(gid == null ? '' : gid);
    var tail = raw.split('/').pop() || '';
    return tail.split('?')[0];
  }

  function isBloodTestOrder(o) {
    var items = ((o.lineItems && o.lineItems.edges) || []).map(function (li) { return li.node; });
    return items.some(function (li) {
      return BLOOD_TEST_PRODUCT_IDS.indexOf(numericId(li.productId)) !== -1;
    });
  }

  /**
   * Post-purchase booking page for an order (sections/blood-test-booking-form.liquid). Built off
   * `Shopify.routes.root` so the locale prefix survives, and carries the confirmation number
   * alongside the order id — the page reads the id today, the pair is what the backend will
   * authorise on.
   */
  function bookingUrl(o) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root + 'pages/booking-form?order=' + encodeURIComponent(numericId(o.id));
    if (o.confirmationNumber) url += '&cn=' + encodeURIComponent(o.confirmationNumber);
    return url;
  }

  function orderBucket(o) {
    var f = (o.fulfillmentStatus || '').toUpperCase();
    var p = (o.financialStatus    || '').toUpperCase();
    if (p === 'VOIDED' || p === 'REFUNDED') return 'canceled';
    if (f === 'FULFILLED') return 'delivered';
    return 'active';
  }
  function pillClassFor(bucket) {
    if (bucket === 'delivered') return 'pp-pill-status--delivered';
    if (bucket === 'active')    return 'pp-pill-status--active';
    if (bucket === 'canceled')  return 'pp-pill-status--canceled';
    return 'pp-pill-status--other';
  }
  function pillLabelFor(bucket) {
    if (bucket === 'delivered') return IS_TH ? 'จัดส่งแล้ว' : 'Delivered';
    if (bucket === 'active')    return IS_TH ? 'กำลังจัดส่ง' : 'In transit';
    if (bucket === 'canceled')  return IS_TH ? 'ยกเลิก' : 'Canceled';
    return '';
  }
  function actionFor(o, bucket) {
    // Takes the place of tracking, on live orders only — a delivered test is done, and its row is
    // more useful offering the package again. A booked test still shows the button: the booking page
    // answers a re-opened link with the appointment already on file, so it then reads as "see my
    // booking" rather than a second chance to book.
    if (bucket === 'active' && isBloodTestOrder(o)) {
      return { kind: 'booking', label: IS_TH ? 'จองตรวจเลือด' : 'Book blood test', primary: true };
    }
    if (bucket === 'active') return { kind: 'track',   label: IS_TH ? 'ติดตาม' : 'Track order', primary: true };
    return { kind: 'reorder', label: IS_TH ? 'เพิ่มลงตะกร้า' : 'Add to cart', primary: false };
  }

  function renderOrders(force) {
    var container = document.getElementById('pp-orders-' + sid);
    if (!container) return;
    if (ordersLoaded && !force) {
      renderOrdersList();
      return;
    }
    container.innerHTML = '<div class="pp-loader"><div class="pp-spinner"></div></div>';
    caApi(Q_ORDERS, {})
      .then(function (resp) {
        ordersLoaded = true;
        var edges = (((resp.data || {}).customer || {}).orders || {}).edges || [];
        ordersCache = edges.map(function (e) { return e.node; });
        renderStatTiles();
        renderOrdersList();
      })
      .catch(function (err) {
        if (err && err.status === 401) { window.location.href = LOGIN_URL; return; }
        console.error('[orders] fetch failed:', err);
        container.innerHTML = '<p class="pp-empty">' + (IS_TH ? 'ไม่สามารถโหลดคำสั่งซื้อได้ ลองอีกครั้ง' : 'Failed to load orders. Please try again.') + '</p>';
      });
  }

  function renderOrdersList() {
    var container = document.getElementById('pp-orders-' + sid);
    var countEl   = document.getElementById('pp-orders-count-' + sid);
    if (!container) return;
    var arr = ordersCache || [];
    var filtered = ordersFilter === 'all' ? arr : arr.filter(function (o) { return orderBucket(o) === ordersFilter; });
    if (countEl) countEl.textContent = arr.length
      ? (arr.length + ' ' + (IS_TH ? 'คำสั่งซื้อ' : 'orders') + ' · ' + (IS_TH ? 'ติดตาม สั่งซ้ำ หรือดูรายละเอียดได้ที่นี่' : 'track, reorder or view details below.'))
      : '';
    if (!filtered.length) {
      container.innerHTML = '<p class="pp-empty">' + (IS_TH ? 'ไม่มีคำสั่งซื้อในหมวดนี้' : 'No orders in this filter.') + '</p>';
      return;
    }
    container.innerHTML = '<div class="pp-orders">' + filtered.map(function (o) {
      // Use the underlying index in ordersCache so the click handler can
      // find the order even when the chip filter has narrowed the list.
      var orderIdx = ordersCache.indexOf(o);
      var dateStr = o.processedAt ? new Date(o.processedAt).toLocaleDateString(IS_TH ? 'th-TH' : 'en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
      var bucket  = orderBucket(o);
      var pillCls = pillClassFor(bucket);
      var pillLbl = pillLabelFor(bucket);
      // `totalPrice` is the CURRENT total net of returned/refunded line items, so a
      // fully refunded (Canceled) order reports 0. Add `totalRefunded` back to show
      // what the customer originally paid. totalRefunded is 0 for non-refunded orders.
      var totalStr = '';
      if (o.totalPrice) {
        var grossAmount = parseFloat(o.totalPrice.amount) + parseFloat((o.totalRefunded && o.totalRefunded.amount) || 0);
        totalStr = grossAmount.toFixed(2) + ' ' + o.totalPrice.currencyCode;
      }
      var items = ((o.lineItems && o.lineItems.edges) || []).map(function (li) { return li.node; });
      var qtySum = items.reduce(function (n, x) { return n + (x.quantity || 1); }, 0);
      var titles = items.map(function (x) { return x.title; }).filter(Boolean);
      var summary = titles.length === 1 ? titles[0] : (titles[0] || '') + (titles.length > 1 ? ' + ' + (titles.length - 1) + ' ' + (IS_TH ? 'รายการ' : 'more') : '');
      var qtyStr = (qtySum || items.length || 1) + ' ' + (IS_TH ? 'รายการ' : (qtySum === 1 ? 'item' : 'items'));
      var thumbs = items.slice(0, 4).map(function (x) {
        var img = x.image
          ? '<img src="' + escapeHtml(x.image.url) + '" alt="' + escapeHtml(x.image.altText || x.title || '') + '" loading="lazy">'
          : '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/></svg>';
        return '<div class="pp-order__thumb">' + img + '</div>';
      }).join('');
      var act = actionFor(o, bucket);
      var hasReorderable = items.some(function (i) { return i.variantId; });
      var btnAttr;
      if (act.kind === 'reorder') {
        btnAttr = ' data-pp-order-reorder="' + orderIdx + '"' + (hasReorderable ? '' : ' disabled');
      } else if (act.kind === 'booking') {
        btnAttr = ' data-pp-order-booking="' + orderIdx + '"';
      } else {
        btnAttr = ' data-pp-order-track="' + orderIdx + '"' + (o.statusPageUrl ? '' : ' disabled');
      }
      return '<div class="pp-order">' +
        '<div class="pp-order__hd">' +
          '<div class="pp-order__hd-l">' +
            (pillLbl ? '<span class="pp-pill-status ' + pillCls + '">' + pillLbl + '</span>' : '') +
            '<span class="pp-order__name">' + escapeHtml(o.name || '') + '</span>' +
            (dateStr ? '<span class="pp-order__dot">·</span><span class="pp-order__date">' + dateStr + '</span>' : '') +
          '</div>' +
          (totalStr ? '<span class="pp-order__total">' + totalStr + '</span>' : '') +
        '</div>' +
        '<div class="pp-order__body">' +
          '<div class="pp-order__items">' +
            '<div class="pp-order__thumbs">' + thumbs + '</div>' +
            '<div class="pp-order__summary">' +
              '<div class="pp-order__title">' + escapeHtml(summary) + '</div>' +
              '<span class="pp-order__qty">' + qtyStr + '</span>' +
            '</div>' +
          '</div>' +
          '<div class="pp-order__actions">' +
            '<button class="pp-btn ' + (act.primary ? 'pp-btn--primary' : 'pp-btn--ghost') + ' pp-btn--sm"' + btnAttr + '>' + escapeHtml(act.label) + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('') + '</div>';
  }

  // Confirm the order's variants are still purchasable, then bulk-add to
  // /cart/add.js so a "Buy again" / "Add to cart" click recreates the order's
  // line items in the customer's cart. We look variants up by their GID (which
  // the order line items already carry) rather than by SKU: the Storefront
  // `products(query:)` connection has no `sku` filter, so a `sku:` search
  // silently matches nothing and makes every still-available item look "no
  // longer available". `nodes(ids:)` is an exact ID lookup with no such gap —
  // a null node means the variant was genuinely deleted/unpublished.
  var Q_VARIANTS_BY_ID =
    'query($ids:[ID!]!){' +
      'nodes(ids:$ids){ ... on ProductVariant { id availableForSale } }' +
    '}';

  function handleOrderReorder(orderIdx, btn) {
    var order = ordersCache && ordersCache[orderIdx];
    if (!order) return;
    var items = ((order.lineItems && order.lineItems.edges) || [])
      .map(function (li) { return li.node; })
      .filter(function (i) { return i && i.variantId; });
    if (!items.length) {
      toast(IS_TH ? 'ไม่มีรายการที่สามารถสั่งซ้ำได้' : 'No items available to reorder.', 'error');
      return;
    }
    var origLabel = btn.textContent;
    btn.disabled = true; btn.textContent = '…';

    var ids = items.map(function (i) { return i.variantId; });
    gql(Q_VARIANTS_BY_ID, { ids: ids })
      .then(function (d) {
        if (d.errors) console.error('[reorder] storefront errors:', d.errors);
        // Build variantId → available map from the exact-ID lookup.
        var byId = {};
        var nodes = ((d.data || {}).nodes || []);
        nodes.forEach(function (n) {
          if (n && n.id) byId[n.id] = !!n.availableForSale;
        });
        var bulkItems = items
          .map(function (i) {
            if (!byId[i.variantId]) return null;
            var numericId = String(i.variantId).split('/').pop();
            return { id: parseInt(numericId, 10), quantity: i.quantity || 1 };
          })
          .filter(Boolean);
        if (!bulkItems.length) {
          toast(IS_TH ? 'สินค้าไม่พร้อมจำหน่ายแล้ว' : 'These items are no longer available.', 'error');
          return null;
        }
        var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: bulkItems })
        })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error((e && e.description) || ('Cart error ' + r.status)); });
          return r.json();
        })
        .then(function () { return fetch(cartRoot + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.body.classList.add('cart-sidebar-show');
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count >= 100 ? '99+' : cart.item_count;
          });
          window.updateCartCountLabels?.(cart.item_count);
          var wrapper = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
          if (wrapper) {
            fetch(cartRoot + 'cart?view=ajax_side_cart', { cache: 'no-store' })
              .then(function (r) { return r.text(); })
              .then(function (html) {
                wrapper.innerHTML = html;
                document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
              });
          }
          var added = bulkItems.length;
          var skipped = items.length - added;
          toast(
            (IS_TH ? 'เพิ่มแล้ว ' : 'Added ') + added + ' ' + (IS_TH ? 'รายการ' : (added === 1 ? 'item' : 'items')) +
            (skipped ? ' · ' + skipped + ' ' + (IS_TH ? 'รายการไม่พร้อม' : (skipped === 1 ? 'unavailable' : 'unavailable')) : ''),
            'success'
          );
        });
      })
      .catch(function (err) {
        console.error('[reorder] failed:', err);
        toast(IS_TH ? 'ไม่สามารถเพิ่มลงตะกร้าได้' : 'Could not add to cart. Please try again.', 'error');
      })
      .finally(function () { btn.disabled = false; btn.textContent = origLabel; });
  }

  // ── Logout ──────────────────────────────────────────────
  // Drop every scrap of per-session state held in memory. Shared by sign-out,
  // account deletion and the account-switch path in revalidateSession(), which
  // all need the same guarantee: nothing from the previous session survives
  // into the next one.
  function resetSessionState() {
    sessionEpoch++;
    sessionVerified = false;
    customer = null;
    expert = null;
    ordersLoaded = false; ordersCache = null;
    wellnessTestsCache = null;
    bloodTestsCache = null;
    // Reset expert / telehealth state so nothing leaks into the next session.
    appointmentsCache = null;
    patientsCache = null;
    expertPanelsLoaded = { appointments: false, patients: false, schedule: false, profile: false };
    currentExpertTab = 'dashboard';
    openApptId = null; openPatientId = null; apptDetailState = null;
    apptCache = null; apptById = {}; apptLoaded = false; apptLoading = false;
  }

  function handleLogout() {
    var revoke = Promise.resolve();
    // Read before clearStoredAuth() drops the token it lives in.
    var stored = getStoredToken();
    var shopId = (stored && stored.shopId) || root.dataset.shopId || '';
    // Invalidate the backend session cookie. Clearing sessionStorage alone is not
    // enough: /shopify/profile authenticates from the session cookie (credentials:
    // 'include'), so a stale cookie would silently re-authenticate the user on the
    // next boot(). Best-effort — we sign the user out locally regardless of result.
    if (LOGOUT_URL) {
      try {
        revoke = fetch(LOGOUT_URL, {
          method: 'POST',
          credentials: 'include',
          keepalive: true,
          headers: { 'Accept': 'application/json' }
        }).catch(function (err) {
          console.warn('[ProfilePage] backend logout failed:', err);
        });
      } catch (_) {}
    }

    clearStoredAuth();
    // Clear the client-readable session cookie so nothing re-authenticates on next boot.
    clearCookie('vitals_session');
    // Also drop the one-time deeplink guard so a fresh sign-in re-delivers the token.
    try { sessionStorage.removeItem(DEEPLINK_SENT_KEY); } catch (_) {}
    resetSessionState();
    markSignedOut();
    showView('signin');
    toast(IS_TH ? 'ออกจากระบบแล้ว' : 'You have been signed out.', 'success');
    endIdentitySession(revoke, shopId);
  }

  // End the Shopify customer-account session the login left in this browser.
  //
  // Sign-in runs Shopify's OAuth on its own domain, which keeps an HttpOnly
  // session there that nothing on this page can clear. While it lives, the
  // next Sign in completes the OAuth silently — no email, no OTP — and the
  // user is straight back in. Only a navigation to Shopify's logout ends it,
  // the same trip the mobile app makes (endBrowserIdentitySession). Shopify
  // finishes on the storefront; the signed-out mark keeps the profile on the
  // sign-in view from there.
  //
  // Waits briefly for the backend logout so leaving the page can't cut it off.
  // Skipped inside the app's WebView, which ends this session itself.
  function endIdentitySession(revoke, shopId) {
    if (!shopId || window.ReactNativeWebView) return;
    var url = 'https://shopify.com/' + encodeURIComponent(shopId) + '/account/logout' +
      '?return_url=' + encodeURIComponent(window.location.origin + window.location.pathname);
    var go = function () { window.location.href = url; };
    Promise.race([
      revoke.catch(function () {}),
      new Promise(function (resolve) { setTimeout(resolve, 1500); })
    ]).then(go, go);
  }

  // ── Delete account ──────────────────────────────────────
  // Clears every trace of the (now deleted) session locally and returns the
  // user to the signed-out view. The backend has already invalidated the
  // account, so — unlike handleLogout — we don't POST a logout.
  function finishAccountDeletion() {
    clearStoredAuth();
    clearCookie('vitals_session');
    try { sessionStorage.removeItem(DEEPLINK_SENT_KEY); } catch (_) {}
    resetSessionState();
    markSignedOut();
    showView('signin');
    toast(IS_TH ? 'ลบบัญชีของคุณเรียบร้อยแล้ว' : 'Your account has been deleted.', 'success');
  }

  function closeDeleteAccountModal() {
    var wrap = document.getElementById('pp-delete-modal-' + sid);
    if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
  }

  function openDeleteAccountModal() {
    closeDeleteAccountModal(); // Remove any prior instance
    var wrap = document.createElement('div');
    wrap.id = 'pp-delete-modal-' + sid;
    wrap.className = 'pp-modal-bg';
    wrap.style.display = 'flex';
    wrap.innerHTML =
      '<div class="pp-modal-box" style="max-width:480px">' +
        '<div class="pp-modal-header">' +
          '<span class="pp-modal-title">' + (IS_TH ? 'ลบบัญชี' : 'Delete account') + '</span>' +
          '<button type="button" class="pp-modal-close" data-pp-delete-close aria-label="Close">&#x2715;</button>' +
        '</div>' +
        '<p style="font-size:14px;color:var(--pp-text);margin:0 0 12px;line-height:1.55">' +
          (IS_TH
            ? 'การลบบัญชีเป็นการดำเนินการถาวรและไม่สามารถกู้คืนได้ ข้อมูลโปรไฟล์ ที่อยู่ ผลตรวจสุขภาพ และการตั้งค่าของคุณจะถูกลบอย่างถาวร'
            : 'Deleting your account is permanent and cannot be undone. Your profile, addresses, wellness results and preferences will be permanently removed.') +
        '</p>' +
        '<p style="font-size:13px;color:var(--pp-muted);margin:0 0 16px;line-height:1.55">' +
          (IS_TH
            ? 'หากคุณมีคำสั่งซื้ออยู่แล้ว บัญชีของคุณจะไม่สามารถลบโดยอัตโนมัติได้ กรุณาติดต่อ '
            : 'If you have existing orders, your account can’t be deleted automatically. Please contact ') +
          '<a href="mailto:' + escapeHtml(SUPPORT_EMAIL) + '" style="color:var(--pp-green);font-weight:700">' + escapeHtml(SUPPORT_EMAIL) + '</a>.' +
        '</p>' +
        '<div class="pp-error" id="pp-delete-err-' + sid + '"></div>' +
        '<div style="display:flex;gap:10px;margin-top:18px;justify-content:flex-end">' +
          '<button type="button" class="pp-btn--plain" data-pp-delete-close>' + (IS_TH ? 'ยกเลิก' : 'Cancel') + '</button>' +
          '<button type="button" class="pp-btn pp-btn--danger pp-btn--sm" id="pp-delete-confirm-' + sid + '">' + (IS_TH ? 'ลบบัญชีของฉัน' : 'Delete my account') + '</button>' +
        '</div>' +
      '</div>';
    root.appendChild(wrap);

    wrap.addEventListener('click', function (e) {
      if (e.target === wrap) closeDeleteAccountModal();
      if (e.target.closest('[data-pp-delete-close]')) closeDeleteAccountModal();
    });
    var confirmBtn = document.getElementById('pp-delete-confirm-' + sid);
    if (confirmBtn) confirmBtn.addEventListener('click', handleDeleteAccount);
  }

  function handleDeleteAccount() {
    var errEl  = document.getElementById('pp-delete-err-' + sid);
    var btn    = document.getElementById('pp-delete-confirm-' + sid);
    if (errEl) { errEl.textContent = ''; errEl.classList.remove('pp-show'); }
    if (btn) { btn.disabled = true; btn.dataset.orig = btn.textContent; btn.textContent = IS_TH ? 'กำลังลบ…' : 'Deleting…'; }

    fetch(DELETE_URL, {
      method: 'DELETE',
      credentials: 'include',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      return r.text().then(function (txt) {
        var json = null;
        try { json = txt ? JSON.parse(txt) : null; } catch (_) {}
        return { ok: r.ok, status: r.status, json: json };
      });
    }).then(function (res) {
      var json = res.json;
      var deleted = json && json.data && json.data.deleted === true;
      // Backend sends deleted:false (with a message) when it can't delete —
      // e.g. the customer has existing orders. Surface that message in-modal.
      if (res.ok && json && json.success && deleted) {
        closeDeleteAccountModal();
        finishAccountDeletion();
        return;
      }
      var msg = (json && json.error && json.error.message) ||
                (json && json.message) ||
                (IS_TH ? 'ไม่สามารถลบบัญชีได้ กรุณาลองใหม่อีกครั้ง' : 'Your account could not be deleted. Please try again.');
      if (errEl) { errEl.textContent = msg; errEl.classList.add('pp-show'); }
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.orig || (IS_TH ? 'ลบบัญชีของฉัน' : 'Delete my account'); }
    }).catch(function (err) {
      console.error('[ProfilePage] account deletion failed:', err);
      if (errEl) {
        errEl.textContent = IS_TH ? 'เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง' : 'A network error occurred. Please try again.';
        errEl.classList.add('pp-show');
      }
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.orig || (IS_TH ? 'ลบบัญชีของฉัน' : 'Delete my account'); }
    });
  }

  // ── Storefront API (wellness recommendations) ───────────
  function gql(query, variables) {
    return fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', 'Accept': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontToken
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) {
      if (!r.ok) throw new Error('Network error ' + r.status);
      return r.json();
    });
  }

  function handleAddToCart(btn) {
    var vid = btn.dataset.vid;
    if (!vid) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error((e && e.description) || ('Cart error ' + r.status)); });
      return r.json();
    })
    .then(function () {
      return fetch(cartRoot + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      refreshCartUi(cart);
      btn.textContent = IS_TH ? 'เพิ่มแล้ว ✓' : 'Added ✓';
      setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 2000);
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = orig;
      toast(IS_TH ? 'ไม่สามารถเพิ่มลงตะกร้าได้' : 'Could not add to cart. Please try again.', 'error');
    });
  }

  // ── Wellness ────────────────────────────────────────────
  var isVitalsbrand          = (root.dataset.domain || '').indexOf('vitalsbrand') !== -1;
  var wellnessPrefix         = isVitalsbrand ? 'VSG' : 'VIT';
  var wellnessLabId          = isVitalsbrand ? 3 : 2;
  var showWellnessLangSelect = !isVitalsbrand;
  var WELLNESS_API           = 'https://api.vitals.co.th';

  var wT = {
    en: {
      modalTitle: 'Wellness Test', testId: 'Test ID',
      firstName: 'First name', lastName: 'Last name',
      gender: 'Gender', selectGender: 'Select gender',
      male: 'Male', female: 'Female',
      email: 'Email address', phone: 'Phone number', birthdate: 'Birthdate',
      month: 'Month', day: 'Day', year: 'Year',
      months: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
      language: 'Report Language', english: 'English', thai: 'Thai',
      saving: 'Saving…', save: 'Save',
      testIdLabel: 'Test ID:', on: 'On', downloadPdf: 'Download PDF',
      requiredFields: 'Please complete all required fields.',
      alreadyRegistered: 'This test ID has already been registered.',
      testIdNotFound: 'Test ID not found.',
      savedSuccess: 'Wellness test saved successfully.',
      noTests: 'No wellness tests yet.',
      recommendedProducts: 'Recommended for you'
    },
    th: {
      modalTitle: 'การทดสอบสุขภาพ', testId: 'รหัสทดสอบ',
      firstName: 'ชื่อ', lastName: 'นามสกุล',
      gender: 'เพศ', selectGender: 'เลือกเพศ',
      male: 'ชาย', female: 'หญิง',
      email: 'อีเมล', phone: 'เบอร์โทรศัพท์',
      birthdate: 'วันเกิด',
      month: 'เดือน', day: 'วัน', year: 'ปี',
      months: ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.'],
      language: 'ภาษาของรายงาน', english: 'อังกฤษ', thai: 'ไทย',
      saving: 'กำลังบันทึก…', save: 'บันทึก',
      testIdLabel: 'รหัสทดสอบ:', on: 'วันที่', downloadPdf: 'ดาวน์โหลด PDF',
      requiredFields: 'กรุณากรอกข้อมูลให้ครบถ้วน',
      alreadyRegistered: 'รหัสทดสอบนี้ถูกลงทะเบียนแล้ว',
      testIdNotFound: 'ไม่พบรหัสทดสอบ',
      savedSuccess: 'บันทึกการทดสอบสุขภาพสำเร็จแล้ว',
      noTests: 'ยังไม่มีการตรวจสุขภาพ',
      recommendedProducts: 'แนะนำสำหรับคุณ'
    }
  };
  function getWT() { return wT[IS_TH ? 'th' : 'en']; }

  function formatWellnessTestId(val) {
    var clean = val.replace(/[^A-Z0-9]/gi, '').toUpperCase();
    var formatted;
    if (clean.length > 8) formatted = clean.slice(0, 4) + '-' + clean.slice(4, 8);
    else if (clean.length > 4) formatted = clean.slice(0, 4) + '-' + clean.slice(4);
    else formatted = clean;
    return formatted.slice(0, 9);
  }
  function customerNumericId() {
    if (!customer || !customer.id) return '';
    var s = String(customer.id);
    var m = s.match(/\/(\d+)(?:[?#].*)?$/);
    return m ? m[1] : s;
  }

  // Build a Shopify-style `customers/create` webhook payload from the
  // current customer object. Used to bootstrap the user in the wellness
  // backend when /user-tests/shopify says "user not found".
  function buildShopifyCustomerWebhookPayload() {
    if (!customer) return null;
    var numericIdStr = customerNumericId();
    var idNum = parseInt(numericIdStr, 10);
    if (!idNum || isNaN(idNum)) idNum = null;

    function toShopifyAddress(a, isDefault) {
      if (!a) return null;
      return {
        id: a.id ? parseInt(String(a.id).match(/\/(\d+)/) ? String(a.id).match(/\/(\d+)/)[1] : a.id, 10) || null : null,
        customer_id: idNum,
        first_name: a.firstName || '',
        last_name:  a.lastName  || '',
        company: null,
        address1: a.address1 || '',
        address2: a.address2 || '',
        city:     a.city     || '',
        province: a.province || '',
        country:  a.country  || '',
        zip:      a.zip      || '',
        phone:    a.phone    || '',
        name: ((a.firstName || '') + ' ' + (a.lastName || '')).trim(),
        province_code: null,
        country_code: null,
        country_name: a.country || '',
        default: !!isDefault
      };
    }

    var defaultAddr = customer.defaultAddress
      ? toShopifyAddress(customer.defaultAddress, true)
      : null;
    var addresses = (customer.addresses || []).map(function (a) {
      var isDef = !!(customer.defaultAddress && a.id === customer.defaultAddress.id);
      return toShopifyAddress(a, isDef);
    });
    var subscribed = customer.emailMarketingState === 'SUBSCRIBED';

    return {
      id: idNum,
      email: customer.email || '',
      accepts_marketing: subscribed,
      created_at: customer.creationDate || null,
      updated_at: customer.creationDate || null,
      first_name: customer.firstName || '',
      last_name:  customer.lastName  || '',
      orders_count: 0,
      state: 'enabled',
      total_spent: '0.00',
      last_order_id: null,
      note: null,
      verified_email: true,
      multipass_identifier: null,
      tax_exempt: false,
      phone: customer.phone || null,
      tags: '',
      last_order_name: null,
      currency: 'THB',
      addresses: addresses,
      accepts_marketing_updated_at: null,
      marketing_opt_in_level: subscribed ? 'single_opt_in' : null,
      tax_exemptions: [],
      admin_graphql_api_id: numericIdStr ? ('gid://shopify/Customer/' + numericIdStr) : null,
      default_address: defaultAddr
    };
  }

  // Posts the Shopify customer.create webhook payload to the Vitals backend
  // so it can provision the user. Returns a Promise<boolean> indicating
  // whether the call succeeded.
  function notifyVitalsCustomerCreated() {
    var payload = buildShopifyCustomerWebhookPayload();
    if (!payload) return Promise.resolve(false);
    return fetch(WELLNESS_API + '/auth/api/v1/webhook/shopify/customer-created', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return !!r.ok; })
      .catch(function (err) {
        console.error('[wellness] customer-created webhook failed:', err);
        return false;
      });
  }

  // Detects "user not found" from either an HTTP 404 or a 200 with an error
  // body. Returns the parsed tests array on success; throws on other errors.
  function fetchUserTests() {
    var url = WELLNESS_API + '/api/v1/user/wellness-test/list';
    return fetch(url, { credentials: 'include' }).then(function (r) {
      if (r.status === 404) {
        var err = new Error('User not found'); err.userNotFound = true; throw err;
      }
      if (!r.ok) throw new Error('Wellness API ' + r.status);
      return r.json().then(function (body) {
        // Response shape: { success, data: [ ...tests ], message }.
        var data = body && body.data;
        // Some backends return 200 with a "user not found" message — handle both.
        if (!Array.isArray(data)) {
          var msg = String((body && (body.error || body.message)) || '').toLowerCase();
          if (msg.indexOf('not found') !== -1) {
            var err = new Error('User not found'); err.userNotFound = true; throw err;
          }
        }
        return Array.isArray(data) ? data : [];
      });
    });
  }

  function renderWellness() {
    var t = getWT();
    var container = document.getElementById('pp-wellness-' + sid);
    if (!container || !customer) return;
    container.innerHTML = '<div class="pp-loader"><div class="pp-spinner"></div></div>';

    fetchUserTests()
      .catch(function (err) {
        if (err && err.userNotFound) {
          // First time this customer hits the wellness backend — bootstrap
          // them via the customer-created webhook, then retry once.
          return notifyVitalsCustomerCreated().then(function (ok) {
            if (!ok) return [];
            return fetchUserTests().catch(function () { return []; });
          });
        }
        throw err;
      })
      .then(function (tests) {
        wellnessTestsCache = Array.isArray(tests) ? tests : [];
        // Sort latest first
        wellnessTestsCache.sort(function (a, b) {
          return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
        });
        renderHeroStatus();
        renderStatTiles();
        renderWellnessBanner();
        renderTestHistory();
        renderProtocol();
        renderProfileRecommended();
      })
      .catch(function (err) {
        wellnessTestsCache = [];
        renderHeroStatus();
        renderStatTiles();
        renderWellnessBanner();
        console.error('[Wellness] tests fetch failed:', err);
        container.innerHTML = '<p class="pp-empty">' + (IS_TH ? 'ไม่สามารถโหลดข้อมูลได้' : 'Failed to load wellness data.') + '</p>';
      });
  }

  function renderTestHistory() {
    var t = getWT();
    var container = document.getElementById('pp-wellness-' + sid);
    if (!container) return;
    var tests = wellnessTestsCache || [];
    if (!tests.length) {
      container.innerHTML = '<p class="pp-empty">' + t.noTests + '</p>';
      return;
    }
    container.innerHTML = '<div class="pp-wt-list">' + tests.map(function (test) {
      var dateStr = test.createdAt ? new Date(test.createdAt).toLocaleDateString(IS_TH ? 'th-TH' : 'en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
      var status = (test.status || '').toUpperCase().replace(/_/g, ' ');
      return '<div class="pp-wt">' +
        '<div class="pp-wt__row">' +
          '<div class="pp-wt__info">' +
            '<span class="pp-wt__id">' + escapeHtml(test.testId || '') + '</span>' +
            (status ? '<span class="pp-wt__badge">' + escapeHtml(status) + '</span>' : '') +
            (dateStr ? '<span class="pp-wt__date">' + t.on + ' ' + dateStr + '</span>' : '') +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('') + '</div>';
  }

  // ── Blood Test tab ──────────────────────────────────────
  // Backend: GET {WELLNESS_API}/api/v1/user/blood-test/list → { data: { tests: [...] } }.
  // Cookie-authenticated like the wellness list (credentials: include).
  var bloodTestsCache = null;

  function fetchBloodTests() {
    var url = WELLNESS_API + '/api/v1/user/blood-test/list';
    return fetch(url, { credentials: 'include', headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (r.status === 404) return { data: { tests: [] } };
        if (!r.ok) throw new Error('Blood test API ' + r.status);
        return r.json();
      })
      .then(function (body) {
        var data = body && body.data;
        var tests = (data && data.tests) || (Array.isArray(data) ? data : []);
        return Array.isArray(tests) ? tests : [];
      });
  }

  function btDate(iso) {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleDateString(IS_TH ? 'th-TH' : 'en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch (_) { return ''; }
  }

  // Map a raw backend status to a display label + one of the existing
  // pp-pill-status colour classes (delivered/upcoming = green, pending = amber,
  // canceled/other = grey).
  function btStatus(raw) {
    var s = String(raw || '').toLowerCase();
    var cls = 'other';
    if (s.indexOf('cancel') !== -1) cls = 'canceled';
    else if (s.indexOf('complete') !== -1 || s.indexOf('report') !== -1 || s.indexOf('ready') !== -1 || s.indexOf('deliver') !== -1) cls = 'delivered';
    else if (s.indexOf('confirm') !== -1 || s.indexOf('schedul') !== -1 || s.indexOf('book') !== -1) cls = 'upcoming';
    else if (s.indexOf('pending') !== -1 || s.indexOf('await') !== -1 || s.indexOf('process') !== -1 || s.indexOf('request') !== -1) cls = 'pending';
    var thMap = {
      appointment_confirmed: 'ยืนยันนัดหมายแล้ว',
      pending: 'รอดำเนินการ',
      processing: 'กำลังดำเนินการ',
      completed: 'เสร็จสมบูรณ์',
      report_ready: 'รายงานพร้อมแล้ว',
      cancelled: 'ยกเลิก',
      canceled: 'ยกเลิก'
    };
    var label = (IS_TH && thMap[s]) ? thMap[s]
      : String(raw || '').replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    return { label: label || (IS_TH ? 'ไม่ทราบสถานะ' : 'Unknown'), cls: cls };
  }

  function renderBloodTestBanner() {
    var cap = document.getElementById('pp-bt-cap-' + sid);
    var title = document.getElementById('pp-bt-title-' + sid);
    var sub = document.getElementById('pp-bt-sub-' + sid);
    var report = document.getElementById('pp-bt-report-' + sid);
    if (!cap || !title || !sub) return;
    var tests = bloodTestsCache || [];
    if (!tests.length) {
      cap.textContent = IS_TH ? 'ตรวจเลือด' : 'Blood tests';
      title.textContent = IS_TH ? 'ยังไม่มีการตรวจเลือด' : 'No blood tests yet';
      sub.textContent = IS_TH ? 'จองการตรวจเลือดครั้งแรกของคุณเพื่อเริ่มต้น' : 'Book your first blood test to get started.';
      if (report) report.style.display = 'none';
      return;
    }
    var latest = tests[0];
    var st = btStatus(latest.status);
    var when = btDate(latest.appointmentDate || latest.createdDate);
    cap.textContent = IS_TH ? 'ผลตรวจล่าสุด' : 'Latest panel';
    title.textContent = latest.testTypeName || (IS_TH ? 'การตรวจเลือด' : 'Blood test');
    sub.textContent = st.label + (when ? ' · ' + when : '');
    if (report) {
      if (latest.reportUrl) {
        report.href = latest.reportUrl;
        report.style.display = '';
      } else {
        report.style.display = 'none';
      }
    }
  }

  function renderBloodTestHistory() {
    var container = document.getElementById('pp-bt-list-' + sid);
    if (!container) return;
    var tests = bloodTestsCache || [];
    if (!tests.length) {
      container.innerHTML = '<p class="pp-empty">' + (IS_TH ? 'ยังไม่มีการตรวจเลือด' : 'No blood tests yet.') + '</p>';
      return;
    }
    container.innerHTML = '<div class="pp-wt-list">' + tests.map(function (test) {
      var st = btStatus(test.status);
      var dateStr = btDate(test.appointmentDate || test.createdDate);
      var apptLine = '';
      if (test.appointmentDate || test.appointmentTime) {
        var ad = btDate(test.appointmentDate);
        var at = test.appointmentTime ? escapeHtml(test.appointmentTime) : '';
        var pieces = [ad, at].filter(Boolean).join(' · ');
        if (pieces) {
          apptLine = '<div class="pp-wt__sub">' +
            '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>' +
            '<span>' + (IS_TH ? 'นัดหมาย' : 'Appointment') + ': ' + pieces + '</span>' +
          '</div>';
        }
      }
      return '<div class="pp-wt">' +
        '<div class="pp-wt__row">' +
          '<div class="pp-wt__info">' +
            '<span class="pp-wt__id">' + escapeHtml(test.testTypeName || '') + '</span>' +
            (test.testId ? '<span class="pp-wt__date">' + escapeHtml(test.testId) + (dateStr ? ' · ' + dateStr : '') + '</span>' : (dateStr ? '<span class="pp-wt__date">' + dateStr + '</span>' : '')) +
          '</div>' +
          '<div class="pp-wt__actions">' +
            '<span class="pp-pill-status pp-pill-status--' + st.cls + '">' + escapeHtml(st.label) + '</span>' +
            (test.reportUrl
              ? '<a class="pp-btn pp-btn--ghost pp-btn--sm" href="' + escapeHtml(test.reportUrl) + '" target="_blank" rel="noopener">' + (IS_TH ? 'ดูรายงาน' : 'View report') + '</a>'
              : '') +
          '</div>' +
        '</div>' +
        apptLine +
      '</div>';
    }).join('') + '</div>';
  }

  // One bundle group per blood panel that carries recommendations, newest first.
  // The list endpoint returns the field camelCased (`recommendedProducts`), like the rest of
  // the blood-test payload (`reportUrl`, `appointmentDate`); the snake_case read is a legacy
  // fallback. Entries are Shopify product ids, not SKUs.
  function bloodTestRecoGroups(tests) {
    var groups = [];
    for (var i = 0; i < tests.length; i++) {
      var test = tests[i];
      var recs = test && (test.recommendedProducts || test.recommended_products);
      if (!Array.isArray(recs) || !recs.length) continue;
      var ids = [], seen = {};
      for (var j = 0; j < recs.length; j++) {
        var pid = numericProductId(extractRecoProductId(recs[j]));
        if (pid && !seen[pid]) { seen[pid] = true; ids.push(pid); }
      }
      if (!ids.length) continue;
      groups.push({
        key: 'bt-' + groups.length,
        label: test.testTypeName || test.testId || (IS_TH ? 'ผลตรวจเลือด' : 'Blood panel'),
        dateStr: btDate(test.appointmentDate || test.createdDate),
        pdfUrl: test.reportUrl || '',
        ids: ids
      });
    }
    return groups;
  }

  // "Recommended for you" on the Blood Test tab: one subscription bundle per panel that
  // carries recommendations, resolved from Shopify product ids against the Storefront catalog.
  function renderBloodTestProtocol() {
    var section = document.getElementById('pp-bt-protocol-section-' + sid);
    var host    = document.getElementById('pp-bt-protocol-grid-' + sid);
    var sub     = document.getElementById('pp-bt-protocol-sub-' + sid);
    if (!section || !host) return;
    var tests    = bloodTestsCache || [];
    var groups   = bloodTestRecoGroups(tests);
    var oosId    = 'pp-bt-protocol-oos-' + sid;
    var addAllId = 'pp-bt-protocol-addall-' + sid;
    // Each bundle carries its own add button now, so the section-level one stays hidden.
    bindAddAllToCart(addAllId, []);
    // No report carries recommendations yet — that's an empty state, not an out-of-stock one.
    if (!groups.length) {
      hideProtocolOos(oosId);
      mountBundles(host, []);
      section.style.display = 'none';
      return;
    }
    section.style.display = '';
    hideProtocolOos(oosId);
    host.innerHTML = '<div class="pp-loader"><div class="pp-spinner"></div></div>';
    var allIds = [], seenId = {};
    groups.forEach(function (g) {
      g.ids.forEach(function (pid) { if (!seenId[pid]) { seenId[pid] = true; allIds.push(pid); } });
    });
    fetchProductsByIds(allIds)
      .then(function (products) {
        // A panel that recommends the next panel: the test is not part of the supplement bundle, and
        // the out-of-stock copy below is judged on what is left once the tests are out.
        var usable = dropTestProducts(products);
        var byId = {};
        buyableOnly(usable).forEach(function (p) { byId[p.pid] = p; });
        var ready = groups.filter(function (g) {
          g.products = g.ids.map(function (pid) { return byId[pid]; }).filter(Boolean);
          return g.products.length;
        });
        if (!ready.length) {
          mountBundles(host, []);
          if (sub) sub.textContent = '';
          showProtocolOos(oosId, usable.length ? 'sold-out' : 'unavailable');
          return;
        }
        if (sub) {
          sub.textContent = IS_TH
            ? (ready.length + ' ผลตรวจที่มีคำแนะนำ')
            : (ready.length + (ready.length === 1 ? ' panel with recommendations' : ' panels with recommendations'));
        }
        hideProtocolOos(oosId);
        mountBundles(host, ready);
      })
      .catch(function (err) {
        console.error('[BloodTest] recommended products fetch failed:', err);
        mountBundles(host, []);
        if (sub) sub.textContent = '';
        section.style.display = '';
        showProtocolOos(oosId, 'unavailable');
      });
  }

  function renderBloodTests() {
    var container = document.getElementById('pp-bt-list-' + sid);
    if (!container || !customer) return;
    if (bloodTestsCache) { renderBloodTestBanner(); renderBloodTestHistory(); renderBloodTestProtocol(); return; }
    container.innerHTML = '<div class="pp-loader"><div class="pp-spinner"></div></div>';
    fetchBloodTests()
      .then(function (tests) {
        bloodTestsCache = (Array.isArray(tests) ? tests : []).slice().sort(function (a, b) {
          return new Date(b.createdDate || b.appointmentDate || 0) - new Date(a.createdDate || a.appointmentDate || 0);
        });
        renderBloodTestBanner();
        renderBloodTestHistory();
        renderBloodTestProtocol();
      })
      .catch(function (err) {
        console.error('[BloodTest] fetch failed:', err);
        bloodTestsCache = null;
        renderBloodTestBanner();
        container.innerHTML = '<p class="pp-empty">' + (IS_TH ? 'ไม่สามารถโหลดข้อมูลการตรวจเลือดได้' : 'Failed to load blood tests.') + '</p>';
      });
  }

  // `quantityAvailable` needs the unauthenticated_read_product_inventory scope. A token without
  // it makes the Storefront API reject the whole query, which would blank the wellness tab — so
  // the field is requested optionally and gqlStock() drops it for good on the first refusal.
  var stockFieldOk = true;
  function stockField() { return stockFieldOk ? ' quantityAvailable' : ''; }

  // Runs a query that asks for `quantityAvailable`; on an access-denied error it turns the field
  // off and replays once. Everything downstream then just sees stock: null ("unknown").
  function gqlStock(build, variables) {
    return gql(build(), variables).then(function (d) {
      var denied = stockFieldOk && (d.errors || []).some(function (e) {
        return /quantityAvailable|inventory/i.test((e && e.message) || '');
      });
      if (!denied) return d;
      console.warn('[Bundle] quantityAvailable unavailable to this token — stock checks disabled.');
      stockFieldOk = false;
      return gql(build(), variables);
    });
  }

  function qWellnessProducts() {
    return 'query($q:String!,$mfIds:[HasMetafieldsIdentifier!]!){' +
      'products(first:100,query:$q){' +
        'edges{node{' +
          'id title handle vendor productType' +
          ' featuredImage{url altText}' +
          ' priceRange{minVariantPrice{amount currencyCode}}' +
          ' metafields(identifiers:$mfIds){key value}' +
          ' variants(first:5){edges{node{id sku availableForSale' + stockField() + ' price{amount currencyCode}}}}' +
        '}}' +
      '}' +
    '}';
  }

  // Catalog variant SKUs carry no variant suffix — "VT-101389" is the real SKU, and searching
  // for "VT-101389-01" returns nothing. Recommendations arrive in both forms, so drop the suffix.
  function wellnessSkuForLookup(sku) {
    return String(sku || '').trim().replace(/-\d{2}$/, '');
  }
  // Suffix-insensitive key, so a variant answers to the recommendation whichever form it's
  // stored under. Comparing the raw strings would miss whenever the two spellings disagree.
  function skuKey(sku) { return String(sku || '').trim().toUpperCase().replace(/-\d{2}$/, ''); }
  function extractWellnessSku(p) {
    // New API returns recommended_products as an array of SKU strings.
    if (typeof p === 'string') return p;
    if (!p || typeof p !== 'object') return '';
    var doc = p.document;
    if (typeof doc === 'string') return doc;
    if (doc && typeof doc === 'object') {
      if (typeof doc.sku === 'string')  return doc.sku;
      if (typeof doc.SKU === 'string')  return doc.SKU;
      if (typeof doc.id === 'string')   return doc.id;
      if (typeof doc.name === 'string') return doc.name;
    }
    return '';
  }
  function fetchWellnessProducts(skus) {
    var wanted = {};
    skus.forEach(function (sku) { wanted[skuKey(sku)] = true; });
    // Bare terms, NOT "sku:<value>". The field-scoped form splits the SKU on its hyphens and
    // matches every product carrying a "VT" token (7 SKUs → 84 results), while a bare term hits
    // the variant SKU exactly. The per-variant check below still guards against stray matches.
    var q = skus.map(function (sku) { return sku; }).join(' OR ');
    return gqlStock(qWellnessProducts, { q: q, mfIds: BUNDLE_MF_IDS }).then(function (d) {
      if (d.errors) console.error('[Wellness] products errors:', d.errors);
      var edges = (((d.data || {}).products || {}).edges || []);
      var bySku = {};
      edges.forEach(function (e) {
        var node = e.node;
        var ves = (node.variants && node.variants.edges) || [];
        var bundle = parseBundleMeta(node);
        for (var i = 0; i < ves.length; i++) {
          var ve = ves[i].node;
          var key = skuKey(ve.sku);
          // Drop anything the search matched loosely — only a variant whose SKU was actually
          // recommended earns a card, and it's that variant that goes in the cart.
          if (!wanted[key] || bySku[key]) continue;
          var money = productPriceParts(ve.price, node.priceRange);
          bySku[key] = {
            id: node.id, pid: numericProductId(node.id), sku: ve.sku || '',
            title: node.title, handle: node.handle, vendor: node.vendor || '',
            productType: node.productType || '',
            featuredImage: node.featuredImage,
            priceRange: ve.price ? { minVariantPrice: ve.price } : node.priceRange,
            priceAmount: money.priceAmount, currency: money.currency,
            bundle: bundle,
            variantId: ve.id, available: !!ve.availableForSale, stock: variantStock(ve)
          };
        }
      });
      // Return them in the order they were recommended (newest report's picks first).
      return skus.map(function (sku) { return bySku[skuKey(sku)]; }).filter(Boolean);
    });
  }

  // Blood-test reports send `recommended_products` as Shopify product IDs (the wellness list sends
  // SKUs), so they resolve through an exact `nodes(ids:)` lookup instead of a `sku:` search.
  function qProductsByIds() {
    return 'query($ids:[ID!]!,$mfIds:[HasMetafieldsIdentifier!]!){' +
      'nodes(ids:$ids){ ... on Product {' +
        'id title handle vendor productType' +
        ' featuredImage{url altText}' +
        ' priceRange{minVariantPrice{amount currencyCode}}' +
        ' metafields(identifiers:$mfIds){key value}' +
        ' variants(first:1){edges{node{id availableForSale' + stockField() + ' price{amount currencyCode}}}}' +
      '} }' +
    '}';
  }

  // Numeric Shopify id → product GID; already-qualified GIDs pass through.
  function toProductGid(id) {
    var s = String(id || '').trim();
    if (s.indexOf('gid://') === 0) return s;
    var m = s.match(/(\d+)\s*$/);
    return m ? ('gid://shopify/Product/' + m[1]) : s;
  }

  // Pull the product id out of a recommended_products entry (bare id, or an object carrying it).
  function extractRecoProductId(p) {
    if (typeof p === 'string' || typeof p === 'number') return String(p);
    if (!p || typeof p !== 'object') return '';
    var doc = p.document && typeof p.document === 'object' ? p.document : {};
    var id = p.id != null ? p.id
      : (p.product_id != null ? p.product_id
      : (p.productId != null ? p.productId
      : (p.shopify_product_id != null ? p.shopify_product_id : doc.id)));
    return id != null ? String(id) : '';
  }

  function fetchProductsByIds(ids) {
    var gids = ids.map(toProductGid).filter(Boolean);
    if (!gids.length) return Promise.resolve([]);
    return gqlStock(qProductsByIds, { ids: gids, mfIds: BUNDLE_MF_IDS }).then(function (d) {
      if (d.errors) console.error('[BloodTest] products errors:', d.errors);
      var nodes = ((d.data || {}).nodes || []);
      return nodes.filter(function (n) { return n && n.handle; }).map(function (node) {
        var ve = node.variants && node.variants.edges[0] && node.variants.edges[0].node;
        var money = productPriceParts(ve && ve.price, node.priceRange);
        return {
          id: node.id, pid: numericProductId(node.id), sku: '',
          title: node.title, handle: node.handle, vendor: node.vendor || '',
          productType: node.productType || '',
          featuredImage: node.featuredImage, priceRange: node.priceRange,
          priceAmount: money.priceAmount, currency: money.currency,
          bundle: parseBundleMeta(node),
          variantId: ve ? ve.id : '', available: !!(ve && ve.availableForSale), stock: variantStock(ve)
        };
      });
    });
  }

  // Out-of-stock notice under a protocol grid (rendered hidden by snippets/profile-oos-banner.liquid).
  // `reason` picks the copy: 'sold-out' when the products resolved but none can be bought,
  // 'unavailable' when the report's recommendations resolve to no catalog product at all.
  // The sold-out wording is the snippet's own, stashed on first use so it can be restored.
  function showProtocolOos(bannerId, reason) {
    var el = document.getElementById(bannerId);
    if (!el) return;
    var title = document.getElementById(bannerId + '-title');
    var text  = document.getElementById(bannerId + '-text');
    if (title && el.dataset.soldOutTitle == null) el.dataset.soldOutTitle = title.textContent;
    if (text  && el.dataset.soldOutText  == null) el.dataset.soldOutText  = text.textContent;
    if (reason === 'unavailable') {
      if (title) title.textContent = IS_TH
        ? 'สินค้าที่แนะนำยังไม่พร้อมจำหน่าย'
        : 'Your recommendations aren\u2019t available';
      if (text) text.textContent = IS_TH
        ? 'ขณะนี้เรายังไม่พบสินค้าที่จับคู่กับผลตรวจของคุณในร้าน ทีมงานของเราช่วยแนะนำทางเลือกอื่นให้คุณได้'
        : 'We couldn\u2019t find the products matched to your results in the store right now. Our team can suggest an alternative in the meantime.';
    } else {
      if (title && el.dataset.soldOutTitle != null) title.textContent = el.dataset.soldOutTitle;
      if (text  && el.dataset.soldOutText  != null) text.textContent  = el.dataset.soldOutText;
    }
    el.style.display = '';
  }
  function hideProtocolOos(bannerId) {
    var el = document.getElementById(bannerId);
    if (el) el.style.display = 'none';
  }
  // Sold-out products are dropped from the protocol grids — a recommendation you can't buy
  // is noise. When the filter empties the grid, the out-of-stock notice takes its place.
  // Out-of-stock products are left out of recommendations entirely. `available` alone isn't
  // enough: a variant set to keep selling at zero stock still reports availableForSale, but the
  // cart can't take any of it, so the bundle would quote a price checkout never charges.
  function buyableOnly(products) {
    return products.filter(function (p) {
      return p.available && p.variantId && (p.stock == null || p.stock > 0);
    });
  }

  // The three Vitals hair tests, by handle. Their Longevity counterparts are matched by id
  // (BLOOD_TEST_PRODUCT_IDS). Both lists are now only a backstop behind the product-type check
  // below — they stay because a product with a blank productType would otherwise slip through.
  // Keep the handles in sync with TIER_PRESETS in
  // vitals-mobile-react/src/modules/VitalsTests/dtos/vitalsTest.dto.ts.
  var WELLNESS_TEST_HANDLES = [
    'vitals-core-wellness-test-100',
    'vitals-advanced-wellness-test-400',
    'vitals-ultra-wellness-test-700'
  ];

  // Every test in the catalog carries a "Test - …" product type ("Test - Hair" for the wellness
  // kits, "Test - Blood" for Longevity); supplements are "Supplement - …" or "Beauty Supplement".
  // Matching the type is what keeps a NEW test out of the bundles — the handle/id lists above only
  // ever covered the six products that existed when they were written, so anything added later
  // would have been priced into a subscription bundle as if it were a supplement.
  function isTestProductType(t) {
    return /^test\b/i.test(String(t == null ? '' : t).trim());
  }

  // Reports sometimes recommend the next test alongside the supplements. A test is booked or
  // registered, never restocked monthly — and a blood test can't be added to the cart at all — so it
  // is dropped from the recommendations rather than priced into a subscription bundle.
  function isTestProduct(p) {
    return isTestProductType(p && p.productType) ||
           BLOOD_TEST_PRODUCT_IDS.indexOf(String((p && p.pid) || '')) !== -1 ||
           WELLNESS_TEST_HANDLES.indexOf(String((p && p.handle) || '')) !== -1;
  }
  function dropTestProducts(products) {
    return products.filter(function (p) { return !isTestProduct(p); });
  }

  // ── Subscription bundles ────────────────────────────────
  // Recommended products are offered per test / panel / consultation as a bundle the
  // customer sizes themselves: pick a subscription length, and each product's pack
  // count comes from its own Shopify metafields —
  //   quantity_per_pack · quantity_unit · estimated_monthly_quantity · calculation_enabled
  // A product that opts out of the calculation, or carries unusable numbers, falls back to
  // one pack per month — the quantity still has to follow the length the customer picked.
  var BUNDLE_MONTHS = [1, 3, 6];
  var BUNDLE_MONTHS_DEFAULT = 3;
  // Bulk discount per length. Checkout charges it through a Shopify discount code that Add to
  // Cart applies to the cart, so each code must exist in Shopify admin at the same percentage —
  // otherwise the card quotes a price checkout won't honour.
  var BUNDLE_DISCOUNTS = { 3: { pct: 10, code: 'BULK3' }, 6: { pct: 15, code: 'BULK6' } };
  function bundleDiscount(m) { return BUNDLE_DISCOUNTS[m] || null; }
  function bundleDiscounted(amount, m) {
    var d = bundleDiscount(m);
    return d ? Math.round(amount * (100 - d.pct)) / 100 : amount;
  }
  // Upper bound for the per-item stepper when Shopify hasn't told us the real stock.
  var BUNDLE_QTY_MAX = 99;
  var BUNDLE_MF_KEYS = ['quantity_per_pack', 'quantity_unit', 'estimated_monthly_quantity', 'calculation_enabled'];
  var BUNDLE_MF_IDS = BUNDLE_MF_KEYS.map(function (k) {
    return { namespace: bundleMfNamespace, key: k };
  });
  // groupKey -> { key, label, dateStr, months, products }. Survives a re-render so the
  // length the customer picked isn't reset when the panel repaints.
  var bundleGroups = {};

  // Storefront hands back every metafield value as a string, and `identifiers` returns a
  // null slot for each key the product doesn't carry — so both are tolerated here rather
  // than in calculatePacks().
  function parseBundleMeta(node) {
    var out = { enabled: false, perPack: 0, monthly: 0, unit: '' };
    var list = (node && node.metafields) || [];
    for (var i = 0; i < list.length; i++) {
      var mf = list[i];
      if (!mf || !mf.key) continue;
      var v = mf.value;
      if (mf.key === 'quantity_per_pack')             out.perPack = Number(v);
      else if (mf.key === 'estimated_monthly_quantity') out.monthly = Number(v);
      else if (mf.key === 'quantity_unit')              out.unit    = String(v == null ? '' : v).trim();
      else if (mf.key === 'calculation_enabled')        out.enabled = (v === true || v === 'true' || v === '1');
    }
    return out;
  }

  // Storefront only returns `quantityAvailable` when the shop exposes inventory to the
  // Storefront API. A null (no scope, or inventory untracked) means "unknown", NOT zero —
  // every caller has to treat it as "send what the customer asked for and let Shopify judge".
  function variantStock(ve) {
    var n = ve ? ve.quantityAvailable : null;
    return typeof n === 'number' && isFinite(n) ? Math.max(0, n) : null;
  }

  // Shopify ids arrive as GIDs here but cart.js reports bare numbers.
  function numericVariantId(raw) {
    var n = parseInt(String(raw == null ? '' : raw).split('/').pop(), 10);
    return n > 0 ? n : 0;
  }

  // variantId -> quantity already in the cart. Used both to clamp the request and to work
  // out, after the fact, how much of the bundle actually landed.
  function cartQtyByVariant(cart) {
    var map = {};
    var lines = (cart && cart.items) || [];
    for (var i = 0; i < lines.length; i++) {
      var id = numericVariantId(lines[i].variant_id || lines[i].id);
      if (id) map[id] = (map[id] || 0) + (Number(lines[i].quantity) || 0);
    }
    return map;
  }

  // packs = ceil(months × estimated_monthly_quantity ÷ quantity_per_pack), never below 1.
  // The epsilon stops a clean division from rounding up (3.0000000004 → 4).
  function calculatePacks(product, months) {
    var b = (product && product.bundle) || {};
    var enabled = b.enabled === true;
    var perPack = Number(b.perPack);
    var monthly = Number(b.monthly);
    var m = Math.max(1, Math.round(Number(months) || 1));
    // Without usable metafields we can't work out consumption, but a 6-month order still
    // has to be bigger than a 3-month one: fall back to a pack a month.
    if (!enabled || !(perPack > 0) || !(monthly > 0)) return m;
    var raw = (months * monthly) / perPack;
    return Math.max(1, Math.ceil(raw - 1e-9));
  }

  // True only when the metafields actually drive the pack count — drives whether the
  // card explains the maths or says the quantity is fixed.
  function bundleCalcActive(product) {
    var b = (product && product.bundle) || {};
    return b.enabled === true && Number(b.perPack) > 0 && Number(b.monthly) > 0;
  }

  // Prefer the recommended variant's own price; fall back to the product's floor.
  function productPriceParts(variantPrice, priceRange) {
    var pv = variantPrice || (priceRange && priceRange.minVariantPrice);
    var amt = pv ? parseFloat(pv.amount) : NaN;
    return { priceAmount: isFinite(amt) ? amt : 0, currency: (pv && pv.currencyCode) || '' };
  }

  // Shopify ids arrive as bare numbers or as GIDs ("gid://shopify/Product/12345").
  function numericProductId(raw) {
    var m = String(raw == null ? '' : raw).trim().match(/(\d+)\s*$/);
    return m ? m[1] : '';
  }

  function bundleKey(raw) {
    return String(raw == null ? '' : raw).replace(/[^A-Za-z0-9_-]/g, '') || 'g';
  }

  // Bundle totals run into five figures, so thousands separators matter here in a way
  // they don't on a single product card.
  function bundleMoney(amount, currency) {
    var n = Number(amount);
    if (!isFinite(n) || n <= 0) return '';
    try {
      return new Intl.NumberFormat(IS_TH ? 'th-TH' : 'en-US', {
        style: 'currency', currency: currency || 'THB', maximumFractionDigits: 2
      }).format(n);
    } catch (_) {
      return n.toFixed(2) + (currency ? ' ' + currency : '');
    }
  }
  function bundleMonthLabel(m) {
    if (IS_TH) return m + ' เดือน';
    return m + (m === 1 ? ' month' : ' months');
  }
  // The selector names plans rather than lengths; the summary row still says "3 months".
  function bundlePlanLabel(m) {
    if (m === 1) return IS_TH ? 'ซื้อครั้งเดียว' : 'One-time';
    if (m === 3) return IS_TH ? 'แผนแนะนำ (3 เดือน)' : 'Recommended Plan (3 months)';
    if (m === 6) return IS_TH ? 'คุ้มที่สุด (6 เดือน)' : 'Best Value (6 months)';
    return bundleMonthLabel(m);
  }
  function bundlePackLabel(n) {
    if (IS_TH) return n + ' แพ็ค';
    return n + (n === 1 ? ' pack' : ' packs');
  }

  // Identity for a line inside a bundle group — the key its manual pack count is stored under.
  function bundleItemKey(p) {
    return String((p && (p.variantId || p.pid || p.handle)) || '');
  }
  // Highest pack count the stepper will go to: real stock when we know it, a flat cap otherwise.
  function bundleQtyMax(p) {
    var stock = p && p.stock;
    if (stock == null) return BUNDLE_QTY_MAX;
    return Math.max(1, Math.min(BUNDLE_QTY_MAX, stock));
  }
  // What this line is actually buying: the customer's own number when they set one, otherwise
  // the count calculated from the subscription length. Overrides are cleared whenever the length
  // changes, so the two never disagree about which months the row is priced for.
  function bundlePackCount(g, p, months) {
    var ov = g && g.qty ? Number(g.qty[bundleItemKey(p)]) : 0;
    if (ov > 0) return Math.min(ov, bundleQtyMax(p));
    return stockedPacks(p, months == null ? (g && g.months) : months);
  }
  // The calculated count, held to real stock when we know it — so a bundle never prices more
  // packs than the cart (and checkout) will accept.
  function stockedPacks(p, months) {
    var packs = calculatePacks(p, months);
    return p && p.stock != null ? Math.max(1, Math.min(packs, p.stock)) : packs;
  }

  function bundleItemHtml(g, p, months) {
    var packs = bundlePackCount(g, p, months);
    var max = bundleQtyMax(p);
    var b = p.bundle || {};
    var unit = b.unit || (IS_TH ? 'หน่วย' : 'units');
    var img = p.featuredImage;
    var imgHtml = img
      ? '<img src="' + escapeHtml(img.url) + '" alt="' + escapeHtml(img.altText || p.title) + '" loading="lazy">'
      : '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/></svg>';
    var each = bundleMoney(p.priceAmount, p.currency);
    var line = bundleMoney(p.priceAmount * packs, p.currency);
    var calc = bundleCalcActive(p)
      ? (IS_TH
          ? (b.perPack + ' ' + unit + ' ต่อแพ็ค · ใช้ราว ' + b.monthly + ' ' + unit + ' ต่อเดือน')
          : (b.perPack + ' ' + unit + ' per pack · ~' + b.monthly + ' ' + unit + ' a month'))
      : (IS_TH ? '1 แพ็คต่อเดือน · ปรับจำนวนได้' : '1 pack a month — adjust if you need to');
    var stepLbl = IS_TH ? 'จำนวนแพ็ค' : 'Packs';
    var addLbl  = p.available
      ? (IS_TH ? 'เพิ่มลงตะกร้า' : 'ADD TO CART')
      : (IS_TH ? 'สินค้าหมด' : 'SOLD OUT');
    return '<div class="pp-bi' + (p.available ? '' : ' pp-bi--oos') + '"' +
      ' data-pp-bi-key="' + escapeHtml(bundleItemKey(p)) + '">' +
      '<div class="pp-bi__img">' +
        (p.handle ? '<a href="/products/' + escapeHtml(p.handle) + '">' + imgHtml + '</a>' : imgHtml) +
      '</div>' +
      '<div class="pp-bi__body">' +
        (p.vendor ? '<span class="pp-bi__vendor">' + escapeHtml(p.vendor) + '</span>' : '') +
        '<div class="pp-bi__title" title="' + escapeHtml(p.title) + '">' + escapeHtml(p.title) + '</div>' +
        '<div class="pp-bi__calc">' + escapeHtml(calc) + '</div>' +
      '</div>' +
      '<div class="pp-bi__end">' +
        '<div class="pp-bi__money">' +
          (each ? '<span class="pp-bi__unit">' + escapeHtml(each) + (IS_TH ? ' / แพ็ค' : ' / pack') + '</span>' : '') +
          (line ? '<span class="pp-bi__price">' + escapeHtml(line) + '</span>' : '') +
        '</div>' +
        '<div class="pp-bi__ctl">' +
          '<div class="pp-bi__qty" role="group" aria-label="' + escapeHtml(stepLbl) + '">' +
            '<button type="button" class="pp-bi__step" data-pp-bi-step="-1"' +
              (packs <= 1 ? ' disabled' : '') +
              ' aria-label="' + escapeHtml(IS_TH ? 'ลดจำนวน' : 'Decrease packs') + '">&minus;</button>' +
            '<span class="pp-bi__qty-n" aria-live="polite">' + packs + '</span>' +
            '<button type="button" class="pp-bi__step" data-pp-bi-step="1"' +
              (packs >= max ? ' disabled' : '') +
              ' aria-label="' + escapeHtml(IS_TH ? 'เพิ่มจำนวน' : 'Increase packs') + '">+</button>' +
          '</div>' +
          '<button type="button" class="pp-bi__add" data-pp-bi-add' +
            (p.available ? '' : ' disabled') + '>' + escapeHtml(addLbl) + '</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function bundleBlockHtml(g) {
    var months = g.months;
    var products = g.products || [];
    var totalPacks = 0, totalAmount = 0, currency = '', buyable = 0;
    for (var i = 0; i < products.length; i++) {
      var packs = bundlePackCount(g, products[i], months);
      totalPacks += packs;
      if (products[i].available) buyable++;
      if (products[i].priceAmount > 0) {
        totalAmount += products[i].priceAmount * packs;
        if (!currency) currency = products[i].currency;
      }
    }
    if (!currency) currency = (products[0] && products[0].currency) || '';

    // Each length prices itself, so the customer compares plans rather than picking one
    // blind. The selected length quotes the real total — manual pack counts and all — while
    // the others quote their calculated size, which is what switching to them would cost.
    var totals = BUNDLE_MONTHS.map(function (m) {
      if (m === months) return totalAmount;
      var amt = 0;
      for (var i = 0; i < products.length; i++) {
        if (products[i].priceAmount > 0) amt += products[i].priceAmount * stockedPacks(products[i], m);
      }
      return amt;
    });
    var opts = BUNDLE_MONTHS.map(function (m, idx) {
      var on = m === months;
      var amt = bundleDiscounted(totals[idx], m);
      var off = bundleDiscount(m);
      return '<button type="button" class="pp-bundle__m' + (on ? ' is-active' : '') + '"' +
        ' data-pp-bundle-m="' + m + '" role="radio" aria-checked="' + (on ? 'true' : 'false') + '">' +
        '<span class="pp-bundle__m-dot" aria-hidden="true"></span>' +
        '<span class="pp-bundle__m-lbl">' + escapeHtml(bundlePlanLabel(m)) +
          (off ? '<span class="pp-bundle__m-off">−' + off.pct + '%</span>' : '') + '</span>' +
        (amt > 0 ? '<span class="pp-bundle__m-amt">' + escapeHtml(bundleMoney(amt, currency)) + '</span>' : '') +
        '</button>';
    }).join('');

    var countTxt = IS_TH
      ? (products.length + ' รายการ')
      : (products.length + (products.length === 1 ? ' product' : ' products'));
    // The bar tracks what can actually be bought today, so a sold-out line is visible
    // in the summary rather than only as a greyed-out row further up.
    var allIn = buyable === products.length && products.length > 0;
    var availTxt = allIn
      ? (IS_TH
          ? ('พร้อมจำหน่ายทั้งหมด · ' + bundlePackLabel(totalPacks))
          : ('All ' + products.length + ' available · ' + bundlePackLabel(totalPacks)))
      : (IS_TH
          ? ('พร้อมจำหน่าย ' + buyable + ' จาก ' + products.length + ' รายการ')
          : (buyable + ' of ' + products.length + ' available'));
    var pct = products.length ? Math.round((buyable / products.length) * 100) : 0;
    var disc = bundleDiscount(months);
    var payAmount = bundleDiscounted(totalAmount, months);
    var perDay = (payAmount > 0 && months > 0) ? payAmount / (months * 30) : 0;
    var addLabel = payAmount > 0
      ? ((IS_TH ? 'เพิ่มลงตะกร้า · ' : 'ADD TO CART · ') + bundleMoney(payAmount, currency))
      : (IS_TH ? 'เพิ่มลงตะกร้า' : 'ADD TO CART');
    // Installments are chosen on Omise's page, which checkout can't pre-select, so the hint
    // tells the customer which payment option to pick there.
    var instHtml = (payAmount >= installmentMin && buyable > 0)
      ? '<button type="button" class="pp-btn pp-btn--ghost pp-bulk__inst" data-pp-bundle-inst>' +
          escapeHtml((IS_TH ? 'ผ่อนชำระ · ' : 'Pay in installments · ') + bundleMoney(payAmount, currency)) +
        '</button>' +
        '<p class="pp-bulk__inst-hint">' +
          escapeHtml(IS_TH
            ? 'ที่หน้าชำระเงิน เลือก "QR Prompt Pay, Bank Apps, Alipay" กด ชำระเงิน แล้วเลือก ผ่อนชำระ'
            : 'At checkout choose "QR Prompt Pay, Bank Apps, Alipay", tap Pay now, then Installment.') +
        '</p>'
      : '';

    // The report these recommendations came from, when the backend has one ready.
    var pdfHtml = g.pdfUrl
      ? '<a class="pp-btn pp-btn--ghost pp-btn--sm pp-bundle__pdf" href="' + escapeHtml(g.pdfUrl) + '" target="_blank" rel="noopener">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 4v11M7 10l5 5 5-5M5 20h14"></path></svg>' +
          (IS_TH ? 'ดาวน์โหลด PDF' : 'Download PDF') +
        '</a>'
      : '';

    return '<div class="pp-bundle" id="pp-bundle-' + g.key + '-' + sid + '" data-pp-bundle-key="' + escapeHtml(g.key) + '">' +
      ((g.label || g.dateStr || pdfHtml)
        ? '<div class="pp-bundle__hd">' +
            '<div class="pp-bundle__src">' +
              (g.label   ? '<span class="pp-bundle__id">'   + escapeHtml(g.label)   + '</span>' : '') +
              (g.dateStr ? '<span class="pp-bundle__date">' + escapeHtml(g.dateStr) + '</span>' : '') +
            '</div>' +
            '<div class="pp-bundle__aux">' +
              '<span class="pp-bundle__count">' + escapeHtml(countTxt) + '</span>' +
              pdfHtml +
            '</div>' +
          '</div>'
        : '') +
      '<div class="pp-bundle__grid">' +
        '<div class="pp-bundle__col">' +
          '<div class="pp-bundle__items">' +
            products.map(function (p) { return bundleItemHtml(g, p, months); }).join('') +
          '</div>' +
          '<div class="pp-bundle__short" data-pp-bundle-short hidden></div>' +
        '</div>' +
        '<aside class="pp-bulk">' +
          bundleTimerHtml() +
          '<p class="pp-bulk__sub">' +
            (IS_TH ? 'สั่งน้อยครั้งลง ไม่มีสะดุดระหว่างคอร์ส' : 'Fewer orders, no gaps in your routine.') +
          '</p>' +
          '<div class="pp-bundle__months" role="radiogroup"' +
            ' aria-label="' + (IS_TH ? 'ระยะเวลาที่ต้องการ' : 'Subscription length') + '">' + opts + '</div>' +
          '<div class="pp-bulk__bar" aria-hidden="true"><span style="width: ' + pct + '%"></span></div>' +
          '<div class="pp-bulk__avail' + (allIn ? '' : ' is-short') + '">' + escapeHtml(availTxt) + '</div>' +
          '<div class="pp-bulk__rows">' +
            '<div class="pp-bulk__row">' +
              '<span>' + escapeHtml(bundlePackLabel(totalPacks) + ' · ' + countTxt) + '</span>' +
              '<span>' + escapeHtml(bundleMonthLabel(months)) + '</span>' +
            '</div>' +
          '</div>' +
          (totalAmount > 0
            ? '<div class="pp-bulk__tot-row">' +
                '<span class="pp-bulk__tot-lbl">' + (IS_TH ? 'รวมทั้งสิ้น' : 'Total') + '</span>' +
                '<span class="pp-bulk__tot">' +
                  (disc ? '<s class="pp-bulk__was">' + escapeHtml(bundleMoney(totalAmount, currency)) + '</s>' : '') +
                  escapeHtml(bundleMoney(payAmount, currency)) +
                '</span>' +
              '</div>' +
              (disc
                ? '<div class="pp-bulk__save">' +
                    escapeHtml((IS_TH ? 'ประหยัด ' : 'You save ') +
                               bundleMoney(totalAmount - payAmount, currency) + ' (' + disc.pct + '%)') +
                  '</div>'
                : '') +
              (perDay > 0
                ? '<div class="pp-bulk__perday">' +
                    escapeHtml((IS_TH ? 'ราว ' : 'about ') + bundleMoney(perDay, currency) +
                               (IS_TH ? ' ต่อวัน' : ' a day')) +
                  '</div>'
                : '')
            : '') +
          '<button type="button" class="pp-btn pp-btn--primary pp-bulk__add" data-pp-bundle-add>' +
            escapeHtml(addLabel) +
          '</button>' +
          instHtml +
        '</aside>' +
      '</div>' +
    '</div>';
  }

  // ── Bundle countdown ────────────────────────────────────
  // A 48h "bulk discount ends in" clock on every bundle card (Wellness and Blood
  // Test tabs). Urgency only — BULK3/BULK6 keep working once it runs out. One clock
  // per account: it starts the first time a bundle is on screen (in the open tab),
  // is kept in this browser under the customer id and is never restarted, so a new
  // device starts its own 48h. Hidden after it expires and inside the mobile app.
  var BUNDLE_TIMER_HOURS = 48;
  var bundleTimerInterval = null;

  // Seconds left, or 0 when the clock hasn't started or has run out. `start`
  // creates the clock if a bundle is visible and none exists yet.
  function bundleTimerLeft(start) {
    var id = customerNumericId();
    if (!id || window.ReactNativeWebView || startedInApp()) return 0;
    var key = 'vitals_bundle_timer_' + id;
    try {
      var t = parseInt(localStorage.getItem(key), 10);
      if (!(t > 0)) {
        if (!start || !root.querySelector('.pp-tab-panel.is-active .pp-bundle')) return 0;
        t = Date.now();
        localStorage.setItem(key, String(t));
      }
      return Math.max(0, Math.floor((t + BUNDLE_TIMER_HOURS * 3600e3 - Date.now()) / 1000));
    } catch (_) { return 0; }
  }

  function bundleTimerParts(left) {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    return [pad(Math.floor(left / 3600)), pad(Math.floor(left % 3600 / 60)), pad(left % 60)];
  }

  // Rendered with the current time already in it, so a repainted card doesn't
  // blink empty until the next tick.
  function bundleTimerHtml() {
    var left = bundleTimerLeft(false);
    var p = bundleTimerParts(left);
    var units = IS_TH ? ['ชม.', 'นาที', 'วินาที'] : ['Hrs', 'Min', 'Sec'];
    function unit(i) {
      return '<span class="pp-bulk__unit"><span class="pp-bulk__num" data-pp-timer-part="' + i + '">' + p[i] + '</span>' +
        '<span class="pp-bulk__unit-lbl">' + units[i] + '</span></span>';
    }
    var sep = '<span class="pp-bulk__sep" aria-hidden="true">:</span>';
    return '<div class="pp-bulk__timer" data-pp-bundle-timer role="timer" aria-live="off"' + (left ? '' : ' hidden') + '>' +
      '<span class="pp-bulk__timer-lbl">' + (IS_TH ? 'ส่วนลดซื้อแพ็กยาวหมดเขตใน' : 'Bulk discount ends in') + '</span>' +
      '<span class="pp-bulk__clock">' + unit(0) + sep + unit(1) + sep + unit(2) + '</span>' +
    '</div>';
  }

  // Starts the clock if a bundle has just come into view, then paints every card.
  // Re-queries each tick because bundle cards are replaced wholesale on repaint.
  function paintBundleTimers() {
    var left = bundleTimerLeft(true);
    var p = bundleTimerParts(left);
    root.querySelectorAll('[data-pp-bundle-timer]').forEach(function (el) {
      el.hidden = !left;
      el.querySelectorAll('[data-pp-timer-part]').forEach(function (n) {
        n.textContent = p[n.getAttribute('data-pp-timer-part')];
      });
    });
    if (left && !bundleTimerInterval) bundleTimerInterval = setInterval(paintBundleTimers, 1000);
    if (!left && bundleTimerInterval) { clearInterval(bundleTimerInterval); bundleTimerInterval = null; }
  }

  function bundleFindItem(g, key) {
    var list = (g && g.products) || [];
    for (var i = 0; i < list.length; i++) {
      if (bundleItemKey(list[i]) === key) return list[i];
    }
    return null;
  }

  // Swaps a bundle block for a freshly rendered one and restores focus to the stepper button
  // the customer was holding, so repeated taps don't lose the keyboard or the hover target.
  function repaintBundleBlock(host, block, g, itemKey, stepAttr) {
    block.outerHTML = bundleBlockHtml(g);
    var fresh = host.querySelector('.pp-bundle[data-pp-bundle-key="' + g.key + '"]');
    var btn = fresh && fresh.querySelector('.pp-bi[data-pp-bi-key="' + itemKey + '"] ' +
      '[data-pp-bi-step="' + stepAttr + '"]');
    // A step button disables itself at the ends of the range — fall back to its partner.
    if (btn && btn.disabled) {
      btn = fresh.querySelector('.pp-bi[data-pp-bi-key="' + itemKey + '"] ' +
        '[data-pp-bi-step]:not([disabled])');
    }
    if (btn) btn.focus();
  }

  // One line of the bundle, at the pack count showing on its stepper. Same clamp-to-stock
  // care as addBundleToCart, minus the batch/retry handling a single line doesn't need.
  function addBundleItemToCart(btn, g, p) {
    var id = numericVariantId(p.variantId);
    if (!p.available || id <= 0) {
      toast(IS_TH ? 'สินค้านี้ยังไม่พร้อมจำหน่าย' : 'This product cannot be bought right now.', 'error');
      return;
    }
    var want = bundlePackCount(g, p, g.months);
    var orig = btn.textContent;
    var cartRoot = cartRootPath();
    var before = {};
    btn.disabled = true;
    btn.textContent = IS_TH ? 'กำลังเพิ่ม…' : 'Adding…';

    function restore() { btn.disabled = false; btn.textContent = orig; }
    function fail(err) {
      if (err) console.error('[Bundle] item add to cart failed:', err);
      restore();
      toast(IS_TH ? 'ไม่สามารถเพิ่มลงตะกร้าได้' : 'Could not add to cart. Please try again.', 'error');
    }
    function readCart() {
      return fetch(cartRoot + 'cart.js', { cache: 'no-store' }).then(function (r) {
        if (!r.ok) throw new Error('Cart read failed ' + r.status);
        return r.json();
      });
    }

    fetch(cartRoot + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; })    // no pre-read is survivable; we just can't clamp.
      .then(function (cart) {
        before = cartQtyByVariant(cart);
        // stock == null means Shopify didn't tell us → ask for the full amount.
        var room = p.stock == null ? want : Math.max(0, p.stock - (before[id] || 0));
        var ask = Math.max(0, Math.min(want, room));
        if (!ask) return null;    // already in the cart in full, or nothing left in stock
        return fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: ask }] })
        }).then(function (r) {
          if (r.ok) return null;
          return r.json().catch(function () { return {}; }).then(function (e) {
            console.warn('[Bundle] item cart/add rejected:', (e && e.description) || r.status);
            return null;
          });
        });
      })
      .then(readCart)
      .then(function (cart) {
        var added = Math.max(0, (cartQtyByVariant(cart)[id] || 0) - (before[id] || 0));
        if (!added) {
          // Nothing moved. Fine if the cart already holds the full amount, a failure otherwise.
          if ((before[id] || 0) < want) { fail(null); return; }
        }
        refreshCartUi(cart);
        if (added && added < want) {
          btn.textContent = IS_TH ? 'เพิ่มบางส่วน' : 'Partly added';
          toast(IS_TH
            ? ('เพิ่ม ' + added + ' จาก ' + want + ' แพ็ค · สต็อกจำกัด')
            : ('Added ' + added + ' of ' + want + ' packs — limited stock'), 'error');
          setTimeout(restore, 4000);
        } else {
          btn.textContent = IS_TH ? 'เพิ่มแล้ว ✓' : 'Added ✓';
          setTimeout(restore, 2000);
        }
      })
      .catch(fail);
  }

  // Renders one bundle block per group into `host` and wires the delegated handler.
  // Assigning onclick (rather than addEventListener) keeps repeated renders from
  // stacking listeners, the same way bindAddAllToCart does.
  function mountBundles(host, groups) {
    if (!host) return;
    groups = groups || [];
    if (!groups.length) { host.innerHTML = ''; host.onclick = null; return; }
    groups.forEach(function (g) {
      var prev = bundleGroups[g.key];
      if (g.months == null) g.months = (prev && prev.months) || BUNDLE_MONTHS_DEFAULT;
      bundleGroups[g.key] = g;
    });
    host.innerHTML = groups.map(bundleBlockHtml).join('');
    paintBundleTimers();
    host.onclick = function (e) {
      if (!e.target || !e.target.closest) return;
      var block = e.target.closest('.pp-bundle');
      if (!block) return;
      var g = bundleGroups[block.getAttribute('data-pp-bundle-key')];
      if (!g) return;
      var mBtn = e.target.closest('[data-pp-bundle-m]');
      if (mBtn) {
        var m = parseInt(mBtn.getAttribute('data-pp-bundle-m'), 10);
        // Repaint just this block — the delegated handler lives on `host`, so it survives.
        // Manual pack counts go with the old length; the new one recalculates from scratch.
        if (m > 0 && m !== g.months) { g.months = m; g.qty = {}; block.outerHTML = bundleBlockHtml(g); }
        return;
      }
      var stepBtn = e.target.closest('[data-pp-bi-step]');
      if (stepBtn) {
        var stepRow = stepBtn.closest('.pp-bi');
        var stepP = stepRow && bundleFindItem(g, stepRow.getAttribute('data-pp-bi-key'));
        if (!stepP) return;
        var delta = parseInt(stepBtn.getAttribute('data-pp-bi-step'), 10) || 0;
        var next = bundlePackCount(g, stepP, g.months) + delta;
        next = Math.max(1, Math.min(bundleQtyMax(stepP), next));
        g.qty = g.qty || {};
        g.qty[bundleItemKey(stepP)] = next;
        // The row's price and the bundle total both move, so repaint the block and put the
        // keyboard back on the button that was just pressed.
        repaintBundleBlock(host, block, g, stepRow.getAttribute('data-pp-bi-key'),
                           stepBtn.getAttribute('data-pp-bi-step'));
        return;
      }
      var itemAdd = e.target.closest('[data-pp-bi-add]');
      if (itemAdd) {
        var itemRow = itemAdd.closest('.pp-bi');
        var itemP = itemRow && bundleFindItem(g, itemRow.getAttribute('data-pp-bi-key'));
        if (itemP) addBundleItemToCart(itemAdd, g, itemP);
        return;
      }
      var instBtn = e.target.closest('[data-pp-bundle-inst]');
      if (instBtn) { checkoutBundleInstallment(instBtn, g); return; }
      var addBtn = e.target.closest('[data-pp-bundle-add]');
      if (addBtn) addBundleToCart(addBtn, g);
    };
  }

  // "Pay in installments": the bundle alone, in a throwaway Storefront cart with its bulk code
  // and the customer's details, straight to checkout. The standing cart is never touched, so the
  // helper's AJAX fallback (which clears the cart) is switched off.
  function checkoutBundleInstallment(btn, g) {
    var items = (g.products || []).filter(function (p) {
      return p.available && numericVariantId(p.variantId) > 0;
    }).map(function (p) {
      var want = bundlePackCount(g, p, g.months);
      var qty = p.stock == null ? want : Math.min(want, p.stock);
      return { id: numericVariantId(p.variantId), quantity: qty };
    }).filter(function (it) { return it.quantity > 0; });

    function fail(err) {
      if (err) console.error('[Bundle] installment checkout failed:', err);
      btn.disabled = false;
      btn.textContent = orig;
      toast(IS_TH ? 'ไม่สามารถไปหน้าชำระเงินได้ กรุณาลองอีกครั้ง' : 'Could not open checkout. Please try again.', 'error');
    }

    var orig = btn.textContent;
    if (!items.length || !window.VitalsBookingCheckout) return fail(items.length ? 'checkout helper missing' : 'no buyable lines');

    var addr = (customer && customer.defaultAddress) || null;
    var disc = bundleDiscount(g.months);
    btn.disabled = true;
    btn.textContent = IS_TH ? 'กำลังไปหน้าชำระเงิน…' : 'Opening checkout…';

    window.VitalsBookingCheckout.go({
      domain: root.dataset.domain,
      token: storefrontToken,
      version: apiVersion,
      items: items,
      buyer: {
        email: customer && customer.email,
        phone: customer && customer.phone,
        address: addr && {
          firstName: addr.firstName, lastName: addr.lastName,
          address1: addr.address1, address2: addr.address2,
          city: addr.city, province: addr.province, zip: addr.zip,
          country: addr.country, phone: addr.phone
        }
      },
      discountCodes: disc ? [disc.code] : [],
      // A payment-rules app hides card/COD on carts carrying this, leaving Omise selected.
      attributes: { _installment: 'yes' },
      ajaxFallback: false
    }).catch(fail);
  }

  // Paints (or clears) the "these came up short" list inside a bundle block. `rows` are
  // {title, added, want} for the lines that didn't land in full.
  function renderBundleShortfall(block, rows) {
    var el = block && block.querySelector('[data-pp-bundle-short]');
    if (!el) return;
    if (!rows || !rows.length) { el.hidden = true; el.innerHTML = ''; return; }
    var head = IS_TH
      ? 'สต็อกไม่เพียงพอ จึงเพิ่มได้เท่าที่มี:'
      : 'Limited stock — we added everything that was available:';
    el.innerHTML = '<div class="pp-bundle__short-hd">' + escapeHtml(head) + '</div>' +
      '<ul class="pp-bundle__short-list">' +
        rows.map(function (r) {
          var detail = IS_TH
            ? ('เพิ่ม ' + r.added + ' จาก ' + r.want + ' แพ็ค')
            : (r.added + ' of ' + r.want + ' packs added');
          return '<li><span class="pp-bundle__short-t">' + escapeHtml(r.title) + '</span>' +
            '<span class="pp-bundle__short-q">' + escapeHtml(detail) + '</span></li>';
        }).join('') +
      '</ul>';
    el.hidden = false;
  }

  // The whole bundle in one request, each line at its calculated pack count.
  //
  // /cart/add.js has two failure modes, and the old code reported both as a flat failure:
  //   · a line asking for MORE than Shopify has → the other lines still land, response is 422.
  //     Customers were told nothing was added while most of the bundle sat in their cart.
  //   · a line that is entirely unsellable (e.g. a variant with no stock location, which can
  //     still report availableForSale:true) → the WHOLE batch is rejected and nothing lands.
  // So: clamp each line to real stock minus what the cart already holds, retry line-by-line if
  // the batch dies outright, and report what actually landed by diffing the cart before/after.
  function addBundleToCart(btn, g) {
    var block = btn.closest('.pp-bundle');
    var buyable = (g.products || []).filter(function (p) {
      return p.available && numericVariantId(p.variantId) > 0;
    });
    if (!buyable.length) {
      toast(IS_TH ? 'สินค้าในแพ็กเกจนี้ยังไม่พร้อมจำหน่าย' : 'None of these products can be bought right now.', 'error');
      return;
    }
    var orig = btn.textContent;
    var cartRoot = cartRootPath();
    btn.disabled = true;
    btn.textContent = IS_TH ? 'กำลังเพิ่ม…' : 'Adding…';
    renderBundleShortfall(block, null);

    var plan = [];   // every buyable line: what we want, and what we're asking for now
    var before = {};

    function restore() { btn.disabled = false; btn.textContent = orig; }
    function fail(err) {
      if (err) console.error('[Bundle] add to cart failed:', err);
      restore();
      toast(IS_TH ? 'ไม่สามารถเพิ่มลงตะกร้าได้' : 'Could not add to cart. Please try again.', 'error');
    }
    function readCart() {
      return fetch(cartRoot + 'cart.js', { cache: 'no-store' }).then(function (r) {
        if (!r.ok) throw new Error('Cart read failed ' + r.status);
        return r.json();
      });
    }
    // Never rejects: a 422 here is information, not the end of the attempt.
    function postItems(items) {
      return fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (r.ok) return true;
        return r.json().catch(function () { return {}; }).then(function (e) {
          console.warn('[Bundle] cart/add rejected:', (e && e.description) || r.status);
          return false;
        });
      }).catch(function (err) {
        console.warn('[Bundle] cart/add network error:', err);
        return false;
      });
    }
    // One request per line, in order. Used only when the batch was rejected outright, so a
    // single unsellable variant can't take the rest of the bundle down with it.
    function postOneByOne(items) {
      return items.reduce(function (chain, it) {
        return chain.then(function () { return postItems([it]); });
      }, Promise.resolve());
    }

    fetch(cartRoot + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; })    // no pre-read is survivable; we just can't clamp.
      .then(function (cart) {
        before = cartQtyByVariant(cart);
        plan = buyable.map(function (p) {
          var id = numericVariantId(p.variantId);
          var want = bundlePackCount(g, p, g.months);
          // stock == null means Shopify didn't tell us → ask for the full amount, as before.
          var room = p.stock == null ? want : Math.max(0, p.stock - (before[id] || 0));
          return { id: id, title: p.title || '', want: want, ask: Math.max(0, Math.min(want, room)) };
        }).filter(function (it) { return it.id > 0 && it.want > 0; });

        var items = plan.filter(function (it) { return it.ask > 0; })
          .map(function (it) { return { id: it.id, quantity: it.ask }; });

        // Everything is already in the cart, or nothing is in stock: skip straight to the report.
        if (!items.length) return null;

        return postItems(items).then(function (ok) {
          if (ok) return null;
          // Batch rejected. It may still have landed most lines (the low-stock case), so look
          // before retrying — re-sending lines that already went in would double them.
          return readCart().then(function (cart2) {
            var mid = cartQtyByVariant(cart2);
            var landed = plan.some(function (it) {
              return (mid[it.id] || 0) > (before[it.id] || 0);
            });
            if (landed) return null;
            return postOneByOne(items);
          }).catch(function () { return postOneByOne(items); });
        });
      })
      .then(function () { return applyBundleDiscount(g.months); })
      .then(readCart)
      .then(function (cart) {
        var after = cartQtyByVariant(cart);
        var addedTotal = 0, wantTotal = 0, short = [];
        plan.forEach(function (it) {
          var added = Math.max(0, (after[it.id] || 0) - (before[it.id] || 0));
          addedTotal += added;
          wantTotal  += it.want;
          if (added < it.want) short.push({ title: it.title, added: added, want: it.want });
        });

        // Nothing landed, and it isn't because the cart already held the bundle: a real failure.
        if (!addedTotal) {
          var allSeated = plan.every(function (it) { return (before[it.id] || 0) >= it.want; });
          if (!allSeated) { fail(null); return; }
        }

        refreshCartUi(cart);
        renderBundleShortfall(block, short);
        if (short.length) {
          btn.textContent = IS_TH ? 'เพิ่มบางส่วน' : 'Partly added';
          toast(IS_TH
            ? ('เพิ่ม ' + addedTotal + ' จาก ' + wantTotal + ' แพ็ค · ' + short.length + ' รายการมีสต็อกจำกัด')
            : ('Added ' + addedTotal + ' of ' + wantTotal + ' packs — ' + short.length +
               (short.length === 1 ? ' product has' : ' products have') + ' limited stock'),
            'error');
        } else {
          btn.textContent = IS_TH ? 'เพิ่มแล้ว ✓' : 'Added ✓';
        }
        setTimeout(restore, short.length ? 4000 : 2000);
      })
      .catch(fail);
  }

  // Puts the length's bulk code on the cart so checkout charges what the card quoted. Other codes
  // the customer already entered are kept; a different length's bulk code is swapped out, so
  // adding a 6-month bundle after a 3-month one doesn't leave the cart on 10%. /cart/update.js
  // takes `discount` as a comma-separated list; if the cart still doesn't show the code, the
  // /discount/<code> route sets it for checkout instead. Never rejects — the products are
  // already in the cart, and a missing code must not turn that into a failure.
  function applyBundleDiscount(months) {
    var d = bundleDiscount(months);
    if (!d) return Promise.resolve();
    var cartRoot = cartRootPath();
    var bulkCodes = Object.keys(BUNDLE_DISCOUNTS).map(function (k) { return BUNDLE_DISCOUNTS[k].code; });
    function hasCode(cart) {
      return ((cart && cart.discount_codes) || []).some(function (c) {
        return c && String(c.code).toUpperCase() === d.code;
      });
    }
    return fetch(cartRoot + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; })
      .then(function (cart) {
        var keep = ((cart && cart.discount_codes) || [])
          .map(function (c) { return c && String(c.code || ''); })
          .filter(function (c) { return c && bulkCodes.indexOf(c.toUpperCase()) === -1; });
        return fetch(cartRoot + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: keep.concat(d.code).join(',') })
        }).then(function (r) { return r.ok ? r.json() : null; });
      })
      .catch(function () { return null; })
      .then(function (cart) {
        if (hasCode(cart)) return;
        return fetch(cartRoot + 'discount/' + encodeURIComponent(d.code), { credentials: 'same-origin' });
      })
      .catch(function (err) { console.warn('[Bundle] discount code not applied:', err); });
  }

  function cartRootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Opens the side cart and repaints its contents / the header count after a cart mutation.
  function refreshCartUi(cart) {
    var cartRoot = cartRootPath();
    document.body.classList.add('cart-sidebar-show');
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count >= 100 ? '99+' : cart.item_count;
    });
    window.updateCartCountLabels?.(cart.item_count);
    var wrapper = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (wrapper) {
      fetch(cartRoot + 'cart?view=ajax_side_cart', { cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          wrapper.innerHTML = html;
          document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
        });
    }
  }

  // Whole protocol in one go. /cart/add.js takes an `items` array, so this is a single request —
  // and it's all-or-nothing, which is why only in-stock variants are ever passed in.
  function addAllToCart(btn, ids) {
    var orig = btn.textContent;
    var cartRoot = cartRootPath();
    btn.disabled = true;
    btn.textContent = IS_TH ? 'กำลังเพิ่ม…' : 'Adding…';
    fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error((e && e.description) || ('Cart error ' + r.status)); });
      return r.json();
    })
    .then(function () {
      return fetch(cartRoot + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      refreshCartUi(cart);
      btn.textContent = IS_TH ? 'เพิ่มแล้ว ✓' : 'Added ✓';
      setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 2000);
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = orig;
      toast(IS_TH ? 'ไม่สามารถเพิ่มลงตะกร้าได้' : 'Could not add to cart. Please try again.', 'error');
    });
  }

  // Wires the section's "Add all to cart" button to the products currently in its grid.
  // Re-render safe: onclick replaces the previous handler rather than stacking listeners.
  function bindAddAllToCart(btnId, products) {
    var btn = document.getElementById(btnId);
    if (!btn) return;
    var ids = (products || []).map(function (p) {
      return parseInt(String(p.variantId || '').split('/').pop(), 10);
    }).filter(function (n) { return n > 0; });
    if (!ids.length) { btn.style.display = 'none'; btn.onclick = null; return; }
    btn.style.display = '';
    btn.textContent = (IS_TH ? 'เพิ่มทั้งหมดลงตะกร้า' : 'Add all to cart') + ' (' + ids.length + ')';
    btn.onclick = function () { addAllToCart(btn, ids); };
  }

  // A customer's protocol is the union of what ALL their reports recommended, not just the
  // newest report's slice — older reports still carry products worth keeping on the shelf.
  // Tests arrive sorted newest first, so the newest report's picks lead the list.
  function allWellnessRecoSkus(tests) {
    var out = [], seen = {};
    for (var i = 0; i < tests.length; i++) {
      var recs = tests[i] && tests[i].recommended_products;
      if (!Array.isArray(recs)) continue;
      for (var j = 0; j < recs.length; j++) {
        var sku = wellnessSkuForLookup(extractWellnessSku(recs[j]));
        if (sku && !seen[sku]) { seen[sku] = true; out.push(sku); }
      }
    }
    return out;
  }
  function wellnessTestDate(test) {
    if (!test || !test.createdAt) return '';
    var d = new Date(test.createdAt);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString(IS_TH ? 'th-TH' : 'en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  // One bundle group per wellness result that carries recommendations, newest first.
  // Keyed by position rather than test id so two results can't collide on a sanitised id.
  function wellnessRecoGroups(tests) {
    var groups = [];
    for (var i = 0; i < tests.length; i++) {
      var test = tests[i];
      var recs = test && test.recommended_products;
      if (!Array.isArray(recs) || !recs.length) continue;
      var skus = [], seen = {};
      for (var j = 0; j < recs.length; j++) {
        var sku = wellnessSkuForLookup(extractWellnessSku(recs[j]));
        var k = skuKey(sku);
        if (sku && !seen[k]) { seen[k] = true; skus.push(sku); }
      }
      if (!skus.length) continue;
      groups.push({
        key: 'wl-' + groups.length,
        label: test.testId || (IS_TH ? 'ผลตรวจสุขภาพ' : 'Wellness result'),
        dateStr: wellnessTestDate(test),
        pdfUrl: test.test_url || '',
        skus: skus
      });
    }
    return groups;
  }

  function renderProtocol() {
    var section = document.getElementById('pp-protocol-section-' + sid);
    var host    = document.getElementById('pp-protocol-grid-' + sid);
    var sub     = document.getElementById('pp-protocol-sub-' + sid);
    if (!section || !host) return;
    var tests    = wellnessTestsCache || [];
    var groups   = wellnessRecoGroups(tests);
    var oosId    = 'pp-protocol-oos-' + sid;
    var addAllId = 'pp-protocol-addall-' + sid;
    // Each bundle carries its own add button now, so the section-level one stays hidden.
    bindAddAllToCart(addAllId, []);
    // No result carries recommendations yet — that's an empty state, not an out-of-stock one.
    if (!groups.length) {
      hideProtocolOos(oosId);
      mountBundles(host, []);
      section.style.display = 'none';
      return;
    }
    section.style.display = '';
    hideProtocolOos(oosId);
    host.innerHTML = '<div class="pp-loader"><div class="pp-spinner"></div></div>';
    // One catalog round-trip for the union of SKUs, then split back per result —
    // the same product routinely shows up in several reports.
    var allSkus = [], seenSku = {};
    groups.forEach(function (g) {
      g.skus.forEach(function (sku) {
        var k = skuKey(sku);
        if (!seenSku[k]) { seenSku[k] = true; allSkus.push(sku); }
      });
    });
    fetchWellnessProducts(allSkus)
      .then(function (products) {
        // A result that recommends the next kit: the test is not part of the supplement bundle, and
        // the out-of-stock copy below is judged on what is left once the tests are out.
        var usable = dropTestProducts(products);
        var bySku = {};
        buyableOnly(usable).forEach(function (p) { bySku[skuKey(p.sku)] = p; });
        var ready = groups.filter(function (g) {
          g.products = g.skus.map(function (sku) { return bySku[skuKey(sku)]; }).filter(Boolean);
          return g.products.length;
        });
        console.log('[Wellness] protocol:', allSkus.length, 'skus ->', usable.length, 'products ->', ready.length, 'bundles');
        if (!ready.length) {
          mountBundles(host, []);
          if (sub) sub.textContent = '';
          showProtocolOos(oosId, usable.length ? 'sold-out' : 'unavailable');
          return;
        }
        if (sub) {
          sub.textContent = IS_TH
            ? (ready.length + ' ผลตรวจที่มีคำแนะนำ')
            : (ready.length + (ready.length === 1 ? ' result with recommendations' : ' results with recommendations'));
        }
        hideProtocolOos(oosId);
        mountBundles(host, ready);
      })
      .catch(function (err) {
        console.error('[Wellness] protocol fetch failed:', err);
        mountBundles(host, []);
        if (sub) sub.textContent = '';
        section.style.display = '';
        showProtocolOos(oosId, 'unavailable');
      });
  }

  function renderProfileRecommended() {
    var section = document.getElementById('pp-rec-section-' + sid);
    var grid    = document.getElementById('pp-rec-grid-' + sid);
    if (!section || !grid) return;
    var tests = wellnessTestsCache || [];
    var skus = allWellnessRecoSkus(tests);
    if (!skus.length) { section.style.display = 'none'; return; }
    section.style.display = '';
    grid.innerHTML = '<div class="pp-loader"><div class="pp-spinner"></div></div>';
    // Six SKUs for three cards: a recommended test is dropped below, and the rail should still fill.
    fetchWellnessProducts(skus.slice(0, 6))
      .then(function (products) {
        var usable = buyableOnly(dropTestProducts(products));
        if (!usable.length) { section.style.display = 'none'; return; }
        grid.innerHTML = usable.slice(0, 3).map(function (p) {
          var img = p.featuredImage;
          var pv = p.priceRange && p.priceRange.minVariantPrice;
          var price = pv ? parseFloat(pv.amount).toFixed(2) + ' ' + pv.currencyCode : '';
          var vid = p.variantId ? p.variantId.split('/').pop() : '';
          var ok = !!p.available;
          var imgHtml = img
            ? '<img src="' + escapeHtml(img.url) + '" alt="' + escapeHtml(img.altText || p.title) + '" loading="lazy">'
            : '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/></svg>';
          return '<div class="pp-rec-card">' +
            '<div class="pp-rec-card__img"><a href="/products/' + escapeHtml(p.handle) + '">' + imgHtml + '</a></div>' +
            '<div class="pp-rec-card__body">' +
              '<span class="pp-rec-card__vendor">' + escapeHtml(p.vendor || '') + '</span>' +
              '<span class="pp-rec-card__title">' + escapeHtml(p.title) + '</span>' +
              '<div class="pp-rec-card__price-row">' +
                (price ? '<span class="pp-rec-card__price">' + price + '</span>' : '<span></span>') +
                (ok && vid
                  ? '<button class="pp-rec-card__add" data-vid="' + escapeHtml(vid) + '">' + (IS_TH ? 'เพิ่มลงตะกร้า' : 'Add to cart') + '</button>'
                  : '<button class="pp-rec-card__add" disabled>' + (IS_TH ? 'สินค้าหมด' : 'Out of Stock') + '</button>') +
              '</div>' +
            '</div>' +
          '</div>';
        }).join('');
        grid.querySelectorAll('.pp-rec-card__add[data-vid]').forEach(function (btn) {
          btn.addEventListener('click', function () { handleAddToCart(btn); });
        });
      })
      .catch(function () { section.style.display = 'none'; });
  }

  // ── Wellness modal (add test) ───────────────────────────
  function showWellnessModal() {
    var t = getWT();
    var modalBg = document.getElementById('pp-wellness-modal-bg-' + sid);
    if (!modalBg) return;
    var mTitle = document.getElementById('pp-wellness-modal-title-' + sid);
    if (mTitle) mTitle.textContent = t.modalTitle;
    var dobOpts = buildDobOptions();
    var monthOpts = dobOpts.monthOpts;
    var dayOpts   = dobOpts.dayOpts;
    var yearOpts  = dobOpts.yearOpts;
    var langField = showWellnessLangSelect
      ? '<div class="pp-field"><label class="pp-label">' + t.language + '</label>' +
          '<select class="pp-input" id="pp-wl-lang-' + sid + '">' +
            '<option value="en"' + (!IS_TH ? ' selected' : '') + '>' + t.english + '</option>' +
            '<option value="th"' + ( IS_TH ? ' selected' : '') + '>' + t.thai + '</option>' +
          '</select></div>'
      : '';
    var html =
      '<div class="pp-wl-grid">' +
        '<div class="pp-field pp-field--full">' +
          '<label class="pp-label">' + t.testId + ' *</label>' +
          '<div class="pp-wl-tid-wrap"><span class="pp-wl-prefix">' + wellnessPrefix + '-</span>' +
            '<input class="pp-input" type="text" id="pp-wl-testid-' + sid + '" autocomplete="off"></div>' +
        '</div>' +
        '<div class="pp-field"><label class="pp-label">' + t.firstName + ' *</label>' +
          '<input class="pp-input" type="text" id="pp-wl-fname-' + sid + '" value="' + escapeHtml(customer.first_name || '') + '"></div>' +
        '<div class="pp-field"><label class="pp-label">' + t.lastName + ' *</label>' +
          '<input class="pp-input" type="text" id="pp-wl-lname-' + sid + '" value="' + escapeHtml(customer.last_name || '') + '"></div>' +
        '<div class="pp-field"><label class="pp-label">' + t.gender + ' *</label>' +
          '<select class="pp-input" id="pp-wl-gender-' + sid + '">' +
            '<option value="">' + t.selectGender + '</option>' +
            '<option value="male">' + t.male + '</option>' +
            '<option value="female">' + t.female + '</option>' +
          '</select></div>' +
        '<div class="pp-field"><label class="pp-label">' + t.email + ' *</label>' +
          '<input class="pp-input" type="email" id="pp-wl-email-' + sid + '" value="' + escapeHtml(customer.email || '') + '"></div>' +
        '<div class="pp-field"><label class="pp-label">' + t.phone + ' *</label>' +
          '<input class="pp-input" type="tel" id="pp-wl-phone-' + sid + '" value="' + escapeHtml(customer.phone || '') + '"></div>' +
        langField +
        '<div class="pp-field pp-field--full">' +
          '<label class="pp-label">' + t.birthdate + ' *</label>' +
          '<div class="pp-grid-2">' +
            '<select class="pp-input" id="pp-wl-month-' + sid + '">' + monthOpts + '</select>' +
            '<select class="pp-input" id="pp-wl-day-'   + sid + '">' + dayOpts   + '</select>' +
            '<select class="pp-input" id="pp-wl-year-'  + sid + '">' + yearOpts  + '</select>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="pp-error" id="pp-wellness-form-err-' + sid + '"></div>' +
      '<button type="button" class="pp-btn pp-btn--primary pp-btn--full" id="pp-wl-save-btn-' + sid + '">' + t.save + '</button>';
    var fc = document.getElementById('pp-wellness-form-container-' + sid);
    if (fc) fc.innerHTML = html;
    var testIdInput = document.getElementById('pp-wl-testid-' + sid);
    if (testIdInput) {
      testIdInput.addEventListener('input', function () {
        var pos = this.selectionStart;
        this.value = formatWellnessTestId(this.value);
        this.setSelectionRange(pos, pos);
      });
    }
    var saveBtn = document.getElementById('pp-wl-save-btn-' + sid);
    if (saveBtn) saveBtn.addEventListener('click', handleWellnessSave);
    modalBg.style.display = 'flex';
  }
  function hideWellnessModal() {
    var modalBg = document.getElementById('pp-wellness-modal-bg-' + sid);
    if (modalBg) modalBg.style.display = 'none';
  }

  function handleWellnessSave() {
    var t = getWT();
    var saveBtn = document.getElementById('pp-wl-save-btn-' + sid);
    clearErr('pp-wellness-form-err');
    var testId = ((document.getElementById('pp-wl-testid-' + sid) || {}).value || '').trim();
    var fname  = ((document.getElementById('pp-wl-fname-'  + sid) || {}).value || '').trim();
    var lname  = ((document.getElementById('pp-wl-lname-'  + sid) || {}).value || '').trim();
    var gender = (document.getElementById('pp-wl-gender-'  + sid) || {}).value || '';
    var email  = ((document.getElementById('pp-wl-email-'  + sid) || {}).value || '').trim();
    var phone  = ((document.getElementById('pp-wl-phone-'  + sid) || {}).value || '').trim();
    var month  = (document.getElementById('pp-wl-month-'   + sid) || {}).value || '';
    var day    = (document.getElementById('pp-wl-day-'     + sid) || {}).value || '';
    var year   = (document.getElementById('pp-wl-year-'    + sid) || {}).value || '';
    var lang   = showWellnessLangSelect
      ? ((document.getElementById('pp-wl-lang-' + sid) || {}).value || (IS_TH ? 'th' : 'en'))
      : (IS_TH ? 'th' : 'en');
    testId = formatWellnessTestId(testId);
    var birthdate = (year && month && day) ? year + '-' + month + '-' + day : '';
    if (!testId || !fname || !lname || !birthdate || !gender || !email || !phone) {
      showErr('pp-wellness-form-err', t.requiredFields);
      return;
    }
    if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = t.saving; }
    fetch(WELLNESS_API + '/api/v1/user/wellness-test/activate', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shopify_customer_id: Number(customerNumericId()),
        testId: testId, first_name: fname, last_name: lname,
        birth_date: birthdate, gender: gender, email: email,
        phone_number: phone, language: lang, lab_id: wellnessLabId
      })
    })
    .then(function (r) {
      if (r.ok) {
        hideWellnessModal();
        toast(t.savedSuccess, 'success');
        renderWellness();
      } else if (r.status === 409) {
        showErr('pp-wellness-form-err', t.alreadyRegistered);
        if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = t.save; }
      } else {
        showErr('pp-wellness-form-err', t.testIdNotFound);
        if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = t.save; }
      }
    })
    .catch(function () {
      showErr('pp-wellness-form-err', t.testIdNotFound);
      if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = t.save; }
    });
  }

  // ── Boot ────────────────────────────────────────────────
  function isWellnessExpert() {
    return !!(expert && String(expert.role || '').toLowerCase() === 'wellness_expert');
  }

  function enterExpertDashboard() {
    var first = (customer && customer.firstName) || '';
    var last  = (customer && customer.lastName)  || '';
    var full  = ((first + ' ' + last).trim()) || (customer && customer.displayName) || 'Doctor';
    var firstInitial = first ? first.charAt(0).toUpperCase() : '';
    var lastInitial  = last  ? last.charAt(0).toUpperCase()  : '';
    var initials = (firstInitial + lastInitial) || (customer && customer.email ? customer.email.charAt(0).toUpperCase() : '—');
    var greeting = first ? ('Dr. ' + first) : 'Doctor';
    var fullName = 'Dr. ' + full;

    function setText(id, val) {
      var el = ddpEl(id);
      if (el) el.textContent = val;
    }
    setText('ddp-greeting-name', greeting);
    setText('ddp-full-name',     fullName);
    setText('ddp-initials',      initials);
    showView('expert');
    currentExpertTab = 'dashboard';
  }

  // ── Expert tab switching ────────────────────────────────
  function showExpertTab(name) {
    currentExpertTab = name;
    var root = ddpEl('DDP');
    if (!root) return;
    var buttons = root.querySelectorAll('[data-ddp-tab]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].classList.toggle('active', buttons[i].getAttribute('data-ddp-tab') === name);
    }
    var panels = root.querySelectorAll('[data-ddp-panel]');
    for (var j = 0; j < panels.length; j++) {
      panels[j].classList.toggle('is-active', panels[j].getAttribute('data-ddp-panel') === name);
    }
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (_) { window.scrollTo(0, 0); }

    if (name === 'dashboard')    { renderExpertDashboard(); }
    if (name === 'appointments') { renderExpertAppointments(); }
    if (name === 'patients')     { renderExpertPatients(); }
    if (name === 'schedule')     { renderExpertSchedule(); }
    if (name === 'profile')      { renderExpertProfile(); }
  }

  // ── Data loaders ────────────────────────────────────────
  function currentExpertId() {
    return expert && expert.expert_id ? String(expert.expert_id) : '';
  }

  function loadAppointments(force) {
    if (!force && appointmentsCache) return Promise.resolve(appointmentsCache);
    var eid = currentExpertId();
    if (!eid) return Promise.reject(new Error('Missing expert_id'));
    return expertApi('/telehealth/api/v1/experts/' + encodeURIComponent(eid) + '/appointments?fetchAll=true')
      .then(function (json) {
        var list = (json && json.data && (json.data.appointments || json.data.records)) || [];
        // Latest first (newest date at the top) — matches the customer Appointments tab.
        list.sort(function (a, b) { return apptSortMs(b) - apptSortMs(a); });
        appointmentsCache = list;
        return list;
      });
  }

  // Best-effort timestamp for an expert appointment, preferring the UTC ISO field.
  function apptSortMs(a) {
    var s = a.schedule || {};
    var iso = s.start_date_utc || a.start_date_utc;
    if (iso) { var t = Date.parse(iso); if (!isNaN(t)) return t; }
    var d = s.start_date || a.start_date;
    var tm = s.start_time || a.start_time;
    if (d) { var t2 = Date.parse(d + (tm ? ' ' + tm : '')); if (!isNaN(t2)) return t2; }
    return 0;
  }

  function loadPatients(force) {
    if (!force && patientsCache) return Promise.resolve(patientsCache);
    var eid = currentExpertId();
    if (!eid) return Promise.reject(new Error('Missing expert_id'));
    return expertApi('/telehealth/api/v1/experts/' + encodeURIComponent(eid) + '/patients')
      .then(function (json) {
        var list = (json && json.data && json.data.patients) || [];
        patientsCache = list;
        return list;
      });
  }

  // ── Row templates ───────────────────────────────────────
  function ddpSchedRowHtml(a) {
    var p = a.patient || {};
    var name = (p.first_name || '') + ' ' + (p.last_name || '');
    name = name.trim() || (p.email || '—');
    var reason = p.reason || p.chief_complaint || a.appointment_id || '—';
    var initials = ddpInitialsFromName(p.first_name, p.last_name);
    var avClass = ddpAvatarClass(a.id || name);
    var status = a.status || (a.payment_status === 'paid' ? 'confirmed' : 'pending');
    var tagClass = ddpStatusTagClass(status);
    var label = ddpStatusLabel(status);
    var time = (a.schedule && a.schedule.start_time) || a.start_time || '—';
    return (
      '<button type="button" class="ddp-sched-row" data-ddp-appt-id="' + ddpEscape(a.id) + '">' +
        '<span class="ddp-sched-time">' + ddpEscape(time) + '</span>' +
        '<div class="ddp-sched-patient">' +
          '<span class="ddp-pt-avatar ' + avClass + '">' + ddpEscape(initials) + '</span>' +
          '<span class="ddp-pt-meta">' +
            '<span class="ddp-pt-name">' + ddpEscape(name) + '</span>' +
            '<span class="ddp-pt-reason">' + ddpEscape(reason) + '</span>' +
          '</span>' +
        '</div>' +
        '<span class="ddp-tag ' + tagClass + '">' + ddpEscape(label) + '</span>' +
        '<span class="ddp-chev"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg></span>' +
      '</button>'
    );
  }

  function ddpPatientRowHtml(p) {
    var name = ((p.first_name || '') + ' ' + (p.last_name || '')).trim() || (p.email || '—');
    var initials = ddpInitialsFromName(p.first_name, p.last_name);
    var avClass = ddpAvatarClass(p.patient_id || p.email || name);
    var last = p.last_appointment_date ? ('Last visit: ' + p.last_appointment_date) : 'No visits yet';
    var visits = (p.visits != null ? p.visits : 0) + ' visit' + (p.visits === 1 ? '' : 's');
    return (
      '<button type="button" class="ddp-pt-row" data-ddp-patient-id="' + ddpEscape(p.patient_id) + '">' +
        '<span class="ddp-pt-avatar ' + avClass + '">' + ddpEscape(initials) + '</span>' +
        '<span class="ddp-pt-meta">' +
          '<span class="ddp-pt-name">' + ddpEscape(name) + '</span>' +
          '<span class="ddp-pt-email">' + ddpEscape(p.email || '—') + '</span>' +
        '</span>' +
        '<span class="ddp-pt-email">' + ddpEscape(last) + '</span>' +
        '<span class="ddp-pt-visits">' + ddpEscape(visits) + '</span>' +
        '<span class="ddp-chev"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg></span>' +
      '</button>'
    );
  }

  // ── Renderers ───────────────────────────────────────────
  function renderExpertDashboard() {
    var schedEl = ddpEl('ddp-sched-list');
    if (schedEl) schedEl.innerHTML = '<div class="ddp-loader-row">Loading…</div>';

    var eid = currentExpertId();
    if (!eid) {
      if (schedEl) schedEl.innerHTML = '<div class="ddp-loader-row">Missing expert id.</div>';
      return;
    }

    expertApi('/telehealth/api/v1/experts/' + encodeURIComponent(eid) + '/dashboard')
      .then(function (json) {
        var data     = (json && json.data) || {};
        var stats    = data.stats || {};
        var schedule = data.today_schedule || [];

        var setNum = function (id, n) {
          var el = ddpEl(id);
          if (el) el.textContent = String(n != null ? n : 0);
        };
        setNum('ddp-stat-rescheduled', stats.rescheduled);
        setNum('ddp-stat-confirmed',   stats.confirmed);
        setNum('ddp-stat-completed',   stats.completed);
        setNum('ddp-stat-today',       schedule.length);
        setNum('ddp-stat-total',       stats.total_patients);
        setNum('ddp-stat-cancelled',   stats.cancelled);
        setNum('ddp-stat-noshow',      stats.no_show);

        var meta = ddpEl('ddp-sched-meta');
        if (meta) meta.textContent = schedule.length + ' appointment' + (schedule.length === 1 ? '' : 's');

        // Sidebar badge = count of confirmed + rescheduled (things that still need the doctor).
        var navBadge = ddpEl('ddp-nav-appt-count');
        if (navBadge) {
          var pendingWork = (stats.confirmed || 0) + (stats.rescheduled || 0);
          if (pendingWork > 0) { navBadge.textContent = String(pendingWork); navBadge.style.display = ''; }
          else                 { navBadge.style.display = 'none'; }
        }

        if (schedEl) {
          schedEl.innerHTML = schedule.length
            ? schedule.map(ddpDashboardSchedRowHtml).join('')
            : '<div class="ddp-loader-row">No appointments today.</div>';
        }
      })
      .catch(function (err) {
        console.error('[doctors] dashboard load failed:', err);
        if (schedEl) schedEl.innerHTML = '<div class="ddp-loader-row">Failed to load dashboard.</div>';
        toast('Could not load dashboard', 'error');
      });
  }

  // Row renderer for /experts/:id/dashboard → today_schedule item shape
  // { id, appointment_id, patient_name, start_time, start_date_utc, status }
  function ddpDashboardSchedRowHtml(item) {
    var name = item.patient_name || '—';
    // Derive initials from the display name (handles "Jane (Test) Doe" → "JD").
    var parts = String(name).replace(/\([^)]*\)/g, '').trim().split(/\s+/);
    var initials = ((parts[0] || '').charAt(0) + ((parts.length > 1 ? parts[parts.length - 1] : '') || '').charAt(0)).toUpperCase() || '—';
    var avClass = ddpAvatarClass(item.id || name);
    var status = normalizeApptStatus(item.status);
    var tagClass = ddpStatusTagClass(status);
    var label = ddpStatusLabel(status);
    var reason = item.appointment_id ? ('APT-' + item.appointment_id) : '—';
    var time = item.start_time || '—';
    return (
      '<button type="button" class="ddp-sched-row" data-ddp-appt-id="' + ddpEscape(item.id) + '">' +
        '<span class="ddp-sched-time">' + ddpEscape(time) + '</span>' +
        '<div class="ddp-sched-patient">' +
          '<span class="ddp-pt-avatar ' + avClass + '">' + ddpEscape(initials) + '</span>' +
          '<span class="ddp-pt-meta">' +
            '<span class="ddp-pt-name">' + ddpEscape(name) + '</span>' +
            '<span class="ddp-pt-reason">' + ddpEscape(reason) + '</span>' +
          '</span>' +
        '</div>' +
        '<span class="ddp-tag ' + tagClass + '">' + ddpEscape(label) + '</span>' +
        '<span class="ddp-chev"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg></span>' +
      '</button>'
    );
  }

  function renderExpertAppointments() {
    var container = ddpEl('ddp-appt-list');
    if (!container) return;
    if (expertPanelsLoaded.appointments && appointmentsCache) {
      container.innerHTML = ddpAppointmentsHtml(appointmentsCache);
      mountApptTableHandlers();
      return;
    }
    container.innerHTML = '<div class="ddp-loader-row">Loading…</div>';
    loadAppointments().then(function (list) {
      expertPanelsLoaded.appointments = true;
      container.innerHTML = ddpAppointmentsHtml(list);
      mountApptTableHandlers();
    }).catch(function () {
      container.innerHTML = '<div class="ddp-empty">Failed to load appointments.</div>';
    });
  }

  function normalizeApptStatus(status) {
    var s = String(status || '').toLowerCase();
    if (s === 'completed' || s === 'done') return 'completed';
    if (s === 'cancelled' || s === 'canceled') return 'cancelled';
    // Expert has asked staff to cancel; the booking is still live until staff acts on it.
    if (s === 'requested_cancellation' || s === 'requested cancellation' ||
        s === 'cancellation_requested' || s === 'requested_cancel') return 'requested_cancellation';
    if (s === 'rescheduled' || s === 'reschedule' ||
        s === 'rescheduled_by_patient' || s === 'rescheduled_by_expert') return 'rescheduled';
    // Everything else (confirmed, approved, paid, pending, requested…) is an active,
    // confirmed booking. Per the dashboard, there is no separate "Pending" state.
    return 'confirmed';
  }

  // Field extractors — the appointments-list API returns a flatter shape than the older
  // detail response, so accept both (nested `patient.*` and flat `patient_name` / `doctor_name`).
  function apptPatientName(a) {
    var p = a.patient || a.customer || {};
    var first = p.first_name || p.firstName || a.patient_first_name || a.first_name || '';
    var last  = p.last_name  || p.lastName  || a.patient_last_name  || a.last_name  || '';
    var joined = (first + ' ' + last).trim();
    return joined
      || p.name || p.full_name || p.display_name
      || a.patient_name || a.customer_name || a.patient_full_name
      || p.email || a.patient_email
      || '—';
  }
  function apptInitials(name) {
    var parts = String(name || '').replace(/\([^)]*\)/g, '').trim().split(/\s+/);
    var a = (parts[0] || '').charAt(0);
    var b = parts.length > 1 ? (parts[parts.length - 1] || '').charAt(0) : '';
    return (a + b).toUpperCase() || '—';
  }
  function apptDoctorName(a) {
    var ex = a.expert || a.doctor || {};
    var joined = ((ex.first_name || '') + ' ' + (ex.last_name || '')).trim();
    return (ex.full_name || ex.name)
      || joined
      || a.doctor_name || a.expert_name || a.doctor_full_name || a.expert_full_name
      || (expert && (expert.full_name || expert.name || expert.doctor_full_name))
      || '—';
  }
  function formatApptRef(a) {
    var raw = a.appointment_id || a.id || '';
    if (!raw) return '—';
    var s = String(raw);
    // If the ID already looks like a formatted reference (contains a letter or hyphen), use it as-is.
    return /[a-zA-Z-]/.test(s) ? s : ('APT-' + s);
  }
  function fmtIsoDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
    } catch (_) { return d.toDateString(); }
  }

  function apptMatchesSearch(a, q) {
    if (!q) return true;
    var p = a.patient || {};
    var s = a.schedule || {};
    var hay = [
      a.appointment_id, a.id,
      apptPatientName(a),
      p.email || a.patient_email,
      p.phone || a.patient_phone,
      p.reason || p.chief_complaint || a.reason,
      apptDoctorName(a),
      s.start_date || a.start_date, s.start_time || a.start_time
    ].filter(Boolean).join(' ').toLowerCase();
    return hay.indexOf(q) !== -1;
  }

  function ddpAppointmentsHtml(list) {
    list = list || [];

    // Bucket counts across the full list — filter chips always reflect the whole set.
    var counts = { all: list.length, confirmed: 0, requested_cancellation: 0, rescheduled: 0, completed: 0, cancelled: 0 };
    for (var i = 0; i < list.length; i++) {
      var st = normalizeApptStatus(list[i].status);
      if (counts[st] != null) counts[st]++;
    }

    // Apply active filters + search
    var q = String(apptSearchQuery || '').trim().toLowerCase();
    var filtered = list.filter(function (a) {
      if (apptFilterStatus !== 'all' && normalizeApptStatus(a.status) !== apptFilterStatus) return false;
      if (!apptMatchesSearch(a, q)) return false;
      return true;
    });

    function chip(key, label, count) {
      var active = apptFilterStatus === key ? ' is-active' : '';
      return '<button type="button" class="ddp-appt-chip' + active + '" data-ddp-appt-status="' + key + '">' +
        ddpEscape(label) + '<span class="ddp-appt-chip-count">' + count + '</span>' +
      '</button>';
    }
    var toolbar =
      '<div class="ddp-appt-toolbar">' +
        '<div class="ddp-appt-chips">' +
          chip('all',         'All',         counts.all) +
          chip('confirmed',   'Confirmed',   counts.confirmed) +
          chip('requested_cancellation', 'Cancel requested', counts.requested_cancellation) +
          chip('rescheduled', 'Rescheduled', counts.rescheduled) +
          chip('completed',   'Completed',   counts.completed) +
          chip('cancelled',   'Cancelled',   counts.cancelled) +
        '</div>' +
        '<div class="ddp-appt-toolbar-row">' +
          '<label class="ddp-appt-search">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
            '<input type="search" id="ddp-appt-search-' + sid + '" placeholder="Search…" value="' + ddpEscape(apptSearchQuery) + '">' +
          '</label>' +
        '</div>' +
      '</div>';

    if (!filtered.length) {
      return toolbar + '<div class="ddp-empty">' +
        (list.length ? 'No appointments match the current filters.' : 'No appointments yet.') +
      '</div>';
    }

    var header =
      '<div class="ddp-appt-table__hd">' +
        '<span>Appointment ID</span>' +
        '<span>Patient</span>' +
        '<span>Doctor</span>' +
        '<span>Date</span>' +
        '<span>Time</span>' +
        '<span>Status</span>' +
      '</div>';

    var rows = filtered.map(ddpApptTableRowHtml).join('');
    return toolbar + '<div class="ddp-appt-table">' + header + rows + '</div>';
  }

  function ddpApptTableRowHtml(a) {
    var p = a.patient || {};
    var s = a.schedule || {};
    var name = apptPatientName(a);
    var initials = apptInitials(name);
    var avClass = ddpAvatarClass(a.id || name);
    var reason = p.reason || p.chief_complaint || a.reason || '';
    var status = normalizeApptStatus(a.status);
    var apptRef = formatApptRef(a);
    var doctor = apptDoctorName(a);
    var date = s.start_date || a.start_date || fmtIsoDate(a.start_date_utc) || '—';
    var time = s.start_time || a.start_time || '—';

    return (
      '<button type="button" class="ddp-appt-table__row" data-ddp-appt-id="' + ddpEscape(a.id) + '">' +
        '<span class="ddp-appt-cell-id">' + ddpEscape(apptRef) + '</span>' +
        '<span class="ddp-appt-cell-patient">' +
          '<span class="ddp-pt-avatar ' + avClass + '">' + ddpEscape(initials) + '</span>' +
          '<span class="ddp-appt-cell-patient__body">' +
            '<span class="ddp-appt-cell-patient__name">' + ddpEscape(name) + '</span>' +
            (reason ? '<span class="ddp-appt-cell-patient__reason">' + ddpEscape(reason) + '</span>' : '') +
          '</span>' +
        '</span>' +
        '<span class="ddp-appt-cell-doctor" data-lbl="Doctor">' + ddpEscape(doctor) + '</span>' +
        '<span class="ddp-appt-cell-date" data-lbl="Date">' + ddpEscape(date) + '</span>' +
        '<span class="ddp-appt-cell-time" data-lbl="Time">' + ddpEscape(time) + '</span>' +
        '<span class="ddp-appt-cell-status">' +
          '<span class="ddp-tag ' + ddpStatusTagClass(status) + '">' + ddpEscape(ddpStatusLabel(status)) + '</span>' +
        '</span>' +
      '</button>'
    );
  }

  var apptTableSearchDebounce = null;
  function mountApptTableHandlers() {
    var container = ddpEl('ddp-appt-list');
    if (!container) return;

    // Chip clicks — attach once per container to avoid stacking on rerender.
    if (!container.dataset.apptWired) {
      container.dataset.apptWired = '1';
      container.addEventListener('click', function (e) {
        var stChip = e.target.closest('[data-ddp-appt-status]');
        if (stChip) {
          apptFilterStatus = stChip.getAttribute('data-ddp-appt-status');
          rerenderApptTable();
          return;
        }
      });
    }

    // The search input is re-rendered each time, so its own listener has to be
    // reattached (the previous input element is destroyed with innerHTML).
    var input = ddpEl('ddp-appt-search');
    if (input) {
      input.addEventListener('input', function () {
        apptSearchQuery = input.value;
        if (apptTableSearchDebounce) clearTimeout(apptTableSearchDebounce);
        apptTableSearchDebounce = setTimeout(function () { rerenderApptRowsOnly(); }, 150);
      });
    }
  }

  function rerenderApptTable() {
    var container = ddpEl('ddp-appt-list');
    if (!container || !appointmentsCache) return;
    container.innerHTML = ddpAppointmentsHtml(appointmentsCache);
    mountApptTableHandlers();
  }

  // Search: only replace the rows so the input keeps focus.
  function rerenderApptRowsOnly() {
    var container = ddpEl('ddp-appt-list');
    if (!container || !appointmentsCache) return;
    var q = String(apptSearchQuery || '').trim().toLowerCase();
    var filtered = appointmentsCache.filter(function (a) {
      if (apptFilterStatus !== 'all' && normalizeApptStatus(a.status) !== apptFilterStatus) return false;
      if (!apptMatchesSearch(a, q)) return false;
      return true;
    });
    var tbl = container.querySelector('.ddp-appt-table');
    var empty = container.querySelector(':scope > .ddp-empty');
    if (!filtered.length) {
      if (tbl) tbl.remove();
      if (!empty) {
        container.insertAdjacentHTML('beforeend', '<div class="ddp-empty">No appointments match the current filters.</div>');
      }
      return;
    }
    if (empty) empty.remove();
    var rowsHtml = filtered.map(ddpApptTableRowHtml).join('');
    if (tbl) {
      // Keep header, replace only row content.
      var kids = tbl.querySelectorAll('.ddp-appt-table__row');
      for (var i = 0; i < kids.length; i++) kids[i].remove();
      tbl.insertAdjacentHTML('beforeend', rowsHtml);
    } else {
      var header =
        '<div class="ddp-appt-table__hd">' +
          '<span>Appointment ID</span><span>Patient</span><span>Doctor</span><span>Date</span><span>Time</span><span>Status</span>' +
        '</div>';
      container.insertAdjacentHTML('beforeend', '<div class="ddp-appt-table">' + header + rowsHtml + '</div>');
    }
  }

  function renderExpertPatients() {
    var container = ddpEl('ddp-patient-list');
    if (!container) return;
    if (expertPanelsLoaded.patients && patientsCache) {
      container.innerHTML = ddpPatientsHtml(patientsCache);
      return;
    }
    container.innerHTML = '<div class="ddp-loader-row">Loading…</div>';
    loadPatients().then(function (list) {
      expertPanelsLoaded.patients = true;
      container.innerHTML = ddpPatientsHtml(list);
    }).catch(function () {
      container.innerHTML = '<div class="ddp-empty">Failed to load patients.</div>';
      toast('Could not load patients', 'error');
    });
  }

  function ddpPatientsHtml(list) {
    if (!list || !list.length) return '<div class="ddp-empty">No patients yet.</div>';
    return '<div class="ddp-pt-list">' + list.map(ddpPatientRowHtml).join('') + '</div>';
  }

  function renderExpertSchedule() {
    var container = ddpEl('ddp-schedule-list');
    if (!container) return;
    container.innerHTML = '<div class="ddp-loader-row">Loading…</div>';
    loadAppointments().then(function (list) {
      if (!list.length) { container.innerHTML = '<div class="ddp-empty">No scheduled appointments.</div>'; return; }
      var byDate = {};
      var order = [];
      for (var i = 0; i < list.length; i++) {
        var a = list[i];
        var d = (a.schedule && a.schedule.start_date) || a.start_date || 'Undated';
        if (!byDate[d]) { byDate[d] = []; order.push(d); }
        byDate[d].push(a);
      }
      order.sort(function (a, b) {
        var da = ddpParseDate(a), db = ddpParseDate(b);
        if (!da && !db) return 0;
        if (!da) return 1;
        if (!db) return -1;
        return da.getTime() - db.getTime();
      });
      var out = '';
      for (var k = 0; k < order.length; k++) {
        var day = order[k];
        var arr = byDate[day];
        out += '<div class="ddp-day-group">' +
          '<div class="ddp-day-head"><span>' + ddpEscape(day) + '</span><span class="ddp-day-count">' + arr.length + ' appt' + (arr.length === 1 ? '' : 's') + '</span></div>' +
          arr.map(ddpSchedRowHtml).join('') +
        '</div>';
      }
      container.innerHTML = out;
    }).catch(function () {
      container.innerHTML = '<div class="ddp-empty">Failed to load schedule.</div>';
    });
  }

  function renderExpertProfile() {
    var container = ddpEl('ddp-profile-card');
    if (!container) return;
    var c = customer || {};
    var fields = [
      ['Name', 'Dr. ' + (((c.firstName || '') + ' ' + (c.lastName || '')).trim() || c.displayName || '')],
      ['Email', c.email || '—'],
      ['Phone', c.phone || '—'],
      ['Role', expert && expert.role ? ddpStatusLabel(expert.role.replace(/_/g, ' ')) : '—'],
      ['Expert ID', expert && expert.expert_id ? expert.expert_id : '—']
    ];
    var grid = fields.map(function (kv) {
      return '<div><div class="ddp-kv-k">' + ddpEscape(kv[0]) + '</div><div class="ddp-kv-v">' + ddpEscape(kv[1]) + '</div></div>';
    }).join('');
    container.innerHTML = '<div class="ddp-panel-title" style="margin:0 0 4px">Account details</div>' +
      '<p class="ddp-panel-sub" style="margin-bottom:0">Read-only for now. Contact support to update.</p>' +
      '<div class="ddp-profile-grid">' + grid + '</div>';
  }

  // ── Appointment detail (inline full-screen) ─────────────
  // State for the currently-open appointment. Mutations POST the whole
  // prescription payload — the API expects the full JSON on every update.
  var apptDetailState = null; // { appt, note, medicines[], recommended: {[id]: true} }
  var apptDetailSaveTimer = null;
  var recProductsAll = null;      // cached full catalog from Storefront API (normalized shape)
  var recProductsPromise = null;  // in-flight fetch promise (dedupes concurrent loads)
  var recProductsError = false;
  var recSearchQuery = '';
  var recSearchDebounce = null;

  // Medicine-name autocomplete (RxTerms) state.
  var medAcDebounce = null;    // keystroke debounce timer
  var medAcController = null;  // AbortController for the in-flight lookup
  var medAcResults = [];       // current suggestions: [{ name, strengths[] }]
  var medAcActive = -1;        // keyboard-highlighted row index
  var medSelStrengths = [];    // strengths of the last-selected medicine (Dose picklist)
  var medDoseCustom = false;   // doctor chose "Custom dose" — keep the picklist out of the way
  var medAcDocBound = false;   // guards the one-time outside-click listener

  // Editor-curated fallback (used if Storefront token is missing or the fetch fails).
  function ddpRecProductsFromBlocks() {
    var node = document.getElementById('ddp-rec-products-data-' + sid);
    if (!node) return [];
    try { return JSON.parse(node.textContent) || []; } catch (e) { return []; }
  }

  // GID → numeric ID (Storefront returns "gid://shopify/Product/12345").
  function stripProductGid(gid) {
    var s = String(gid || '');
    var m = s.match(/\/Product\/(\d+)/);
    return m ? m[1] : s;
  }

  var Q_ALL_PRODUCTS =
    'query($cursor:String){' +
      'products(first:250, after:$cursor){' +
        'pageInfo{hasNextPage endCursor}' +
        'edges{node{' +
          'id title handle vendor onlineStoreUrl availableForSale' +
          ' featuredImage{url altText}' +
          ' priceRange{minVariantPrice{amount currencyCode}}' +
        '}}' +
      '}' +
    '}';

  function loadAllProductsForRec() {
    if (recProductsAll) return Promise.resolve(recProductsAll);
    if (recProductsPromise) return recProductsPromise;
    if (!storefrontToken) {
      // No Storefront token — fall back to editor-curated blocks only.
      recProductsAll = ddpRecProductsFromBlocks();
      return Promise.resolve(recProductsAll);
    }
    var collected = [];
    function page(cursor) {
      return gql(Q_ALL_PRODUCTS, { cursor: cursor || null }).then(function (d) {
        if (d.errors) console.error('[doctors] products errors:', d.errors);
        var conn = (d.data && d.data.products) || {};
        var edges = conn.edges || [];
        for (var i = 0; i < edges.length; i++) {
          var n = edges[i].node;
          var pv = n.priceRange && n.priceRange.minVariantPrice;
          collected.push({
            id: stripProductGid(n.id),
            title: n.title || '',
            vendor: n.vendor || '',
            price: pv ? (parseFloat(pv.amount).toFixed(2) + ' ' + pv.currencyCode) : '',
            image: (n.featuredImage && n.featuredImage.url) || '',
            url: n.onlineStoreUrl || ('/products/' + n.handle),
            available: n.availableForSale !== false
          });
        }
        var pi = conn.pageInfo || {};
        // Cap at 1000 products to keep the picker responsive.
        if (pi.hasNextPage && pi.endCursor && collected.length < 1000) return page(pi.endCursor);
        return collected;
      });
    }
    recProductsPromise = page(null)
      .then(function (list) {
        recProductsAll = list.length ? list : ddpRecProductsFromBlocks();
        recProductsPromise = null;
        return recProductsAll;
      })
      .catch(function (err) {
        console.error('[doctors] failed to load product catalog:', err);
        recProductsError = true;
        recProductsAll = ddpRecProductsFromBlocks();
        recProductsPromise = null;
        return recProductsAll;
      });
    return recProductsPromise;
  }

  function showAppointmentDetail(apptId) {
    if (!apptId) return;
    openApptId = apptId;
    // Reset local search state so switching between appointments doesn't leak the previous query.
    recSearchQuery = '';
    if (recSearchDebounce) { clearTimeout(recSearchDebounce); recSearchDebounce = null; }
    // Reset medicine-autocomplete state so a stale lookup/picklist can't leak across appointments.
    if (medAcDebounce) { clearTimeout(medAcDebounce); medAcDebounce = null; }
    if (medAcController) { medAcController.abort(); medAcController = null; }
    medAcResults = []; medAcActive = -1; medSelStrengths = []; medDoseCustom = false;
    // A generate still in flight belongs to the appointment we're leaving — don't carry its
    // busy state onto the one being opened.
    rxDocBusy = false;
    var body = ddpEl('ddp-detail-body');
    if (!body) return;
    body.innerHTML = '<div class="ddp-loader-row">Loading…</div>';
    showExpertTab('appt-detail');
    // The detail view has no sidebar entry — keep "Appointments" highlighted since it's the parent list.
    var ddpRoot = ddpEl('DDP');
    if (ddpRoot) {
      var apptBtn = ddpRoot.querySelector('[data-ddp-tab="appointments"]');
      if (apptBtn) apptBtn.classList.add('active');
    }
    // Kick off product-catalog fetch in parallel with the appointment fetch.
    // The grid renders a loading state now and swaps in when this settles.
    // The selected list also refreshes so pre-recommended IDs get real names/images/prices.
    loadAllProductsForRec().then(function () {
      // Only refresh if the same appointment is still open.
      if (openApptId !== apptId) return;
      refreshRecGridInner();
      refreshRecSelected();
    });
    expertApi('/telehealth/api/v1/appointments/' + encodeURIComponent(apptId))
      .then(function (json) {
        var appt = (json && json.data && json.data.appointment) || null;
        if (!appt) throw new Error('Appointment not found');
        var pres = appt.prescription || {};
        var meds = appt.medicines || pres.medicines || [];
        var recs = appt.recommended_products || pres.recommended_products || [];
        var recMap = {};
        for (var i = 0; i < recs.length; i++) { recMap[String(recs[i])] = true; }
        apptDetailState = {
          appt: appt,
          note: appt.prescription_note || pres.prescription_note || '',
          medicines: meds.map(function (m) {
            return {
              medicine_name: m.medicine_name || m.name || '',
              dose: m.dose || '',
              frequency: m.frequency || '',
              quantity: m.quantity || '',
              duration: m.duration || '',
              notes: m.notes || ''
            };
          }),
          recommended: recMap,
          // URL of the prescription PDF the backend has already rendered for this appointment,
          // if any. Regenerating replaces it (see handleGeneratePrescription).
          report: pickApptReport(appt)
        };
        body.innerHTML = ddpAppointmentDetailHtml(appt);
        ddpMountDetailHandlers();
      })
      .catch(function (err) {
        console.error('[doctors] appointment detail failed:', err);
        body.innerHTML = '<div class="ddp-empty">Could not load appointment.</div>';
      });
  }

  function hideAppointmentDetail() {
    apptDetailState = null;
    openApptId = null;
    showExpertTab('appointments');
  }

  function ddpStatusStep(status) {
    var s = normalizeApptStatus(status);
    if (s === 'completed') return 3;
    if (s === 'cancelled') return -1;
    // Confirmed and rescheduled are both "active" bookings the expert can complete.
    return 2;
  }

  function ddpActionsLead(status) {
    var s = normalizeApptStatus(status);
    if (s === 'completed') return 'This consultation is complete. Records are saved.';
    if (s === 'cancelled') return 'This appointment was cancelled.';
    if (s === 'requested_cancellation') return 'Cancellation request sent — awaiting staff review. The status will update once staff cancels the appointment.';
    if (s === 'rescheduled') return 'This appointment was rescheduled. Mark complete once the consultation is done.';
    return 'Appointment is confirmed. Mark complete once the consultation is done.';
  }

  function ddpPayLabel(status) {
    var s = String(status || '').toLowerCase();
    if (s === 'paid') return 'Paid';
    return 'Unpaid';
  }
  function ddpPayTagClass(status) {
    return String(status || '').toLowerCase() === 'paid' ? 'ddp-tag--paid' : 'ddp-tag--unpaid';
  }

  function ddpProgressHtml(status) {
    var step = ddpStatusStep(status);
    function stepHtml(idx, label, num) {
      var cls = 'ddp-prog-step';
      var inner;
      if (step === -1) {
        cls += (idx === 1 ? ' is-done' : '');
        inner = idx === 1 ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' : num;
      } else if (idx < step) {
        cls += ' is-done';
        inner = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
      } else if (idx === step) {
        cls += ' is-current';
        inner = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
      } else {
        inner = num;
      }
      return '<div class="' + cls + '"><span class="ddp-prog-dot">' + inner + '</span><span>' + label + '</span></div>';
    }
    return (
      '<div class="ddp-actions__prog">' +
        stepHtml(1, 'Booked', '1') +
        stepHtml(2, 'Confirmed', '2') +
        stepHtml(3, 'Completed', '3') +
      '</div>'
    );
  }

  // ── Blood test reports on the doctor's appointment detail ──
  // The backend attaches the patient's blood-test reports to the appointment as
  // `blood_test_reports`. Its exact shape has moved around (top level vs. nested on the patient,
  // plain URL strings vs. objects), so read every known spelling and keep whatever carries a link.
  function ddpBloodTestReports(a) {
    var p = a.patient || {};
    var rx = a.prescription || {};
    var raw = a.blood_test_reports || a.bloodTestReports ||
      p.blood_test_reports || p.bloodTestReports ||
      rx.blood_test_reports || rx.bloodTestReports || [];
    if (!Array.isArray(raw)) raw = [raw];
    return raw.map(function (r) {
      if (typeof r === 'string') return { url: r, label: '', type: '', date: '' };
      r = r || {};
      return {
        url: r.pdf_report_url || r.pdfReportUrl || r.report_url || r.reportUrl || r.url || r.link ||
             r.file_url || r.fileUrl || r.pdf_url || r.test_url || '',
        label: r.test_type_name || r.testTypeName || r.name || r.title ||
               r.report_name || r.file_name || r.test_id || r.testId || '',
        // Panel tier ("gold", "custom") — shown as a chip beside the label when present.
        type: r.test_type || r.testType || '',
        date: r.created_at || r.createdAt || r.report_date || r.reportDate ||
              r.appointment_date || r.appointmentDate ||
              r.created_date || r.createdDate || r.date || ''
      };
    }).filter(function (r) { return r.url; });
  }

  var DDP_REPORT_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M9 15h6"/><path d="M9 18h4"/></svg>';
  var DDP_DOWNLOAD_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m7 10 5 5 5-5"/><path d="M12 15V3"/></svg>';

  function ddpBloodTestReportsHtml(reports) {
    if (!reports.length) {
      return '<p style="color:var(--muted);font-size:13px;margin:8px 0">No blood test reports on file for this patient.</p>';
    }
    // Newest first — the most recent panel is the one the consultation is usually about.
    // Undated entries sort to the bottom rather than jumping the queue.
    var sorted = reports.slice().sort(function (x, y) {
      return (Date.parse(y.date) || 0) - (Date.parse(x.date) || 0);
    });
    return '<ul class="ddp-bt-list">' + sorted.map(function (r, i) {
      var title = r.label || ('Blood test report ' + (i + 1));
      var when = fmtIsoDate(r.date) || r.date;
      return '<li class="ddp-bt-item">' +
          '<a class="ddp-bt-link" href="' + ddpEscape(r.url) + '" target="_blank" rel="noopener" title="' + ddpEscape(r.url) + '">' +
            '<span class="ddp-bt-ic">' + DDP_REPORT_ICON + '</span>' +
            '<span class="ddp-bt-body">' +
              '<span class="ddp-bt-title">' + ddpEscape(title) + '</span>' +
              '<span class="ddp-bt-meta">' +
                (r.type ? '<span class="ddp-bt-type">' + ddpEscape(r.type) + '</span>' : '') +
                (when ? '<span>' + ddpEscape(when) + '</span>' : '') +
              '</span>' +
            '</span>' +
            '<span class="ddp-bt-dl">' + DDP_DOWNLOAD_ICON + '</span>' +
          '</a>' +
        '</li>';
    }).join('') + '</ul>';
  }

  // ── Prescription PDF ─────────────────────────────────────
  // The backend renders the saved prescription into a PDF on demand
  // (POST /appointments/{id}/generate-prescription, no body) and returns its S3 URL. That same URL
  // is handed to the patient on `prescription.prescription_report` once the appointment is
  // completed, so regenerating after an amendment is what keeps the patient's copy current.
  // The URL has been seen both at the top level and nested on the prescription — read both.
  function pickApptReport(a) {
    a = a || {};
    var rx = a.prescription || {};
    return a.prescription_report || rx.prescription_report || '';
  }

  var rxDocBusy = false;  // a generate request is in flight

  var DDP_RX_DOC_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M9 15h6"/><path d="M9 18h4"/></svg>';

  function ddpRxDocHtml() {
    var st = apptDetailState || {};
    var url = st.report || '';
    var linkHtml = url
      ? '<a class="ddp-rx__doc-link" href="' + ddpEscape(url) + '" target="_blank" rel="noopener" title="' + ddpEscape(url) + '">' +
          '<span class="ddp-rx__doc-ic">' + DDP_RX_DOC_ICON + '</span>' +
          '<span class="ddp-rx__doc-body">' +
            '<span class="ddp-rx__doc-title">Prescription PDF</span>' +
            '<span class="ddp-rx__doc-sub">Open or download the current document</span>' +
          '</span>' +
          '<span class="ddp-rx__doc-dl">' + DDP_DOWNLOAD_ICON + '</span>' +
        '</a>'
      : '';

    // Cancelled consultation: nothing can be generated, but an already-rendered PDF still shows.
    if (st.locked) {
      return '<div class="ddp-rx__label">Prescription document</div>' +
        (linkHtml || '<p class="ddp-rx__doc-empty">No prescription document was generated for this appointment.</p>');
    }

    var btnLabel = rxDocBusy
      ? 'GENERATING…'
      : (url ? 'REGENERATE PDF' : 'GENERATE PRESCRIPTION PDF');
    return '<div class="ddp-rx__label">Prescription document</div>' +
      linkHtml +
      '<button type="button" class="ddp-rx__doc-btn" data-ddp-rx-generate' + (rxDocBusy ? ' disabled' : '') + '>' +
        DDP_RX_DOC_ICON + ' ' + btnLabel +
      '</button>' +
      '<p class="ddp-rx__doc-hint">' +
        (url
          ? 'The patient sees this document once the appointment is completed. Regenerate it after any change above so their copy matches the record.'
          : 'Renders the notes, medicines and recommendations above into a PDF. The patient can download it once the appointment is completed.') +
      '</p>';
  }

  function refreshRxDoc() {
    var box = ddpEl('ddp-rx-doc');
    if (box) box.innerHTML = ddpRxDocHtml();
  }

  function handleGeneratePrescription() {
    if (rxDocBusy) return;
    if (!openApptId || !apptDetailState || apptDetailState.locked) return;
    if (!prescriptionHasContent(currentPrescriptionPayload())) {
      toast('Add notes, medicines or recommendations before generating the PDF', 'error');
      return;
    }
    var apptId = openApptId;
    rxDocBusy = true;
    refreshRxDoc();
    // Flush the debounced auto-save first: the PDF is rendered from what the backend has stored,
    // so generating before the pending edit lands would produce a stale document.
    if (apptDetailSaveTimer) { clearTimeout(apptDetailSaveTimer); apptDetailSaveTimer = null; }
    savePrescription()
      .then(function (saved) {
        if (!saved) throw new Error('Prescription could not be saved — PDF not generated');
        return expertApi(
          '/telehealth/api/v1/appointments/' + encodeURIComponent(apptId) + '/generate-prescription',
          { method: 'POST' }
        );
      })
      .then(function (json) {
        var url = (json && json.data && json.data.prescription_report) || '';
        if (!url) throw new Error('No prescription URL was returned');
        rxDocBusy = false;
        // The doctor may have moved on while the PDF rendered — don't write into another
        // appointment's state, and don't repaint a detail view that is no longer this one.
        if (openApptId !== apptId || !apptDetailState) return;
        apptDetailState.report = url;
        refreshRxDoc();
        toast('Prescription PDF generated', 'success');
      })
      .catch(function (err) {
        console.error('[doctors] generate prescription failed:', err);
        rxDocBusy = false;
        if (openApptId === apptId) refreshRxDoc();
        toast(err && err.message ? err.message : 'Could not generate the prescription PDF', 'error');
      });
  }

  function ddpAppointmentDetailHtml(a) {
    var p = a.patient || {};
    var s = a.schedule || {};
    var q = (a.questionnaire && a.questionnaire.responses) || [];
    var name = apptPatientName(a);
    var initials = apptInitials(name);
    var avClass = ddpAvatarClass(a.id || name);
    var status = a.status || (a.payment_status === 'paid' ? 'confirmed' : 'pending');
    var isCompleted = ddpStatusStep(status) >= 3;
    var isApproved  = ddpStatusStep(status) >= 2;
    var isCancelled = ddpStatusStep(status) === -1;
    var cancelRequested = normalizeApptStatus(status) === 'requested_cancellation' ||
      !!(a.requested_cancellation || a.cancellation_requested);
    // Only a CANCELLED appointment makes the prescription final — the consultation never
    // happened, so there is nothing to prescribe against. A COMPLETED one stays editable:
    // doctors routinely correct a dose, fix a typo in the notes or add a recommendation after
    // the call has ended, and the record has to be able to follow. `locked` gates the editor
    // chrome and every write path (see savePrescription), so this one flag is the whole switch.
    var rxLocked = isCancelled;
    if (apptDetailState) apptDetailState.locked = rxLocked;
    var apptRef = ddpEscape(formatApptRef(a));

    // Fields that may or may not be in the API — show "—" placeholder when absent.
    var age = (p.age != null && p.age !== '') ? p.age : (a.age != null ? a.age : '');
    var gender = p.gender || a.gender || '';
    // The blood type is asked in the intake questionnaire, so the same value used to render
    // twice: once here and once in the responses list. Treat the patient record as the source
    // of truth, fall back to the questionnaire answer, and drop that entry from the list below.
    var isBloodTypeQ = function (r) { return /blood\s*type/i.test(r && r.name || ''); };
    var bloodTypeQ = q.filter(isBloodTypeQ)[0];
    q = q.filter(function (r) { return !isBloodTypeQ(r); });
    var bloodType = p.blood_type || p.bloodType || a.blood_type || (bloodTypeQ && bloodTypeQ.value) || '—';
    var language = ddpLangLabel(p.language || a.language);
    var doctorName = apptDoctorName(a);
    var apptType = a.type || a.appointment_type || (a.meeting_link ? 'Google Meet video call' : '—');

    // Hero
    var hero = (
      '<div class="ddp-detail-hero">' +
        '<span class="ddp-pt-avatar ' + avClass + '">' + ddpEscape(initials) + '</span>' +
        '<div>' +
          '<div class="ddp-detail-hero-name">' + ddpEscape(name) + '</div>' +
          '<div class="ddp-detail-hero-meta">' +
            '<span>' + apptRef + '</span>' +
            '<span class="ddp-tag ' + ddpStatusTagClass(status) + '">' + ddpEscape(ddpStatusLabel(status)) + '</span>' +
            '<span class="ddp-tag ' + ddpPayTagClass(a.payment_status) + '">' + ddpEscape(ddpPayLabel(a.payment_status)) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>'
    );

    // Patient Information
    var patientCard = (
      '<div class="ddp-info-card">' +
        '<div class="ddp-info-card__hd"><span class="ddp-info-card__title">Patient Information</span></div>' +
        '<div class="ddp-info-card__bd">' +
          '<div class="ddp-kv-grid ddp-kv-grid--stack">' +
            kvHtml('Blood type', bloodType) +
            kvHtml('Full name', name) +
            kvHtml('Age', age) +
            kvHtml('Gender', gender) +
            kvHtml('Language', language) +
          '</div>' +
          (p.patient_id
            ? '<button type="button" class="ddp-detail-linkbtn" data-ddp-patient-id="' + ddpEscape(p.patient_id) + '">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>' +
                'View full patient profile' +
              '</button>'
            : '') +
        '</div>' +
      '</div>'
    );

    // Blood test reports the patient has on file — read-only links for the consultation.
    var bloodReports = ddpBloodTestReports(a);
    var bloodReportsCard = (
      '<div class="ddp-info-card">' +
        '<div class="ddp-info-card__hd">' +
          '<span class="ddp-info-card__title">Blood Test Reports</span>' +
          '<span class="ddp-info-card__meta">' + bloodReports.length + ' report' + (bloodReports.length === 1 ? '' : 's') + '</span>' +
        '</div>' +
        '<div class="ddp-info-card__bd">' + ddpBloodTestReportsHtml(bloodReports) + '</div>' +
      '</div>'
    );

    // Questionnaire
    var qHtml = q.length
      ? '<ol class="ddp-q-list">' + q.map(function (r, i) {
          return '<li class="ddp-q-item">' +
            '<span class="ddp-q-num">' + (i + 1) + '</span>' +
            '<div class="ddp-q-body">' +
              '<div class="ddp-q-q">' + ddpEscape(r.name) + '</div>' +
              '<div class="ddp-q-a">' + ddpEscape(r.value) + '</div>' +
            '</div>' +
          '</li>';
        }).join('') + '</ol>'
      : '<p style="color:var(--muted);font-size:13px;margin:8px 0">No questionnaire responses.</p>';
    var questionnaireCard = (
      '<div class="ddp-info-card">' +
        '<div class="ddp-info-card__hd">' +
          '<span class="ddp-info-card__title">Questionnaire Responses</span>' +
          '<span class="ddp-info-card__meta">' + q.length + ' question' + (q.length === 1 ? '' : 's') + '</span>' +
        '</div>' +
        '<div class="ddp-info-card__bd">' + qHtml + '</div>' +
      '</div>'
    );

    // Appointment info
    var meetingHtml = a.meeting_link
      ? '<div class="ddp-meeting">' +
          '<span class="ddp-meeting__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="14" height="12" rx="2"/><path d="m22 8-6 4 6 4V8z"/></svg></span>' +
          '<div class="ddp-meeting__body">' +
            '<div class="ddp-meeting__cap">Meeting link</div>' +
            '<a class="ddp-meeting__url" href="' + ddpEscape(a.meeting_link) + '" target="_blank" rel="noopener">' + ddpEscape(a.meeting_link) + '</a>' +
          '</div>' +
          (isCompleted ? '<span class="ddp-tag ddp-tag--completed">Ended</span>' : '') +
        '</div>'
      : '';
    var appointmentInfoCard = (
      '<div class="ddp-info-card">' +
        '<div class="ddp-info-card__hd"><span class="ddp-info-card__title">Appointment Info</span></div>' +
        '<div class="ddp-info-card__bd">' +
          '<div class="ddp-kv-grid">' +
            kvHtml('Date', s.start_date || a.start_date || fmtIsoDate(a.start_date_utc) || '—') +
            kvHtml('Time', s.start_time || a.start_time || '—') +
            kvHtml('Doctor', doctorName) +
            kvHtml('Type', apptType) +
          '</div>' +
          meetingHtml +
        '</div>' +
      '</div>'
    );

    // Prescription + medicines + recommend products
    var rxCard = (
      '<div class="ddp-info-card">' +
        '<div class="ddp-info-card__hd">' +
          '<span class="ddp-info-card__title">' +
            '<span class="ddp-info-card__title-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3h6a4 4 0 0 1 0 8H6z"/><path d="M6 11l8 10"/><path d="m14 15 6-6"/></svg></span>' +
            'Prescription &amp; Recommendations' +
          '</span>' +
          '<span class="ddp-tag ddp-tag--done" id="ddp-rx-savedtag-' + sid + '">On record</span>' +
        '</div>' +
        '<div class="ddp-rx' + (rxLocked ? ' ddp-rx--locked' : '') + '">' +
          (rxLocked
            ? '<div class="ddp-rx__locked-note">This appointment was cancelled — the prescription is final and can no longer be edited.</div>'
            : '') +
          // Editable, but flag it: the consultation is over, so any change here is an amendment
          // to a closed record rather than notes taken during the call.
          (isCompleted && !rxLocked
            ? '<div class="ddp-rx__amend-note">This consultation is completed. Changes you make here update the patient\'s record.</div>'
            : '') +
          '<div class="ddp-rx__label">Prescription notes</div>' +
          '<textarea class="ddp-rx__note" id="ddp-rx-note-' + sid + '" placeholder="Clinical notes, diagnosis, follow-up instructions…"' + (rxLocked ? ' readonly' : '') + '>' + ddpEscape(apptDetailState.note || '') + '</textarea>' +

          '<div class="ddp-rx__label">Medicines</div>' +
          '<div class="ddp-rx__meds-empty" id="ddp-rx-empty-' + sid + '" style="' + (apptDetailState.medicines.length ? 'display:none' : '') + '">' + (rxLocked ? 'No medicines were prescribed.' : 'No medicines added yet.') + '</div>' +
          '<div class="ddp-rx__meds" id="ddp-rx-meds-' + sid + '">' + ddpMedRowsHtml(apptDetailState.medicines) + '</div>' +

          (rxLocked
            ? ''
            : '<div class="ddp-rx__add">' +
                '<div class="ddp-rx__combo">' +
                  '<input type="text" id="ddp-rx-add-name-' + sid + '" placeholder="Medicine name" autocomplete="off">' +
                  '<div class="ddp-rx__menu" id="ddp-rx-name-menu-' + sid + '"></div>' +
                '</div>' +
                '<div class="ddp-rx__combo">' +
                  '<input type="text" id="ddp-rx-add-dose-' + sid + '" placeholder="Dose" autocomplete="off">' +
                  '<div class="ddp-rx__menu" id="ddp-rx-dose-menu-' + sid + '"></div>' +
                '</div>' +
                '<input type="text" id="ddp-rx-add-freq-' + sid + '" placeholder="Frequency">' +
                '<input type="text" id="ddp-rx-add-qty-' + sid + '" placeholder="Quantity" inputmode="numeric">' +
                '<button type="button" id="ddp-rx-add-btn-' + sid + '">' +
                  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14"/><path d="M5 12h14"/></svg> ADD' +
                '</button>' +
              '</div>') +

          ddpRecommendGridHtml() +

          // Generated PDF of everything above — re-rendered in place by refreshRxDoc().
          '<div id="ddp-rx-doc-' + sid + '">' + ddpRxDocHtml() + '</div>' +
        '</div>' +
      '</div>'
    );

    // Doctor Actions
    var leadCopy = cancelRequested
      ? 'Cancellation request sent — awaiting staff review. The status will update once staff cancels the appointment.'
      : ddpActionsLead(status);
    var cancelBtn = cancelRequested
      ? '<button type="button" class="ddp-btn-full ddp-btn-full--danger" disabled>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg> CANCELLATION REQUESTED' +
        '</button>'
      : '<button type="button" class="ddp-btn-full ddp-btn-full--danger" data-ddp-appt-action="cancel"' + (isCompleted || isCancelled ? ' disabled' : '') + '>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg> CANCEL APPOINTMENT' +
        '</button>';

    var actionsCard = (
      '<div class="ddp-info-card">' +
        '<div class="ddp-info-card__hd"><span class="ddp-info-card__title">Doctor Actions</span></div>' +
        '<div class="ddp-actions ddp-actions--bar">' +
          '<div class="ddp-actions__info">' +
            '<div class="ddp-actions__lead">' + ddpEscape(leadCopy) + '</div>' +
            ddpProgressHtml(status) +
          '</div>' +
          '<div class="ddp-actions__btns">' +
            '<button type="button" class="ddp-btn-full ddp-btn-full--primary" data-ddp-appt-action="complete"' + (!isApproved || isCompleted || isCancelled || cancelRequested ? ' disabled' : '') + '>' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> MARK AS COMPLETE' +
            '</button>' +
            cancelBtn +
          '</div>' +
        '</div>' +
      '</div>'
    );

    return (
      '<div class="ddp-detail">' +
        '<button type="button" class="ddp-detail-back" data-ddp-back>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>' +
          'Back to appointments' +
        '</button>' +
        hero +
        '<div class="ddp-detail-grid">' +
          '<div class="ddp-detail-col">' +
            rxCard + appointmentInfoCard + actionsCard +
          '</div>' +
          '<div class="ddp-detail-col">' +
            patientCard + questionnaireCard + bloodReportsCard +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function kvHtml(k, v) {
    return '<div class="ddp-kv-item"><span class="ddp-kv-k">' + ddpEscape(k) + '</span><span class="ddp-kv-v">' + ddpEscape(v || '—') + '</span></div>';
  }
  // Same row, but the value is actionable (mailto:/tel:). Falls back to the plain row when the
  // API omits the field, so the grid keeps its shape either way.
  function kvLinkHtml(k, v, href) {
    if (!v || !href) return kvHtml(k, v);
    return '<div class="ddp-kv-item"><span class="ddp-kv-k">' + ddpEscape(k) + '</span>' +
      '<a class="ddp-kv-v ddp-kv-v--link" href="' + ddpEscape(href) + '">' + ddpEscape(v) + '</a></div>';
  }
  function ddpLangLabel(code) {
    var c = String(code || '').toLowerCase();
    if (c === 'en') return 'English';
    if (c === 'th') return 'Thai';
    return code || '';
  }

  function ddpMedRowsHtml(meds) {
    if (!meds || !meds.length) return '';
    var locked = !!(apptDetailState && apptDetailState.locked);
    return meds.map(function (m, i) {
      return '<div class="ddp-rx__med' + (locked ? ' ddp-rx__med--locked' : '') + '" data-ddp-med-idx="' + i + '">' +
        '<span><strong>' + ddpEscape(m.medicine_name) + '</strong></span>' +
        '<span>' + ddpEscape(m.dose || '—') + '</span>' +
        '<span>' + ddpEscape(m.frequency || '—') + '</span>' +
        '<span>' + ddpEscape(m.quantity || '—') + '</span>' +
        (locked ? '' : '<button type="button" class="ddp-rx__med-rm" data-ddp-med-rm="' + i + '" aria-label="Remove">×</button>') +
      '</div>';
    }).join('');
  }

  function recBtnLabelHtml(isRec) {
    return isRec
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> RECOMMENDED'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14"/><path d="M5 12h14"/></svg> RECOMMEND';
  }

  function recCardHtml(p, isRec) {
    var imgHtml = p.image
      ? '<img src="' + ddpEscape(p.image) + '" alt="' + ddpEscape(p.title) + '" loading="lazy">'
      : '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/></svg>';
    return '<div class="ddp-reccard">' +
      '<div class="ddp-reccard__img">' + imgHtml + '</div>' +
      '<div class="ddp-reccard__body">' +
        '<span class="ddp-reccard__title">' + ddpEscape(p.title) + '</span>' +
        '<span class="ddp-reccard__vendor">' + ddpEscape(p.vendor || '') + '</span>' +
        '<span class="ddp-reccard__price">' + ddpEscape(p.price || '') + '</span>' +
        '<button type="button" class="ddp-reccard__cta' + (isRec ? ' is-recommended' : '') + '" data-ddp-rec-toggle="' + ddpEscape(p.id) + '">' + recBtnLabelHtml(isRec) + '</button>' +
      '</div>' +
    '</div>';
  }

  // Only in-stock products are offered in the picker. `recProductsAll` deliberately keeps the
  // out-of-stock ones so already-recommended items still resolve to a real name/image below.
  function recInStockList() {
    return (recProductsAll || []).filter(function (p) { return p.available !== false; });
  }

  function recFilteredList() {
    var list = recInStockList();
    var q = String(recSearchQuery || '').trim().toLowerCase();
    if (!q) return list;
    return list.filter(function (p) {
      return (p.title + ' ' + (p.vendor || '')).toLowerCase().indexOf(q) !== -1;
    });
  }

  function recSelectedCount() {
    if (!apptDetailState) return 0;
    var c = 0;
    var sel = apptDetailState.recommended || {};
    for (var k in sel) if (sel[k]) c++;
    return c;
  }

  // Renders the cards grid contents only (used both on initial mount and on search-filter changes).
  function recGridInnerHtml() {
    if (!recProductsAll) {
      return '<div class="ddp-loader-row">Loading products…</div>';
    }
    var list = recFilteredList();
    if (!list.length) {
      return '<div class="ddp-recgrid-empty">' +
        (recSearchQuery
          ? 'No in-stock products match “' + ddpEscape(recSearchQuery) + '”.'
          : 'No products are currently in stock.') +
      '</div>';
    }
    var selected = (apptDetailState && apptDetailState.recommended) || {};
    return list.map(function (p) { return recCardHtml(p, !!selected[String(p.id)]); }).join('');
  }

  function ddpRecommendGridHtml() {
    // Locked appointments show only the read-only list of what was recommended —
    // no search box, product grid or remove buttons.
    if (apptDetailState && apptDetailState.locked) {
      return (
        '<div class="ddp-recgrid-hd">' +
          '<span class="ddp-recgrid-hd-t">Recommended products</span>' +
          '<span class="ddp-recgrid-hd-m">· <span id="ddp-rec-count-' + sid + '">' + recSelectedCount() + '</span> selected</span>' +
        '</div>' +
        '<div class="ddp-rec-selected" id="ddp-rec-selected-' + sid + '">' + recSelectedHtml() + '</div>'
      );
    }
    return (
      '<div class="ddp-recgrid-hd">' +
        '<span class="ddp-recgrid-hd-t">Recommend products</span>' +
        '<span class="ddp-recgrid-hd-m">· <span id="ddp-rec-count-' + sid + '">' + recSelectedCount() + '</span> selected</span>' +
      '</div>' +
      '<div class="ddp-rec-search">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
        '<input type="search" id="ddp-rec-search-' + sid + '" placeholder="Search products…" value="' + ddpEscape(recSearchQuery) + '">' +
      '</div>' +
      '<div class="ddp-recgrid-scroll">' +
        '<div class="ddp-recgrid" id="ddp-recgrid-' + sid + '">' + recGridInnerHtml() + '</div>' +
      '</div>' +
      '<div class="ddp-rec-selected" id="ddp-rec-selected-' + sid + '">' + recSelectedHtml() + '</div>'
    );
  }

  function refreshRecGridInner() {
    var el = ddpEl('ddp-recgrid');
    if (el) el.innerHTML = recGridInnerHtml();
  }

  function recSelectedHtml() {
    var locked = !!(apptDetailState && apptDetailState.locked);
    var sel = (apptDetailState && apptDetailState.recommended) || {};
    var ids = [];
    for (var k in sel) if (sel[k]) ids.push(k);
    var count = ids.length;
    var header =
      '<div class="ddp-rec-selected__hd">' +
        '<span>Selected products</span>' +
        '<span class="ddp-rec-selected__hd-count">' + count + '</span>' +
      '</div>';
    if (!count) {
      return header + '<div class="ddp-rec-selected__empty">' + (locked ? 'No products were recommended.' : 'No products recommended yet. Pick one from the list above.') + '</div>';
    }
    // Look up catalog metadata; skip rows we can't identify (e.g. product removed from store).
    var byId = {};
    var catalog = recProductsAll || [];
    for (var i = 0; i < catalog.length; i++) byId[String(catalog[i].id)] = catalog[i];

    var rows = ids.map(function (id) {
      var p = byId[id];
      if (!p) {
        // Catalog might still be loading — show a minimal placeholder so the doctor still knows something is queued.
        return '<div class="ddp-rec-selected__row" data-ddp-rec-selected-id="' + ddpEscape(id) + '">' +
          '<span class="ddp-rec-selected__img"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/></svg></span>' +
          '<span class="ddp-rec-selected__body">' +
            '<span class="ddp-rec-selected__title">Product #' + ddpEscape(id) + '</span>' +
            '<span class="ddp-rec-selected__vendor">Loading details…</span>' +
          '</span>' +
          '<span class="ddp-rec-selected__price"></span>' +
          (locked ? '' : '<button type="button" class="ddp-rec-selected__rm" data-ddp-rec-remove="' + ddpEscape(id) + '" aria-label="Remove">×</button>') +
        '</div>';
      }
      var imgHtml = p.image
        ? '<img src="' + ddpEscape(p.image) + '" alt="' + ddpEscape(p.title) + '" loading="lazy">'
        : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/></svg>';
      return '<div class="ddp-rec-selected__row">' +
        '<span class="ddp-rec-selected__img">' + imgHtml + '</span>' +
        '<span class="ddp-rec-selected__body">' +
          '<span class="ddp-rec-selected__title">' + ddpEscape(p.title) + '</span>' +
          '<span class="ddp-rec-selected__vendor">' + ddpEscape(p.vendor || '') + '</span>' +
        '</span>' +
        '<span class="ddp-rec-selected__price">' + ddpEscape(p.price || '') + '</span>' +
        (locked ? '' : '<button type="button" class="ddp-rec-selected__rm" data-ddp-rec-remove="' + ddpEscape(p.id) + '" aria-label="Remove">×</button>') +
      '</div>';
    }).join('');
    return header + '<div class="ddp-rec-selected__list">' + rows + '</div>';
  }

  function refreshRecSelected() {
    var el = ddpEl('ddp-rec-selected');
    if (el) el.innerHTML = recSelectedHtml();
  }

  function ddpMountDetailHandlers() {
    var body = ddpEl('ddp-detail-body');
    if (!body) return;

    // Prescription note — debounced auto-save on input
    var noteEl = ddpEl('ddp-rx-note');
    if (noteEl) {
      noteEl.addEventListener('input', function () {
        if (!apptDetailState || apptDetailState.locked) return;
        apptDetailState.note = noteEl.value;
        scheduleSavePrescription();
      });
    }

    // Add medicine
    var addBtn = ddpEl('ddp-rx-add-btn');
    if (addBtn) addBtn.addEventListener('click', handleAddMedicine);

    // Medicine-name autocomplete (RxTerms) — debounced network lookup + keyboard nav.
    var nameEl = ddpEl('ddp-rx-add-name');
    if (nameEl) {
      nameEl.addEventListener('input', function () {
        if (medAcDebounce) clearTimeout(medAcDebounce);
        if (nameEl.value.trim().length < 2) {
          medAcResults = []; medAcActive = -1; closeMedMenu('name');
          return;
        }
        medAcDebounce = setTimeout(fetchMedSuggestions, 200);
      });
      nameEl.addEventListener('keydown', handleMedNameKeydown);
    }

    // Dose strength picklist — opens when a medicine with known strengths is selected.
    var doseEl = ddpEl('ddp-rx-add-dose');
    if (doseEl) {
      doseEl.addEventListener('focus', maybeOpenDoseMenu);
      doseEl.addEventListener('click', maybeOpenDoseMenu);
      // Emptying the field is the way back from a custom dose to the strength picklist.
      doseEl.addEventListener('input', function () {
        if (medDoseCustom && !doseEl.value.trim()) medDoseCustom = false;
      });
    }

    // Close the menus when clicking outside the combobox (bound once per section).
    if (!medAcDocBound) {
      medAcDocBound = true;
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.ddp-rx__combo')) closeMedMenu('all');
      });
    }

    // Recommend-product search — debounced, grid-only refresh so focus is preserved.
    var recSearch = ddpEl('ddp-rec-search');
    if (recSearch) {
      recSearch.addEventListener('input', function () {
        recSearchQuery = recSearch.value;
        if (recSearchDebounce) clearTimeout(recSearchDebounce);
        recSearchDebounce = setTimeout(refreshRecGridInner, 120);
      });
    }

    // Delegated clicks inside the detail view
    body.addEventListener('click', function (e) {
      var nameOpt = e.target.closest('[data-med-idx]');
      if (nameOpt) {
        var ni = parseInt(nameOpt.getAttribute('data-med-idx'), 10);
        if (!isNaN(ni)) selectMedSuggestion(ni);
        return;
      }

      if (e.target.closest('[data-dose-custom]')) { startCustomDose(); return; }

      var doseOpt = e.target.closest('[data-dose-idx]');
      if (doseOpt) {
        var di = parseInt(doseOpt.getAttribute('data-dose-idx'), 10);
        if (!isNaN(di)) selectDoseOption(di);
        return;
      }

      var back = e.target.closest('[data-ddp-back]');
      if (back) { hideAppointmentDetail(); return; }

      var rm = e.target.closest('[data-ddp-med-rm]');
      if (rm) {
        var idx = parseInt(rm.getAttribute('data-ddp-med-rm'), 10);
        if (!isNaN(idx)) handleRemoveMedicine(idx);
        return;
      }

      var recBtn = e.target.closest('[data-ddp-rec-toggle]');
      if (recBtn) {
        handleToggleRecommend(recBtn.getAttribute('data-ddp-rec-toggle'));
        return;
      }

      var recRm = e.target.closest('[data-ddp-rec-remove]');
      if (recRm) {
        setRecommend(recRm.getAttribute('data-ddp-rec-remove'), false);
        return;
      }

      var genBtn = e.target.closest('[data-ddp-rx-generate]');
      if (genBtn && !genBtn.disabled) { handleGeneratePrescription(); return; }

      var actionBtn = e.target.closest('[data-ddp-appt-action]');
      if (actionBtn && !actionBtn.disabled) {
        handleApptAction(actionBtn.getAttribute('data-ddp-appt-action'));
        return;
      }
    });
  }

  // ── Medicine-name autocomplete (RxTerms) ─────────────────

  function fetchMedSuggestions() {
    var nameEl = ddpEl('ddp-rx-add-name');
    var term = nameEl ? nameEl.value.trim() : '';
    if (term.length < 2) { medAcResults = []; medAcActive = -1; closeMedMenu('name'); return; }
    if (medAcController) medAcController.abort();
    medAcController = new AbortController();
    var url = RXTERMS_URL + '?df=DISPLAY_NAME,STRENGTHS_AND_FORMS&maxList=8&terms=' + encodeURIComponent(term);
    fetch(url, { signal: medAcController.signal })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        // Shape: [count, [displayNames], null, [[DISPLAY_NAME, STRENGTHS_AND_FORMS], ...]]
        var rows = (json && json[3]) || [];
        medAcResults = rows.map(function (row) {
          var strengths = String(row[1] || '').split(',')
            .map(function (s) { return s.trim(); })
            .filter(Boolean);
          return { name: row[0] || '', strengths: strengths };
        }).filter(function (m) { return m.name; });
        medAcActive = -1;
        renderMedNameMenu();
      })
      .catch(function (err) {
        // Lookup is a convenience — silently drop aborted/failed requests.
        if (err && err.name === 'AbortError') return;
        medAcResults = []; medAcActive = -1; closeMedMenu('name');
      });
  }

  function renderMedNameMenu() {
    var menu = ddpEl('ddp-rx-name-menu');
    if (!menu) return;
    if (!medAcResults.length) { closeMedMenu('name'); return; }
    menu.innerHTML = medAcResults.map(function (m, i) {
      return '<div class="ddp-rx__opt' + (i === medAcActive ? ' is-active' : '') + '" data-med-idx="' + i + '">' +
        '<span class="ddp-rx__opt-name">' + ddpEscape(m.name) + '</span>' +
        (m.strengths.length ? '<span class="ddp-rx__opt-sub">' + ddpEscape(m.strengths.join(' · ')) + '</span>' : '') +
      '</div>';
    }).join('');
    menu.classList.add('is-open');
  }

  function handleMedNameKeydown(e) {
    var menu = ddpEl('ddp-rx-name-menu');
    var open = menu && menu.classList.contains('is-open') && medAcResults.length;
    if (e.key === 'Escape') { closeMedMenu('name'); return; }
    if (!open) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      medAcActive = (medAcActive + 1) % medAcResults.length;
      renderMedNameMenu();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      medAcActive = (medAcActive - 1 + medAcResults.length) % medAcResults.length;
      renderMedNameMenu();
    } else if (e.key === 'Enter') {
      if (medAcActive >= 0) { e.preventDefault(); selectMedSuggestion(medAcActive); }
    }
  }

  function selectMedSuggestion(idx) {
    var m = medAcResults[idx];
    if (!m) return;
    var nameEl = ddpEl('ddp-rx-add-name');
    var doseEl = ddpEl('ddp-rx-add-dose');
    if (nameEl) nameEl.value = m.name;
    medSelStrengths = m.strengths || [];
    medDoseCustom = false;
    // Auto-fill the first strength; the field stays editable and the picklist offers the rest.
    if (doseEl && medSelStrengths.length) doseEl.value = medSelStrengths[0];
    closeMedMenu('name');
    if (medSelStrengths.length > 1 && doseEl) { doseEl.focus(); maybeOpenDoseMenu(); }
    else { var freqEl = ddpEl('ddp-rx-add-freq'); if (freqEl) freqEl.focus(); }
  }

  function maybeOpenDoseMenu() {
    if (!medSelStrengths.length || medDoseCustom) return;
    renderDoseMenu();
  }

  function renderDoseMenu() {
    var menu = ddpEl('ddp-rx-dose-menu');
    if (!menu) return;
    if (!medSelStrengths.length) { closeMedMenu('dose'); return; }
    // RxTerms strengths first, then a free-text escape hatch — RxTerms doesn't cover
    // every product or compounded dose a doctor here needs to write.
    menu.innerHTML = medSelStrengths.map(function (s, i) {
      return '<div class="ddp-rx__opt" data-dose-idx="' + i + '">' +
        '<span class="ddp-rx__opt-name">' + ddpEscape(s) + '</span>' +
      '</div>';
    }).join('') +
      '<div class="ddp-rx__opt ddp-rx__opt--custom" data-dose-custom="1">' +
        '<span class="ddp-rx__opt-name">Custom dose…</span>' +
        '<span class="ddp-rx__opt-sub">Type the dose yourself</span>' +
      '</div>';
    menu.classList.add('is-open');
  }

  // "Custom dose…" — hand the field back to the doctor: empty, focused, picklist out of the way.
  function startCustomDose() {
    medDoseCustom = true;
    closeMedMenu('dose');
    var doseEl = ddpEl('ddp-rx-add-dose');
    if (doseEl) { doseEl.value = ''; doseEl.focus(); }
  }

  function selectDoseOption(idx) {
    var val = medSelStrengths[idx];
    if (val == null) return;
    var doseEl = ddpEl('ddp-rx-add-dose');
    if (doseEl) doseEl.value = val;
    medDoseCustom = false;
    closeMedMenu('dose');
  }

  function closeMedMenu(which) {
    if (which === 'name' || which === 'all') {
      var nm = ddpEl('ddp-rx-name-menu');
      if (nm) { nm.classList.remove('is-open'); nm.innerHTML = ''; }
      medAcActive = -1;
    }
    if (which === 'dose' || which === 'all') {
      var dm = ddpEl('ddp-rx-dose-menu');
      if (dm) { dm.classList.remove('is-open'); dm.innerHTML = ''; }
    }
  }

  function handleAddMedicine() {
    if (!apptDetailState || apptDetailState.locked) return;
    var nameEl = ddpEl('ddp-rx-add-name');
    var doseEl = ddpEl('ddp-rx-add-dose');
    var freqEl = ddpEl('ddp-rx-add-freq');
    var qtyEl = ddpEl('ddp-rx-add-qty');
    var name = nameEl ? nameEl.value.trim() : '';
    if (!name) { if (nameEl) nameEl.focus(); return; }
    apptDetailState.medicines.push({
      medicine_name: name,
      dose: doseEl ? doseEl.value.trim() : '',
      frequency: freqEl ? freqEl.value.trim() : '',
      quantity: qtyEl ? qtyEl.value.trim() : '',
      duration: '',
      notes: ''
    });
    if (nameEl) nameEl.value = '';
    if (doseEl) doseEl.value = '';
    if (freqEl) freqEl.value = '';
    if (qtyEl) qtyEl.value = '';
    // Clear autocomplete state so the next medicine starts fresh.
    medAcResults = []; medAcActive = -1; medSelStrengths = []; medDoseCustom = false;
    closeMedMenu('all');
    refreshMedicinesList();
    savePrescription();
  }

  function handleRemoveMedicine(idx) {
    if (!apptDetailState || apptDetailState.locked) return;
    apptDetailState.medicines.splice(idx, 1);
    refreshMedicinesList();
    savePrescription();
  }

  function refreshMedicinesList() {
    var meds = apptDetailState ? apptDetailState.medicines : [];
    var list = ddpEl('ddp-rx-meds');
    var empty = ddpEl('ddp-rx-empty');
    if (list) list.innerHTML = ddpMedRowsHtml(meds);
    if (empty) empty.style.display = meds.length ? 'none' : '';
  }

  function handleToggleRecommend(productId) {
    if (!apptDetailState || !productId) return;
    var key = String(productId);
    var wasSelected = !!apptDetailState.recommended[key];
    setRecommend(key, !wasSelected);
  }

  function setRecommend(productId, on) {
    if (!apptDetailState || apptDetailState.locked || !productId) return;
    var key = String(productId);
    if (on) apptDetailState.recommended[key] = true;
    else delete apptDetailState.recommended[key];

    // Re-render the grid cards + selected list straight from state so the selection
    // is always reflected immediately — robust against catalog-load timing (previously
    // a first-time toggle could patch buttons before the grid had finished mounting).
    // Preserve the grid's scroll position so re-rendering doesn't jump the viewport.
    var gridEl = ddpEl('ddp-recgrid');
    var scroller = gridEl ? gridEl.closest('.ddp-recgrid-scroll') : null;
    var scrollTop = scroller ? scroller.scrollTop : 0;
    refreshRecGridInner();
    if (scroller) scroller.scrollTop = scrollTop;
    refreshRecSelected();
    var countEl = ddpEl('ddp-rec-count');
    if (countEl) countEl.textContent = recSelectedCount();

    savePrescription();
  }

  function currentPrescriptionPayload() {
    if (!apptDetailState) return null;
    var recs = [];
    for (var k in apptDetailState.recommended) {
      if (apptDetailState.recommended[k]) recs.push(k);
    }
    return {
      appointment_id: openApptId,
      prescription_note: apptDetailState.note || '',
      medicines: apptDetailState.medicines || [],
      recommended_products: recs
    };
  }

  function scheduleSavePrescription() {
    if (apptDetailSaveTimer) clearTimeout(apptDetailSaveTimer);
    apptDetailSaveTimer = setTimeout(function () {
      apptDetailSaveTimer = null;
      savePrescription();
    }, 600);
  }

  // The backend requires at least one of note / medicines / recommended_products.
  function prescriptionHasContent(p) {
    return !!(p && (
      (p.prescription_note && p.prescription_note.trim()) ||
      (p.medicines && p.medicines.length) ||
      (p.recommended_products && p.recommended_products.length)
    ));
  }

  // Resolves to whether the record is now in sync with the editor — never rejects, since most
  // callers are fire-and-forget auto-saves. handleGeneratePrescription reads the flag so it can
  // refuse to render a PDF from a prescription the backend never accepted.
  function savePrescription() {
    // Hard stop: never write a prescription for a cancelled appointment, regardless of any
    // stale DOM controls. Completed appointments are deliberately writable — see `rxLocked`.
    if (apptDetailState && apptDetailState.locked) return Promise.resolve(false);
    var body = currentPrescriptionPayload();
    if (!body || !body.appointment_id) return Promise.resolve(false);
    var tag = ddpEl('ddp-rx-savedtag');
    // Nothing to save yet — skip the API call (empty prescriptions are rejected upstream).
    if (!prescriptionHasContent(body)) {
      if (tag) { tag.textContent = 'Draft'; tag.classList.remove('ddp-tag--pending', 'ddp-tag--done', 'ddp-tag--cancelled'); }
      return Promise.resolve(false);
    }
    if (tag) { tag.textContent = 'Saving…'; tag.classList.remove('ddp-tag--done'); tag.classList.add('ddp-tag--pending'); }
    return expertApi('/telehealth/api/v1/appointments/prescription', {
      method: 'POST',
      body: body
    })
      .then(function () {
        if (tag) { tag.textContent = 'On record'; tag.classList.remove('ddp-tag--pending'); tag.classList.add('ddp-tag--done'); }
        return true;
      })
      .catch(function (err) {
        console.error('[doctors] save prescription failed:', err);
        if (tag) { tag.textContent = 'Save failed'; tag.classList.remove('ddp-tag--done'); tag.classList.add('ddp-tag--cancelled'); }
        toast('Could not save prescription', 'error');
        return false;
      });
  }

  function handleApptAction(action) {
    if (action === 'complete') return handleCompleteAppt();
    if (action === 'cancel')   return handleCancelAppt();
  }

  function handleCompleteAppt() {
    if (!openApptId) return;
    var btn = ddpEl('ddp-detail-body').querySelector('[data-ddp-appt-action="complete"]');
    if (btn) { btn.disabled = true; }
    expertApi('/telehealth/api/v1/appointments/' + encodeURIComponent(openApptId) + '/complete', {
      method: 'PATCH'
    })
    .then(function () {
      toast('Appointment marked as complete', 'success');
      appointmentsCache = null;
      expertPanelsLoaded.appointments = false;
      // Re-fetch to show updated status + progress + lead copy.
      showAppointmentDetail(openApptId);
    })
    .catch(function (err) {
      if (btn) btn.disabled = false;
      toast(err && err.message ? err.message : 'Failed to mark as complete.', 'error');
    });
  }

  function handleCancelAppt() {
    if (!openApptId) return;
    openCancelReasonDialog();
  }

  // ── Appointments (customer-facing) ──────────────────────
  // Live data from the telehealth patient API. Auth reuses the customer JWT via
  // expertApi(); recommended_products (numeric Shopify IDs) resolve against the
  // Storefront catalog loaded by loadAllProductsForRec().
  var APPT_ICON = {
    video: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="14" height="12" rx="2"/><path d="m22 8-6 4 6 4V8z"/></svg>',
    chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg>',
    pill: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10.5 20.5 4 14a4.95 4.95 0 0 1 7-7l6.5 6.5a4.95 4.95 0 0 1-7 7Z"/><path d="m8.5 8.5 7 7"/></svg>',
    doc: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M9 15h6"/><path d="M9 18h4"/></svg>',
    download: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m7 10 5 5 5-5"/><path d="M12 15V3"/></svg>'
  };
  var APPT_MONTHS = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  var apptCache = null;      // normalized appointments (sorted)
  var apptById = {};         // id -> normalized appointment
  var apptLoaded = false;
  var apptLoading = false;

  function apptDateParts(raw) {
    // Prefer the human-readable date ("July 15, 2026"); fall back to the UTC ISO.
    var d = raw.start_date ? new Date(raw.start_date) : null;
    if (!d || isNaN(d.getTime())) d = raw.start_date_utc ? new Date(raw.start_date_utc) : null;
    if (!d || isNaN(d.getTime())) return { mon: '', day: '' };
    return { mon: APPT_MONTHS[d.getMonth()], day: ('0' + d.getDate()).slice(-2) };
  }
  function apptRelLabel(startMs) {
    if (isNaN(startMs)) return '';
    var days = Math.round((startMs - Date.now()) / 86400000);
    if (days < 0) return '';
    if (days === 0) return 'Today';
    if (days === 1) return 'Tomorrow';
    return 'In ' + days + ' days';
  }
  function mapAppt(raw) {
    var exp = raw.expert || {};
    var rx = raw.prescription || {};
    var parts = apptDateParts(raw);
    var statusRaw = String(raw.status || '').toLowerCase();
    var isCancelled = statusRaw === 'cancelled' || statusRaw === 'canceled';
    var isCompleted = statusRaw === 'completed' || statusRaw === 'done';
    // Expert asked staff to cancel — booking is still live, but the patient shouldn't be
    // offered join/reschedule/cancel actions while a cancellation is pending review.
    var isCancelRequested = statusRaw === 'requested_cancellation' ||
      statusRaw === 'cancellation_requested' || statusRaw === 'requested_cancel' ||
      !!(raw.requested_cancellation || raw.cancellation_requested);
    var startMs = raw.start_date_utc ? Date.parse(raw.start_date_utc)
                : (raw.start_date ? Date.parse(raw.start_date) : NaN);
    var isFuture = !isNaN(startMs) && startMs > Date.now();
    var isUpcoming = isFuture && !isCancelled && !isCompleted && !isCancelRequested;
    var meds = (rx.medicines || []).map(function (m) {
      if (typeof m === 'string') return { title: m, dose: '' };
      m = m || {};
      // The expert saves medicines as { medicine_name, dose, frequency, quantity, duration, notes }
      // (see currentPrescriptionPayload / showAppointmentDetail). Keep the legacy aliases
      // too so older records still resolve.
      var title = m.medicine_name || m.name || m.medicine || m.title || m.drug || '';
      // Combine the structured dosing fields into one human-readable line.
      var dose = [
        m.dose || m.dosage || m.strength || '',
        m.frequency || '',
        m.quantity ? 'Qty ' + m.quantity : '',
        m.duration || '',
        m.notes || m.instructions || ''
      ].filter(Boolean).join(' · ');
      return { title: title, dose: dose };
    }).filter(function (m) { return m.title; });
    return {
      id: raw.appointment_id || '',
      doctor: exp.name || (IS_TH ? 'การปรึกษา' : 'Consultation'),
      initials: initialFromName(exp.name),
      specialty: exp.specialization || '',
      mon: parts.mon, day: parts.day,
      dateLong: [raw.start_date, raw.start_time].filter(Boolean).join(', '),
      startMs: startMs, statusRaw: statusRaw,
      isUpcoming: isUpcoming, isCancelled: isCancelled, isCompleted: isCompleted,
      isCancelRequested: isCancelRequested,
      relLabel: isUpcoming ? apptRelLabel(startMs) : '',
      isVideo: !!raw.meeting_link, meetingLink: raw.meeting_link || '',
      rescheduleLink: raw.reschedule_booking_link || '',
      cancelLink: raw.cancel_booking_link || '',
      summary: rx.prescription_note || '',
      // PDF of the doctor's prescription. The backend only fills this in once the consultation
      // is completed and the doctor has generated the document, so it is routinely empty.
      prescriptionReport: rx.prescription_report || raw.prescription_report || '',
      medicines: meds,
      recommendedIds: (rx.recommended_products || []).map(String)
    };
  }
  function apptStatusMeta(a) {
    if (a.isCancelRequested) return { label: (IS_TH ? 'รอการยกเลิก' : 'Cancellation pending'), cls: 'pp-pill-status--pending' };
    if (a.isUpcoming)  return { label: (IS_TH ? 'กำลังจะถึง' : 'Upcoming'),  cls: 'pp-pill-status--upcoming' };
    if (a.isCancelled) return { label: (IS_TH ? 'ยกเลิกแล้ว' : 'Cancelled'), cls: 'pp-pill-status--completed' };
    if (a.isCompleted) return { label: (IS_TH ? 'เสร็จสิ้น' : 'Completed'),  cls: 'pp-pill-status--completed' };
    var s = a.statusRaw ? a.statusRaw.charAt(0).toUpperCase() + a.statusRaw.slice(1) : (IS_TH ? 'นัดหมาย' : 'Scheduled');
    return { label: s, cls: 'pp-pill-status--completed' };
  }

  function renderAppointments(force) {
    if (apptLoaded && !force) return;
    if (apptLoading) return;
    var listWrap = document.getElementById('pp-appt-list-' + sid);
    var nextWrap = document.getElementById('pp-appt-next-' + sid);
    if (!listWrap) return;
    apptLoading = true;
    if (nextWrap) nextWrap.innerHTML = '';
    listWrap.innerHTML = '<div class="pp-loader"><div class="pp-spinner"></div></div>';
    expertApi('/telehealth/api/v1/patient/appointments')
      .then(function (json) {
        var raw = (json && json.data && json.data.appointments) || [];
        apptCache = raw.map(mapAppt).filter(function (a) { return a.id; });
        // Latest first (newest date at the top). The banner picks the soonest
        // upcoming separately in paintAppointments().
        apptCache.sort(function (x, y) { return (y.startMs || 0) - (x.startMs || 0); });
        apptById = {};
        apptCache.forEach(function (a) { apptById[a.id] = a; });
        apptLoaded = true; apptLoading = false;
        paintAppointments();
      })
      .catch(function (err) {
        apptLoading = false;
        console.error('[appointments] load failed:', err);
        var msg = err && err.status === 401
          ? (IS_TH ? 'กรุณาเข้าสู่ระบบอีกครั้งเพื่อดูการนัดหมายของคุณ' : 'Please sign in again to view your appointments.')
          : (IS_TH ? 'ไม่สามารถโหลดการนัดหมายได้ กรุณาลองใหม่ภายหลัง' : 'We couldn’t load your appointments. Please try again later.');
        listWrap.innerHTML = '<div class="pp-appt-empty">' + msg + '</div>';
        // Both tabs read the same payload, so the prescriptions panel has to stop spinning too.
        var rxWrap = document.getElementById('pp-rx-list-' + sid);
        if (rxWrap) rxWrap.innerHTML = '<div class="pp-appt-empty">' + msg + '</div>';
      });
  }

  // ── Telehealth sub-tabs (Appointments / Prescriptions) ──
  // Both views render from the same `apptCache`, so switching never refetches.
  function showTelehealthTab(name) {
    if (name !== 'prescriptions') name = 'appointments';
    root.querySelectorAll('[data-pp-th-tab]').forEach(function (btn) {
      var on = btn.getAttribute('data-pp-th-tab') === name;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    ['appointments', 'prescriptions'].forEach(function (key) {
      var panel = document.getElementById('pp-th-panel-' + key + '-' + sid);
      if (panel) panel.classList.toggle('is-active', key === name);
    });
  }

  // Consultations whose doctor has generated a prescription PDF. The backend only fills
  // `prescription_report` in once the appointment is completed, so this is a strict subset
  // of the appointments list — and empty until the first consultation has happened.
  function apptWithPrescriptions() {
    return apptCache.filter(function (a) { return a.prescriptionReport; });
  }

  function apptRxRowHtml(a) {
    var meta = [a.specialty, a.dateLong].filter(Boolean).join(' · ');
    return '<a class="pp-appt-doc" href="' + escapeHtml(a.prescriptionReport) + '" target="_blank" rel="noopener">' +
        '<span class="pp-appt-doc__ic">' + APPT_ICON.doc + '</span>' +
        '<span class="pp-appt-doc__body">' +
          '<span class="pp-appt-doc__title">' + escapeHtml(a.doctor) + '</span>' +
          '<span class="pp-appt-doc__sub">' + escapeHtml(meta) + '</span>' +
        '</span>' +
        '<span class="pp-appt-doc__dl">' + APPT_ICON.download + '</span>' +
      '</a>';
  }

  function paintPrescriptions() {
    var wrap = document.getElementById('pp-rx-list-' + sid);
    var countEl = document.getElementById('pp-rx-count-' + sid);
    var list = apptWithPrescriptions();
    if (countEl) {
      countEl.textContent = list.length;
      countEl.hidden = list.length === 0;
    }
    if (!wrap) return;
    wrap.innerHTML = list.length
      ? '<div class="pp-rx-list">' + list.map(apptRxRowHtml).join('') + '</div>'
      : '<div class="pp-appt-empty">' +
          (IS_TH
            ? 'ยังไม่มีใบสั่งยา ใบสั่งยาจะแสดงที่นี่หลังจากแพทย์ออกให้เมื่อการปรึกษาเสร็จสิ้น'
            : 'No prescriptions yet. A prescription appears here once your doctor issues one after a completed consultation.') +
        '</div>';
  }

  function paintAppointments() {
    var nextWrap = document.getElementById('pp-appt-next-' + sid);
    var listWrap = document.getElementById('pp-appt-list-' + sid);
    // "Next consultation" = the soonest upcoming appointment, regardless of list order.
    var upcoming = apptCache.filter(function (a) { return a.isUpcoming; })
      .sort(function (x, y) { return (x.startMs || 0) - (y.startMs || 0); })[0];
    if (nextWrap) nextWrap.innerHTML = upcoming ? apptBannerHtml(upcoming) : '';
    if (listWrap) {
      listWrap.innerHTML = apptCache.length
        ? '<div class="pp-appt-list">' + apptCache.map(apptCardHtml).join('') + '</div>'
        : '<div class="pp-appt-empty">' + (IS_TH ? 'คุณยังไม่มีการปรึกษา' : 'You have no consultations yet.') + '</div>';
    }
    paintPrescriptions();
  }

  function apptBannerHtml(a) {
    var joinBtn = (a.isVideo && a.meetingLink)
      ? '<a class="pp-btn pp-btn--accent" href="' + escapeHtml(a.meetingLink) + '" target="_blank" rel="noopener"><span class="pp-appt-next__icon">' + APPT_ICON.video + '</span>' + (IS_TH ? 'เข้าร่วมวิดีโอคอล' : 'Join Video Call') + '</a>'
      : '';
    var reBtn = a.rescheduleLink
      ? '<a class="pp-btn pp-btn--outline" href="' + escapeHtml(a.rescheduleLink) + '" target="_blank" rel="noopener">' + (IS_TH ? 'เลื่อนนัด' : 'Reschedule') + '</a>'
      : '';
    var caBtn = a.cancelLink
      ? '<a class="pp-btn pp-btn--danger" href="' + escapeHtml(a.cancelLink) + '" target="_blank" rel="noopener">' + (IS_TH ? 'ยกเลิก' : 'Cancel') + '</a>'
      : '';
    return '<div class="pp-appt-next">' +
        '<div class="pp-appt-next__deco"></div>' +
        '<div class="pp-appt-next__avatar">' + escapeHtml(a.initials) + '</div>' +
        '<div class="pp-appt-next__info">' +
          '<div class="pp-appt-next__cap">' + (IS_TH ? 'การปรึกษาครั้งถัดไป' : 'Next consultation') + (a.relLabel ? ' · ' + escapeHtml(a.relLabel) : '') + '</div>' +
          '<div class="pp-appt-next__name">' + escapeHtml(a.doctor) + '</div>' +
          '<div class="pp-appt-next__meta">' + escapeHtml([a.specialty, a.dateLong].filter(Boolean).join(' · ')) + '</div>' +
        '</div>' +
        '<div class="pp-appt-next__actions">' + joinBtn + reBtn + caBtn + '</div>' +
      '</div>';
  }

  function apptCardHtml(a) {
    var st = apptStatusMeta(a);
    return '<div class="pp-appt-card" data-pp-appt-id="' + escapeHtml(a.id) + '" role="button" tabindex="0">' +
        '<div class="pp-appt-card__date' + (a.isUpcoming ? ' pp-appt-card__date--upcoming' : '') + '">' +
          '<span class="pp-appt-card__mon">' + escapeHtml(a.mon) + '</span>' +
          '<span class="pp-appt-card__day">' + escapeHtml(a.day) + '</span>' +
        '</div>' +
        '<div class="pp-appt-card__body">' +
          '<div class="pp-appt-card__nm">' +
            '<span class="pp-appt-card__name">' + escapeHtml(a.doctor) + '</span>' +
            '<span class="pp-pill-status ' + st.cls + '">' + escapeHtml(st.label) + '</span>' +
          '</div>' +
          '<div class="pp-appt-card__meta">' + escapeHtml([a.specialty, a.dateLong].filter(Boolean).join(' · ')) + '</div>' +
        '</div>' +
        '<div class="pp-appt-card__end">' +
          (a.isUpcoming && a.isVideo ? '<span class="pp-appt-card__video"><span style="display:inline-flex;width:18px;height:18px">' + APPT_ICON.video + '</span>' + (IS_TH ? 'วิดีโอ' : 'Video') + '</span>' : '') +
          '<span class="pp-appt-card__notes-label">' + (IS_TH ? 'บันทึก' : 'Notes') + '</span>' +
          '<span class="pp-appt-chev">' + APPT_ICON.chev + '</span>' +
        '</div>' +
      '</div>';
  }

  function openApptDetail(id) {
    var a = apptById[id];
    if (!a) return;
    closeApptDetail();

    var rxHtml = a.medicines.length ? (
      '<div class="pp-appt-modal__label">' + (IS_TH ? 'ยาที่สั่งจ่าย' : 'Prescribed') + '</div>' +
      a.medicines.map(function (p) {
        return '<div class="pp-appt-rx"><div><div class="pp-appt-rx__title">' + escapeHtml(p.title) + '</div>' +
          (p.dose ? '<div class="pp-appt-rx__dose">' + escapeHtml(p.dose) + '</div>' : '') + '</div></div>';
      }).join('')
    ) : '';

    var recoHtml = a.recommendedIds.length ? (
      '<div class="pp-appt-modal__label">' + (IS_TH ? 'แนะนำสำหรับคุณ' : 'Recommended for you') + '</div>' +
      '<div id="pp-appt-reco-box-' + sid + '"><div class="pp-loader"><div class="pp-spinner"></div></div></div>'
    ) : '';

    var summaryHtml = a.summary
      ? '<div class="pp-appt-modal__label">' + (IS_TH ? 'สรุป' : 'Summary') + '</div>' +
        '<p class="pp-appt-modal__summary">' + escapeHtml(a.summary) + '</p>'
      : '';

    // The prescription PDF is a record of the consultation too — a modal carrying only the
    // download shouldn't claim nothing was noted.
    var bodyEmpty = !summaryHtml && !rxHtml && !recoHtml && !a.prescriptionReport;

    var wrap = document.createElement('div');
    wrap.id = 'pp-appt-modal-' + sid;
    wrap.className = 'pp-modal-bg';
    wrap.style.display = 'flex';
    wrap.innerHTML =
      '<div class="pp-modal-box">' +
        '<div class="pp-modal-header">' +
          '<div class="pp-appt-modal-hd">' +
            '<div class="pp-appt-modal-hd__avatar">' + escapeHtml(a.initials) + '</div>' +
            '<div><div class="pp-appt-modal-hd__name">' + escapeHtml(a.doctor) + '</div>' +
              '<div class="pp-appt-modal-hd__meta">' + escapeHtml([a.specialty, a.dateLong].filter(Boolean).join(' · ')) + '</div></div>' +
          '</div>' +
          '<button type="button" class="pp-modal-close" data-pp-appt-close aria-label="Close">&#x2715;</button>' +
        '</div>' +
        summaryHtml +
        rxHtml +
        recoHtml +
        (bodyEmpty ? '<p class="pp-appt-modal__summary" style="color:var(--pp-muted)">' + (IS_TH ? 'ไม่มีบันทึกสำหรับการปรึกษาครั้งนี้' : 'No notes recorded for this consultation.') + '</p>' : '') +
        (a.prescriptionReport
          ? '<div class="pp-appt-modal__label">' + (IS_TH ? 'ใบสั่งยา' : 'Prescription') + '</div>' +
            '<a class="pp-appt-doc" href="' + escapeHtml(a.prescriptionReport) + '" target="_blank" rel="noopener">' +
              '<span class="pp-appt-doc__ic">' + APPT_ICON.doc + '</span>' +
              '<span class="pp-appt-doc__body">' +
                '<span class="pp-appt-doc__title">' + (IS_TH ? 'ใบสั่งยา (PDF)' : 'Prescription (PDF)') + '</span>' +
                '<span class="pp-appt-doc__sub">' + (IS_TH ? 'แตะเพื่อเปิดหรือดาวน์โหลด' : 'Tap to open or download') + '</span>' +
              '</span>' +
              '<span class="pp-appt-doc__dl">' + APPT_ICON.download + '</span>' +
            '</a>'
          : '') +
        '<div class="pp-appt-modal__footer">' +
          (a.isUpcoming && a.meetingLink ? '<a class="pp-btn pp-btn--accent" href="' + escapeHtml(a.meetingLink) + '" target="_blank" rel="noopener">' + (IS_TH ? 'เข้าร่วมวิดีโอคอล' : 'Join Video Call') + '</a>' : '') +
          (a.isUpcoming && a.rescheduleLink ? '<a class="pp-btn pp-btn--outline" href="' + escapeHtml(a.rescheduleLink) + '" target="_blank" rel="noopener">' + (IS_TH ? 'เลื่อนนัด' : 'Reschedule') + '</a>' : '') +
          (a.isUpcoming && a.cancelLink ? '<a class="pp-btn pp-btn--danger" href="' + escapeHtml(a.cancelLink) + '" target="_blank" rel="noopener">' + (IS_TH ? 'ยกเลิก' : 'Cancel') + '</a>' : '') +
          '<button type="button" class="pp-btn pp-btn--outline" data-pp-appt-close>' + (IS_TH ? 'ปิด' : 'Close') + '</button>' +
        '</div>' +
      '</div>';
    root.appendChild(wrap);

    wrap.addEventListener('click', function (e) {
      if (e.target === wrap) { closeApptDetail(); return; }
      if (e.target.closest('[data-pp-appt-close]')) { closeApptDetail(); return; }
    });

    // Resolve recommended products lazily; only swap in if this modal is still open.
    // Unlike the doctor-side picker (which browses the whole catalog), this needs the
    // bundle metafields and the buyable variant, so it goes through fetchProductsByIds.
    if (a.recommendedIds.length) {
      var apptIds = [], seenApptId = {};
      a.recommendedIds.forEach(function (rid) {
        var pid = numericProductId(rid);
        if (pid && !seenApptId[pid]) { seenApptId[pid] = true; apptIds.push(pid); }
      });
      fetchProductsByIds(apptIds)
        .then(function (products) {
          var box = document.getElementById('pp-appt-reco-box-' + sid);
          if (!box) return;
          var inStock = buyableOnly(dropTestProducts(products));
          if (!inStock.length) {
            box.innerHTML = '<p class="pp-appt-empty">' + (IS_TH
              ? 'สินค้าที่แนะนำยังไม่พร้อมจำหน่ายในขณะนี้'
              : 'These recommendations aren\u2019t available right now.') + '</p>';
            return;
          }
          // Keyed by appointment so the length the patient picked survives reopening the modal.
          mountBundles(box, [{
            key: 'th-' + bundleKey(a.id),
            label: a.doctor || '',
            dateStr: a.dateLong || '',
            products: inStock
          }]);
        })
        .catch(function (err) {
          console.error('[appointments] recommended products fetch failed:', err);
          var box = document.getElementById('pp-appt-reco-box-' + sid);
          if (box) {
            box.innerHTML = '<p class="pp-appt-empty">' + (IS_TH
              ? 'ไม่สามารถโหลดสินค้าที่แนะนำได้'
              : 'Couldn\u2019t load the recommended products.') + '</p>';
          }
        });
    }
  }
  function closeApptDetail() {
    var wrap = document.getElementById('pp-appt-modal-' + sid);
    if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
  }

  function openCancelReasonDialog() {
    // Reuse the section's .pp-modal-bg styles by appending inside #ProfilePage-*.
    closeCancelReasonDialog(); // Remove any prior instance
    var wrap = document.createElement('div');
    wrap.id = 'ddp-cancel-modal-' + sid;
    wrap.className = 'pp-modal-bg';
    wrap.style.display = 'flex';
    wrap.innerHTML =
      '<div class="pp-modal-box" style="max-width:480px">' +
        '<div class="pp-modal-header">' +
          '<span class="pp-modal-title">Request cancellation</span>' +
          '<button type="button" class="pp-modal-close" data-ddp-cancel-close aria-label="Close">&#x2715;</button>' +
        '</div>' +
        '<p style="font-size:13px;color:var(--pp-muted);margin:0 0 16px;line-height:1.55">' +
          'Experts can’t cancel appointments directly. Submit a reason below and our staff will review and process the cancellation.' +
        '</p>' +
        '<div class="pp-field">' +
          '<label class="pp-label" for="ddp-cancel-reason-' + sid + '">Reason</label>' +
          '<textarea class="pp-input" id="ddp-cancel-reason-' + sid + '" rows="4" placeholder="Explain why this appointment should be cancelled"></textarea>' +
        '</div>' +
        '<div class="pp-error" id="ddp-cancel-err-' + sid + '" style="margin-top:12px"></div>' +
        '<div style="display:flex;gap:10px;margin-top:18px;justify-content:flex-end">' +
          '<button type="button" class="pp-btn--plain" data-ddp-cancel-close>Cancel</button>' +
          '<button type="button" class="pp-btn pp-btn--primary pp-btn--sm" id="ddp-cancel-submit-' + sid + '">Send request</button>' +
        '</div>' +
      '</div>';
    root.appendChild(wrap);

    wrap.addEventListener('click', function (e) {
      if (e.target === wrap) closeCancelReasonDialog();
      if (e.target.closest('[data-ddp-cancel-close]')) closeCancelReasonDialog();
    });
    var submitBtn = document.getElementById('ddp-cancel-submit-' + sid);
    if (submitBtn) submitBtn.addEventListener('click', submitCancelReason);
    var ta = document.getElementById('ddp-cancel-reason-' + sid);
    if (ta) setTimeout(function () { ta.focus(); }, 20);
  }

  function closeCancelReasonDialog() {
    var wrap = document.getElementById('ddp-cancel-modal-' + sid);
    if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
  }

  function submitCancelReason() {
    if (!openApptId) return;
    var ta = document.getElementById('ddp-cancel-reason-' + sid);
    var reason = ta ? ta.value.trim() : '';
    var errEl = document.getElementById('ddp-cancel-err-' + sid);
    if (!reason) {
      if (errEl) { errEl.textContent = 'Please provide a reason.'; errEl.classList.add('pp-show'); }
      return;
    }
    if (errEl) { errEl.textContent = ''; errEl.classList.remove('pp-show'); }
    var btn = document.getElementById('ddp-cancel-submit-' + sid);
    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    expertApi('/telehealth/api/v1/appointments/' + encodeURIComponent(openApptId) + '/cancel-request', {
      method: 'POST',
      body: { reason: reason }
    })
    .then(function () {
      toast('Cancellation request sent to staff for review', 'success');
      appointmentsCache = null;
      expertPanelsLoaded.appointments = false;
      closeCancelReasonDialog();
      // Re-fetch so the UI reflects requested_cancellation immediately.
      showAppointmentDetail(openApptId);
    })
    .catch(function (err) {
      if (errEl) { errEl.textContent = (err && err.message) ? err.message : 'Failed to send cancellation.'; errEl.classList.add('pp-show'); }
      if (btn) { btn.disabled = false; btn.textContent = 'Send request'; }
    });
  }

  function openPatientModal(patientId) {
    if (!patientId) return;
    openPatientId = patientId;
    var bg   = ddpEl('ddp-pt-modal-bg');
    var body = ddpEl('ddp-pt-modal-body');
    if (!bg || !body) return;
    bg.style.display = 'flex';
    body.innerHTML = '<div class="ddp-loader-row">Loading…</div>';
    var eid = currentExpertId();
    expertApi('/telehealth/api/v1/experts/' + encodeURIComponent(eid) + '/patients/' + encodeURIComponent(patientId))
      .then(function (json) {
        var p = (json && json.data && json.data.patient) || null;
        if (!p) throw new Error('Patient not found');
        body.innerHTML = ddpPatientDetailHtml(p);
      })
      .catch(function (err) {
        console.error('[doctors] patient detail failed:', err);
        body.innerHTML = '<div class="ddp-empty">Could not load patient.</div>';
      });
  }

  function closePatientModal() {
    var bg = ddpEl('ddp-pt-modal-bg');
    if (bg) bg.style.display = 'none';
    openPatientId = null;
  }

  function ddpPatientDetailHtml(p) {
    var name = ((p.first_name || '') + ' ' + (p.last_name || '')).trim() || (p.email || '—');
    var apps = p.appointments || [];
    var appsHtml = apps.length
      ? apps.map(function (a) {
          return '<button type="button" class="ddp-sched-row" data-ddp-appt-id="' + ddpEscape(a.id) + '" style="grid-template-columns:1fr auto auto">' +
            '<div class="ddp-pt-meta"><span class="ddp-pt-name">' + ddpEscape(a.start_date || '—') + '</span><span class="ddp-pt-reason">' + ddpEscape((a.start_time || '') + ' · ' + (a.timezone || '')) + '</span></div>' +
            '<span class="ddp-tag ' + ddpStatusTagClass(a.status) + '">' + ddpEscape(ddpStatusLabel(a.status)) + '</span>' +
            '<span class="ddp-chev"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg></span>' +
          '</button>';
        }).join('')
      : '<div class="ddp-empty">No appointments.</div>';
    return (
      '<div style="padding:0 4px">' +
        '<h3 style="margin:0 0 4px;font-size:18px">' + ddpEscape(name) + '</h3>' +
        '<div style="color:#666;font-size:13px;margin-bottom:16px">' + ddpEscape(p.email || '') + (p.phone ? ' · ' + ddpEscape(p.phone) : '') + '</div>' +
        '<div style="background:#F6F2EA;border-radius:12px;padding:14px 16px;margin-bottom:20px;display:flex;gap:24px;flex-wrap:wrap">' +
          '<div><div style="font-size:12px;color:#888;letter-spacing:.06em;text-transform:uppercase">Visits</div><div style="font-weight:600">' + ddpEscape(p.visits != null ? p.visits : 0) + '</div></div>' +
          '<div><div style="font-size:12px;color:#888;letter-spacing:.06em;text-transform:uppercase">Last appointment</div><div style="font-weight:600">' + ddpEscape(p.last_appointment_date || '—') + '</div></div>' +
        '</div>' +
        '<h4 style="margin:0 0 8px;font-size:15px">Appointments</h4>' + appsHtml +
      '</div>'
    );
  }

  function enterDashboard() {
    renderHeroBasics();
    renderAccountView();
    renderAddresses();
    renderMarketingToggle();
    renderStatTiles();
    renderHeroStatus();
    showView('dashboard');
    showTab(tabFromUrl());
  }

  // ── Native app deeplink ─────────────────────────────────
  // Hand the Customer Account API token back to the Vitals mobile app right
  // after auth. Two delivery modes:
  //   • Inside the RN WebView (window.ReactNativeWebView present) → postMessage
  //     the token to the native side. This is the reliable path — custom URL
  //     schemes are frequently blocked inside Android WebViews, so we don't
  //     navigate to vitalsapp:// there. The RN <WebView onMessage> handler
  //     receives { type: 'AUTH_CALLBACK', token, url } and can store the token
  //     directly or call Linking.openURL(url).
  //   • In a normal mobile browser → a TOP-LEVEL navigation to the scheme:
  //     `intent://…` on Android, `vitalsapp://…` on iOS. Both platforms only
  //     launch an app from a main-frame navigation, and the app's own sign-in
  //     sheet (ASWebAuthenticationSession on iOS, a Custom Tab on Android)
  //     recognises its redirect the same way — so this is the hop that closes
  //     the sheet and hands the session over.
  //     Gated to mobile UAs so desktop browsers don't attempt it at all, and on
  //     iOS to a fresh login hand-off — see the branch for why.
  // Fires at most once per token (guarded in sessionStorage) so returning to
  // the profile page in the same session doesn't repeatedly bounce the user
  // into the app.
  var APP_DEEPLINK_BASE = 'vitalsapp://auth/callback';
  var DEEPLINK_SENT_KEY = '_vitals_deeplink_sent_v1';
  var UA = (navigator && navigator.userAgent) || '';
  var IS_ANDROID = /Android/i.test(UA);
  var IS_IOS = /iPhone|iPad|iPod/i.test(UA);
  var IS_MOBILE = IS_ANDROID || IS_IOS;
  // Android package id for the Vitals app. Left empty on purpose: we do NOT
  // want an uninstalled app to redirect anywhere (e.g. the Play Store). The
  // intent below launches the app via the scheme when installed, and falls
  // back to the current page (a no-op) when it isn't.
  var ANDROID_PACKAGE = '';

  // Did the Vitals app start this login? The mobile client calls
  // `/shopify/login?origin=mobile`, so the backend can mark its redirect back
  // here the same way. Treated as a hint, not a requirement — the hand-off also
  // runs on `session_id` alone, which every post-login redirect carries.
  function startedInApp() {
    try {
      var q = new URLSearchParams(window.location.search);
      return q.get('origin') === 'mobile' || q.get('app') === '1';
    } catch (_) { return false; }
  }

  function deliverAuthToApp() {
    try {
      var stored = getStoredToken();
      if (!stored || !stored.token) return;

      // Only deliver once per token.
      try {
        if (sessionStorage.getItem(DEEPLINK_SENT_KEY) === stored.token) return;
      } catch (_) {}

      var sessionId = '';
      try {
        sessionId = new URLSearchParams(window.location.search).get('session_id') || '';
      } catch (_) {}

      var query = 'token=' + encodeURIComponent(stored.token);
      if (sessionId) query += '&vitals_session=' + encodeURIComponent(sessionId);
      var deeplink = APP_DEEPLINK_BASE + '?' + query;
      var bridge = window.ReactNativeWebView;

      if (bridge && typeof bridge.postMessage === 'function') {
        bridge.postMessage(JSON.stringify({
          type: 'AUTH_CALLBACK',
          token: stored.token,
          session_id: sessionId,
          vitals_session: sessionId,
          url: deeplink
        }));
        console.info('[ProfilePage] posted AUTH_CALLBACK to RN bridge', { hasSession: !!sessionId });
      } else if (IS_ANDROID) {
        // Android Chrome ignores custom-scheme navigations from an iframe, so
        // use the intent:// syntax via a top-level navigation — the supported
        // way to launch an app from the browser. If the app is installed it
        // opens (leaving the tab intact). If it isn't, browser_fallback_url
        // keeps the user on the current page instead of redirecting anywhere
        // or showing Chrome's "can't open page" error.
        console.info('[ProfilePage] attempting app deeplink via Android intent');
        var fallbackUrl = window.location.href;
        var intentUrl = 'intent://auth/callback?' + query +
          '#Intent;scheme=vitalsapp;' +
          (ANDROID_PACKAGE ? 'package=' + ANDROID_PACKAGE + ';' : '') +
          'S.browser_fallback_url=' + encodeURIComponent(fallbackUrl) + ';' +
          'end';
        window.location.href = intentUrl;
      } else if (IS_IOS) {
        // iOS honours exactly one hand-off: a MAIN-FRAME navigation to the scheme.
        //
        // The app opens this login in an ASWebAuthenticationSession, which finishes
        // by matching `vitalsapp://` on a top-level navigation. It is never shown a
        // subframe load, and WebKit has not launched apps from an iframe since
        // iOS 9 — so the hidden iframe that used to run here was a silent no-op.
        // The sheet simply sat on this page, `openAuthSessionAsync` never resolved,
        // and no iOS customer could sign in at all.
        //
        // The NSURLErrorDomain -1002 page-blanking the iframe was guarding against
        // only happens in a plain embedded WKWebView — that is the RN WebView, and
        // it takes the `ReactNativeWebView` bridge branch above, never this one.
        //
        // Gated to a fresh login hand-off: `session_id` is only in the URL when the
        // backend OTP flow has just redirected here, which is the one moment there
        // is anything to hand over. On an ordinary profile visit in Safari a
        // visitor without the app would get an "address is invalid" alert for
        // nothing, so leave those navigations alone.
        if (!sessionId && !startedInApp()) {
          console.info('[ProfilePage] skipping deeplink (not a login hand-off)');
          return; // don't mark as sent — a real hand-off still has to deliver it
        }
        console.info('[ProfilePage] attempting app deeplink via top-level navigation');
        window.location.href = deeplink;
      } else {
        console.info('[ProfilePage] skipping deeplink (no RN bridge, non-mobile UA)');
        return; // don't mark as sent — let a real mobile/RN context deliver it
      }

      try { sessionStorage.setItem(DEEPLINK_SENT_KEY, stored.token); } catch (_) {}
    } catch (err) {
      console.warn('[ProfilePage] deliverAuthToApp failed:', err);
    }
  }

  // The one-time login hand-off id. It is only in the URL when the backend OTP
  // flow has just redirected back here, which makes it a dependable "this is a
  // brand-new backend session" signal.
  function loginHandoffId() {
    try { return new URLSearchParams(window.location.search).get('session_id') || ''; } catch (_) { return ''; }
  }

  // Paint the page for whoever `customer` / `expert` currently describe.
  // DOM only — nothing here talks to the network, so it is safe to run against a
  // cache that has not been reconciled with the backend yet.
  function paintSession() {
    if (isWellnessExpert()) { enterExpertDashboard(); return; }
    enterDashboard();
  }

  // Everything that is scoped to a specific identity or role: the app token
  // hand-off, the customer top-up, orders/wellness, and the expert dashboard
  // (which requests /experts/<expert_id>/…). Only ever called once the session
  // behind `customer` / `expert` has been confirmed — firing these against a
  // stale cache is what made the wrong account's data appear, and made the
  // resulting 403s tear down the freshly issued session.
  function startSessionData() {
    var epoch = sessionEpoch;
    sessionVerified = true;
    deliverAuthToApp();
    if (isWellnessExpert()) { renderExpertDashboard(); return; }
    // Eagerly load orders so the tile shows a real count, and wellness so the hero status fills in.
    renderOrders();
    renderWellness();
    topUpCustomer().then(function () {
      if (epoch !== sessionEpoch) return;
      renderHeroBasics();
      renderAccountView();
      renderAddresses();
      renderMarketingToggle();
      renderStatTiles();
    });
  }

  // Paint and load in one go. For paths where the session is already known to be
  // current — a fresh /shopify/profile fetch, or a rebuild after revalidation.
  function enterSession() {
    paintSession();
    startSessionData();
  }

  // Reconcile the optimistic cache paint against the live backend session.
  //
  // sessionStorage survives an account switch that never went through
  // handleLogout() — signing out in another tab, a session the backend expired,
  // or a fresh OTP login layered on top of an old cache — and the cached blob
  // carries no proof of who it belongs to. Booting straight from it therefore
  // shows the previous account's data, and worse, the previous account's *role*:
  // a doctor lands on the customer dashboard, or a patient lands on the expert
  // dashboard whose panels then fail against an expert_id that isn't theirs.
  //
  // So the cache is only ever a fast first paint. This confirms identity and
  // role against /shopify/profile and rebuilds the page if either moved. On a
  // match — the overwhelmingly common case — it re-renders nothing.
  function revalidateSession() {
    var prevId   = customer && customer.id ? String(customer.id) : '';
    var prevRole = expert && expert.role ? String(expert.role).toLowerCase() : '';
    return fetchProfileFromBackend()
      .then(function (result) {
        var nextId   = result.customer && result.customer.id ? String(result.customer.id) : '';
        var nextRole = result.expert && result.expert.role ? String(result.expert.role).toLowerCase() : '';
        if (nextId === prevId && nextRole === prevRole) {
          // Same account, same role. Keep the richer in-memory customer (it may
          // already carry a topUpCustomer() merge) rather than the leaner
          // payload setStoredAuth() just wrote over it.
          if (customer) {
            try { sessionStorage.setItem(STORE_CUSTOMER, JSON.stringify(customer)); } catch (_) {}
          }
          startSessionData();
          return;
        }
        console.warn('[ProfilePage] cached session does not match backend — rebuilding', {
          cachedRole: prevRole || null, backendRole: nextRole || null, identityChanged: nextId !== prevId
        });
        resetSessionState();
        customer = result.customer;
        expert = result.expert || null;
        enterSession();
      })
      .catch(function (err) {
        if (err && (err.status === 401 || err.status === 403)) {
          // The session behind the cache is gone. Never leave the old account's
          // dashboard on screen.
          clearStoredAuth();
          resetSessionState();
          showView('signin');
          return;
        }
        // Transient failure — keep the cached paint rather than blanking a page
        // that is probably correct, and load its data so the dashboard isn't left
        // permanently empty. A real account switch comes back as a 200 with a
        // different id/role, not as a network error, so this does not reopen the
        // stale-role path.
        console.warn('[ProfilePage] session revalidation failed:', err);
        startSessionData();
      });
  }

  function boot() {
    // A login hand-off means the backend just issued a new session, so anything
    // cached here belongs to whoever was signed in before. Drop it before we
    // read it — otherwise the first paint is the previous account.
    if (loginHandoffId()) {
      clearStoredAuth();
      clearSignedOutMark();
    } else if (isMarkedSignedOut()) {
      clearStoredAuth();
      showView('signin');
      return;
    }

    var stored = getStoredToken();
    var cached = getStoredCustomer();
    var cachedExpert = getStoredExpert();
    if (stored && cached) {
      customer = cached;
      expert = cachedExpert;
      // Paint from cache for an instant first frame, but hold every identity- and
      // role-scoped request until revalidateSession() says who this actually is.
      paintSession();
      revalidateSession();
      return;
    }
    // In an app hand-off (RN WebView or mobile browser returning from login) the
    // token that fires the deeplink is the output of this fetch, so the wait is
    // unavoidable — but it should never look like a dead blank page.
    if (window.ReactNativeWebView || IS_MOBILE) {
      setLoadingMsg(IS_TH ? 'กำลังเปิดแอป Vitals…' : 'Opening the Vitals app…');
    }
    showView('loading');
    fetchProfileFromBackend()
      .then(function (result) {
        customer = result.customer;
        expert = result.expert || null;
        enterSession();
      })
      .catch(function (err) {
        if (err && (err.status === 401 || err.status === 403)) { showView('signin'); return; }
        console.error('[profile] could not load profile from backend:', err);
        showView('signin');
      });
  }

  // Clicking Sign in is the user asking to be signed in again, so it lifts the
  // signed-out mark. Waiting for the login hand-off is not enough: a redirect
  // back without ?session_id= would leave the mark set and bounce the user to
  // the sign-in view on every attempt. Matched on href because not every
  // sign-in anchor carries data-pp-login.
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (a && LOGIN_URL && a.href.indexOf(LOGIN_URL.split('?')[0]) === 0) clearSignedOutMark();
  }, true);

  // ── Event wiring ────────────────────────────────────────
  function on(id, ev, fn) {
    var el = document.getElementById(id + '-' + sid);
    if (el) el.addEventListener(ev, fn);
  }

  on('pp-acct-form',          'submit', handleProfileUpdate);
  on('pp-acct-edit',          'click',  openAccountEdit);
  on('pp-acct-cancel',        'click',  closeAccountEdit);
  on('pp-logout-btn',         'click',  handleLogout);
  on('pp-logout-btn-foot',    'click',  handleLogout);
  on('pp-delete-acct',        'click',  openDeleteAccountModal);
  on('pp-mkt-toggle',         'click',  handleMarketingToggle);
  on('pp-addr-add',           'click',  function () { openAddressForm(null); });
  on('pp-addr-form',          'submit', handleAddressSubmit);
  on('pp-addr-cancel',        'click',  closeAddressForm);
  on('pp-wellness-add-btn',   'click',  showWellnessModal);
  on('pp-wb-add-btn',         'click',  showWellnessModal);
  on('pp-wellness-modal-close','click', hideWellnessModal);

  var wlModalBg = document.getElementById('pp-wellness-modal-bg-' + sid);
  if (wlModalBg) wlModalBg.addEventListener('click', function (e) {
    if (e.target === wlModalBg) hideWellnessModal();
  });

  // Patient modal close handlers (appointment view is inline, not a modal)
  on('ddp-pt-modal-close',   'click', closePatientModal);
  var ptModalBg = document.getElementById('ddp-pt-modal-bg-' + sid);
  if (ptModalBg) ptModalBg.addEventListener('click', function (e) {
    if (e.target === ptModalBg) closePatientModal();
  });

  // Delegated: tab buttons (sidebar + hero CTAs) + addresses + chips
  root.addEventListener('click', function (e) {
    var logoutBtn = e.target.closest('[data-ddp-logout]');
    if (logoutBtn) { handleLogout(); return; }
    var expertTab = e.target.closest('[data-ddp-tab]');
    if (expertTab) { showExpertTab(expertTab.getAttribute('data-ddp-tab')); return; }
    var apptRow = e.target.closest('[data-ddp-appt-id]');
    if (apptRow) { showAppointmentDetail(apptRow.getAttribute('data-ddp-appt-id')); return; }
    var patientRow = e.target.closest('[data-ddp-patient-id]');
    if (patientRow) { openPatientModal(patientRow.getAttribute('data-ddp-patient-id')); return; }
    var apptCard = e.target.closest('[data-pp-appt-id]');
    if (apptCard) { openApptDetail(apptCard.getAttribute('data-pp-appt-id')); return; }
    var thTab = e.target.closest('[data-pp-th-tab]');
    if (thTab) { showTelehealthTab(thTab.getAttribute('data-pp-th-tab')); return; }
    var target = e.target.closest('[data-pp-tab]');
    if (target) { showTab(target.dataset.ppTab); return; }
    var editAddr = e.target.closest('[data-pp-addr-edit]');
    if (editAddr) {
      var id = editAddr.dataset.ppAddrEdit;
      var addr = (customer.addresses || []).filter(function (a) { return a.id === id; })[0];
      if (addr) openAddressForm(addr);
      return;
    }
    var delAddr = e.target.closest('[data-pp-addr-del]');
    if (delAddr) { handleAddressDelete(delAddr.dataset.ppAddrDel); return; }
    var defAddr = e.target.closest('[data-pp-addr-default]');
    if (defAddr) { handleAddressSetDefault(defAddr.dataset.ppAddrDefault); return; }
    var chip = e.target.closest('[data-pp-orders-filter]');
    if (chip) {
      ordersFilter = chip.dataset.ppOrdersFilter;
      root.querySelectorAll('[data-pp-orders-filter]').forEach(function (c) {
        c.classList.toggle('is-active', c === chip);
      });
      renderOrdersList();
      return;
    }
    var reorderBtn = e.target.closest('[data-pp-order-reorder]');
    if (reorderBtn && !reorderBtn.disabled) {
      handleOrderReorder(parseInt(reorderBtn.dataset.ppOrderReorder, 10), reorderBtn);
      return;
    }
    var bookBtn = e.target.closest('[data-pp-order-booking]');
    if (bookBtn && !bookBtn.disabled) {
      var bookOrder = ordersCache && ordersCache[parseInt(bookBtn.dataset.ppOrderBooking, 10)];
      if (bookOrder) window.location.href = bookingUrl(bookOrder);
      return;
    }
    var trackBtn = e.target.closest('[data-pp-order-track]');
    if (trackBtn && !trackBtn.disabled) {
      var trackOrder = ordersCache && ordersCache[parseInt(trackBtn.dataset.ppOrderTrack, 10)];
      var trackUrl = trackOrder && trackOrder.statusPageUrl;
      if (trackUrl) {
        window.open(trackUrl, '_blank', 'noopener');
      } else {
        toast(IS_TH ? 'ยังไม่มีข้อมูลการติดตาม' : 'Tracking is not available yet.', 'error');
      }
      return;
    }
    var recAdd = e.target.closest('.pp-rec-card__add[data-vid]');
    if (recAdd && !recAdd.disabled) { handleAddToCart(recAdd); return; }
  });

  boot();
  }
  var roots = document.querySelectorAll('[data-pp-sid]');
  for (var i = 0; i < roots.length; i++) initProfilePage(roots[i]);
})();
